require.config({
    paths: {
        'sdk': uiBuilderSDKPath + '/sdk',
    }
});

define(['sdk'], BackendlessUI => BackendlessUI.startApp());

define('./functions/2f8acdfa5516fd9bc5a77798638e56c9/code.js', () => { 

BackendlessUI.Functions.Custom['fn_2f8acdfa5516fd9bc5a77798638e56c9'] = function fn_2f8acdfa5516fd9bc5a77798638e56c9(DataOffset, ContactNumber) {
var Divisor;


  Divisor = DataOffset;
  if (ContactNumber == 0) {
    return 1;
  } else if (ContactNumber < 1) {
    return 1;
  } else if (ContactNumber > 0 && ContactNumber <= Divisor) {
    return (Math.ceil(ContactNumber / Divisor) + 1);
  } else if (ContactNumber > Divisor) {
    return (Math.ceil(ContactNumber / Divisor) + 1);
  }

return 
}

})
define('./functions/3c63f785d9e228fa06daef03784c9291/code.js', () => { 

BackendlessUI.Functions.Custom['fn_3c63f785d9e228fa06daef03784c9291'] = function fn_3c63f785d9e228fa06daef03784c9291() {
return 
}

})
define('./functions/7fe9b466a35d8f360574274ddddb76f4/code.js', () => { 

BackendlessUI.Functions.Custom['fn_7fe9b466a35d8f360574274ddddb76f4'] = async function fn_7fe9b466a35d8f360574274ddddb76f4(token) {
var NewToken, currentUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (token != null) {
    NewToken = (getObjectProperty((await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://mgr.pockethost.io/api/collections/users/auth-refresh')).set(({ [`Authorization`]: token })).setEncoding('utf8').send()), 'record'));
  } else {
    return false;
  }

return NewToken
}

})
define('./functions/b4791a6b9303120116dfb5053d72713e/code.js', () => { 

BackendlessUI.Functions.Custom['fn_b4791a6b9303120116dfb5053d72713e'] = function fn_b4791a6b9303120116dfb5053d72713e() {
return 
}

})
define('./functions/fb29ed716ee40c6ec05a6af2fb62b61d/code.js', () => { 

BackendlessUI.Functions.Custom['fn_fb29ed716ee40c6ec05a6af2fb62b61d'] = async function fn_fb29ed716ee40c6ec05a6af2fb62b61d(token) {
var currentUser;


  if (token != null) {
    currentUser = (await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://mgr.pockethost.io/api/collections/users/auth-refresh')).set(({ [`Authorization`]: token })).setEncoding('utf8').send());
  } else {
    return false;
  }

return currentUser
}

})
define('./pages/404/components/902c9641de4ec9e73427e7192a118d14/bundle.js', [], () => ({
  /* content */

  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('', null);

  },  
/* handler:onClick *//* content */
}));

define('./pages/5-10-b1_Home/components/ab288c9ed0e835b89a08e4b88e03dc16/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOUserToken'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/5-10-b1_Home/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var currentUser, retrievedContactsRawResponse, storedTokenFromCookie;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['RetrievedContactsRawResponse'] = ({  });
  ___arguments.context.pageData['OpenDrawer'] = false;
  ___arguments.context.pageData['DisplayingContactsPageNumber'] = 0;
  storedTokenFromCookie = ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOUserToken'));
  currentUser = (await BackendlessUI.Functions.Custom['fn_fb29ed716ee40c6ec05a6af2fb62b61d'](storedTokenFromCookie));
  if (currentUser != false) {
    ___arguments.context.appData['currentUser'] = currentUser;
    retrievedContactsRawResponse = (await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://mgr.pockethost.io/api/collections/ACCOContacts/records?perPage=25&sort=+LastName,FirstName')).set(({ [`Authorization`]: ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOContactsToken')) })).setEncoding('utf8').send());
    ___arguments.context.pageData['pageCursor'] = 0;
    ___arguments.context.pageData['page'] = (getObjectProperty(retrievedContactsRawResponse, 'page'));
    ___arguments.context.pageData['perPage'] = (getObjectProperty(retrievedContactsRawResponse, 'perPage'));
    ___arguments.context.pageData['totalItems'] = (getObjectProperty(retrievedContactsRawResponse, 'totalItems'));
    ___arguments.context.pageData['totalPages'] = (getObjectProperty(retrievedContactsRawResponse, 'totalPages'));
    console.log('RetrievedContactsRawResponse:');
    console.log(retrievedContactsRawResponse);
    ___arguments.context.pageData['RetrievedContacts'] = (getObjectProperty(retrievedContactsRawResponse, 'items'));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', (getObjectProperty(___arguments.context.pageData, 'RetrievedContacts')));
    console.log(currentUser);
    ___arguments.context.pageData['DisplayingContactsMessage'] = (['Contact: ',(Number((getObjectProperty(___arguments.context.pageData, 'page')))) * (Number((getObjectProperty(___arguments.context.pageData, 'perPage')))),' | Page: ',(getObjectProperty(___arguments.context.pageData, 'page')),' (',(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8'))[0]), 'LastName')),' To ',(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8')).slice(-1)[0]), 'LastName')),') | Total Pages: ',(getObjectProperty(___arguments.context.pageData, 'totalPages')),' | Total Contacts: ',(getObjectProperty(___arguments.context.pageData, 'totalItems'))].join(''));
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('UserLogin', undefined);
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/5-10-b1_Home/components/54081436bb6842a82788d1d8c2a7dbc1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(getObjectProperty(___arguments.context.appData, 'currentUser'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/5-10-b1_Home/components/e65831ef35789938da8896bca018c4e8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      localStorage.removeItem('ACCOUserToken');
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('UserLogin', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/5-10-b1_Home/components/cb980528d6cebac8f0984878c8985798/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(getObjectProperty(___arguments.context.pageData, 'RetrievedContacts'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/5-10-b1_Home/components/26c848494068ad8874b4b73208376878/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await (async function(TextToCopy) {
  	navigator.clipboard.writeText(TextToCopy);
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5e3f583561b818f8a1786ac80fa77ec8'), 'BusinessPhone')));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9954b1e8ff38cc68d3f769a8c488aa1c'))['color'] = '#A00000';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9954b1e8ff38cc68d3f769a8c488aa1c'))['text-decoration-line'] = 'underline';
  await new Promise(r => setTimeout(r, 400 || 0));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9954b1e8ff38cc68d3f769a8c488aa1c'))['color'] = '#000000';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9954b1e8ff38cc68d3f769a8c488aa1c'))['text-decoration-line'] = 'none';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/5-10-b1_Home/components/8c26d238ec58efa916980c5156989ff8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('14160948a388f4c82618c6e80fc67fec');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/5-10-b1_Home/components/9f18306e287839f6b688b2785af8c8ec/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var decision, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'isContactSelected')) == true) {
    console.log(await asyncListFilter(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8')), async (item) => {
       if ((getObjectProperty(item, 'CurrentlySelectedContact')) == true) {
        delete item['CurrentlySelectedContact'];
        decision = true;
      } else {
        decision = true;
      }


     return ;
    }));
  }
  ___arguments.context.pageData['OpenDrawer'] = false;
  ___arguments.context.pageData['CurrentlySelectedContact'] = false;
  ___arguments.context.pageData['CurrentlySelectedContactObjectID'] = '';
  ___arguments.context.pageData['isContactSelected'] = false;
  await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('d5e8e785986ad5d8c618fb16527f9038', undefined);
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bb85878828193def9f8054853f8949b'))['min-height'] = '100%';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/5-10-b1_Home/components/34b170cf59982968ddc866980023ca7f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var decision, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'isContactSelected')) == true) {
    console.log(await asyncListFilter(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8')), async (item) => {
       if ((getObjectProperty(item, 'CurrentlySelectedContact')) == true) {
        delete item['CurrentlySelectedContact'];
        decision = true;
      } else {
        decision = true;
      }


     return decision;
    }));
    ___arguments.context.pageData['AddScrollDelay'] = false;
  } else {
    ___arguments.context.pageData['AddScrollDelay'] = true;
  }
  ___arguments.context.pageData['OpenDrawer'] = true;
  ___arguments.context.pageData['CurrentlySelectedContact'] = true;
  ___arguments.context.pageData['isContactSelected'] = true;
  ___arguments.context.getComponentDataStoreByUid('f548849959d80918247fdbdd7f982de8')['CurrentlySelectedContact'] = true;
  ___arguments.context.pageData['CurrentlySelectedContactID'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f548849959d80918247fdbdd7f982de8'), 'id'));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bb85878828193def9f8054853f8949b'))['min-height'] = '125%';
  if ((getObjectProperty(___arguments.context.pageData, 'AddScrollDelay')) == true) {
    await new Promise(r => setTimeout(r, 300 || 0));
  }
  (function (component) { component.el.scrollIntoView() })((getObjectProperty(___arguments.context.pageData, (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f548849959d80918247fdbdd7f982de8'), 'id')))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/5-10-b1_Home/components/d5e8e785986ad5d8c618fb16527f9038/bundle.js', [], () => ({
  /* content */
  /* handler:isOpenLogic */
  ['isOpenLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'OpenDrawer'))

  },
  /* handler:isOpenLogic */
  /* handler:onClose */
  async ['onClose'](___arguments) {
    var decision, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  ___arguments.context.pageData['OpenDrawer'] = false;
  if ((getObjectProperty(___arguments.context.pageData, 'isContactSelected')) == true) {
    console.log(await asyncListFilter(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8')), async (item) => {
       if ((getObjectProperty(item, 'CurrentlySelectedContact')) == true) {
        delete item['CurrentlySelectedContact'];
        decision = true;
      } else {
        decision = true;
      }


     return ;
    }));
  }
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bb85878828193def9f8054853f8949b'))['min-height'] = '100%';
  ___arguments.context.pageData['isContactSelected'] = false;

  },
  /* handler:onClose */
  /* content */
}))

define('./pages/5-10-b1_Home/components/715ffae88be9507ff0b894488f3f2571/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f548849959d80918247fdbdd7f982de8'), 'CurrentlySelectedContact')) == true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f548849959d80918247fdbdd7f982de8'))['background-color'] = '#990939';
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f548849959d80918247fdbdd7f982de8'))['background-color'] = '#016288';
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/5-10-b1_Home/components/f548849959d80918247fdbdd7f982de8/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData[(getObjectProperty(___arguments.context.dataModel, 'id'))] = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f548849959d80918247fdbdd7f982de8'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/5-10-b1_Home/components/c4e88a1ec9685fd8d8c459588a08e548/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f548849959d80918247fdbdd7f982de8'), 'EmailAddress')) != '') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c4e88a1ec9685fd8d8c459588a08e548'))['color'] = '#FFFFFF';
  }

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f548849959d80918247fdbdd7f982de8'), 'EmailAddress')) != '') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c4e88a1ec9685fd8d8c459588a08e548'))['color'] = '#B4B4B4';
  }

  },
  /* handler:onMouseOut */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('3d1800088b7fe3386f380083d4e8b13d')), 'text')) != '') {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/5-10-b1_Home/components/9a38cdb1fe6889b8853c0d7891b8ca88/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var response, DBSearchTerm, retrievedContacts;

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setTimeouts'); if (timerId && timers[timerId]) {    clearTimeout(timers[timerId]);    delete timers[timerId]; }}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setTimeouts'); const timer = setTimeout(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function Search_Contacts() {
  if ((getObjectProperty(___arguments.context.pageData, 'TOGGLE_IncludeCompany')) == true) {
    retrievedContacts = (getObjectProperty((await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((['https://mgr.pockethost.io/api/collections/ACCOContacts/records?perPage=50&sort=+LastName,FirstName&filter=(','LastName~\'',___arguments.value,'\' || FirstName~\'',___arguments.value,'\' || Company~\'',___arguments.value,'\')'].join('')))).set(({ [`Authorization`]: ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOContactsToken')) })).setEncoding('utf8').send()), 'items'));
    ___arguments.context.pageData['RetrievedContacts'] = retrievedContacts;
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9048e37ecae67908d8bd408823dce8d8'))['background-color'] = '#A00000';
    ___arguments.context.pageData['MAKEITWHITE'] = true;
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ee68b608a0ec67383ffecb48626858c8'))['color'] = '#FFFFFF';
  } else {
    retrievedContacts = (getObjectProperty((await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((['https://mgr.pockethost.io/api/collections/ACCOContacts/records?perPage=50&sort=+LastName,FirstName&filter=(','LastName~\'',___arguments.value,'\' || FirstName~\'',___arguments.value,'\')'].join('')))).set(({ [`Authorization`]: ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOContactsToken')) })).setEncoding('utf8').send()), 'items'));
  }
  return retrievedContacts
}

/**
 * Describe this function...
 */
async function Reset_Search() {
  retrievedContacts = (getObjectProperty((await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((String('https://mgr.pockethost.io/api/collections/ACCOContacts/records?perPage=25&sort=+LastName,FirstName')))).set(({ [`Authorization`]: ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOContactsToken')) })).setEncoding('utf8').send()), 'items'));
  ___arguments.context.pageData['RetrievedContacts'] = retrievedContacts;
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9048e37ecae67908d8bd408823dce8d8'))['background-color'] = '#F5F5F5';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9a38cdb1fe6889b8853c0d7891b8ca88'))['color'] = '#000000';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ee68b608a0ec67383ffecb48626858c8'))['color'] = '#AD0505';
  ___arguments.context.pageData['MAKEITWHITE'] = false;
  ___arguments.context.appData['ForceSearch'] = false;
  return retrievedContacts
}


  stopSetTimeout('lazySearch');

  ;(function() {
    const callback = async () => {
        DBSearchTerm = ___arguments.value;
    ___arguments.context.pageData['DBSearchTerm'] = DBSearchTerm;
    response = await Search_Contacts();
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', ({  }));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', response);
    ___arguments.context.appData['ForceSearch'] = true;

    };

    const timerId = 'lazySearch';
    const timerDelay = 1000;

    runSetTimeout(timerId, callback, timerDelay)
  })()
  if (___arguments.value == '') {
    response = await Search_Contacts();
    response = await Reset_Search();
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', ({  }));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', response);
    ___arguments.context.appData['ForceSearch'] = false;
    ___arguments.context.pageData['DBSearchTerm'] = '';
  } else {
    response = await Search_Contacts();
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', ({  }));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', response);
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9048e37ecae67908d8bd408823dce8d8'))['background-color'] = '#A00000';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9a38cdb1fe6889b8853c0d7891b8ca88'))['color'] = '#FFFFFF';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ee68b608a0ec67383ffecb48626858c8'))['color'] = '#FFFFFF';
    ___arguments.context.pageData['MAKEITWHITE'] = true;
    ___arguments.context.appData['ForceSearch'] = true;
  }
  if (getValueLength(___arguments.value) == 0) {
    ___arguments.context.pageData['DBSearchTerm'] = '';
    stopSetTimeout('lazySearch');
  }

  },
  /* handler:onChange */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    var classList;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'MAKEITWHITE')) == true) {
    classList = ['input-white'];
  } else {
    classList = ['input-black'];
  }
  return classList;

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/5-10-b1_Home/components/ee68b608a0ec67383ffecb48626858c8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var retrievedContacts;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setTimeouts'); if (timerId && timers[timerId]) {    clearTimeout(timers[timerId]);    delete timers[timerId]; }}

/**
 * Describe this function...
 */
async function Reset_Search() {
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', ({  }));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', (getObjectProperty((await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((String('https://mgr.pockethost.io/api/collections/ACCOContacts/records?perPage=25&sort=+LastName,FirstName')))).set(({ [`Authorization`]: ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOContactsToken')) })).setEncoding('utf8').send()), 'items')));
  ___arguments.context.pageData['RetrievedContacts'] = retrievedContacts;
}


  await Reset_Search();
  ___arguments.context.pageData['DBSearchTerm'] = '';
  ___arguments.context.pageData['value'] = '';
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('9a38cdb1fe6889b8853c0d7891b8ca88'))['value'] = '';
  ___arguments.context.pageData['ForceSearch'] = false;
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9048e37ecae67908d8bd408823dce8d8'))['background-color'] = '#F5F5F5';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ee68b608a0ec67383ffecb48626858c8'))['color'] = '#AD0505';
  ___arguments.context.pageData['MAKEITWHITE'] = false;
  ___arguments.context.pageData['MAKEITBLACK'] = (!(getObjectProperty(___arguments.context.pageData, 'MAKEITWHITE')));
  stopSetTimeout('lazySearch');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/5-10-b1_Home/components/3a4106331cb86b6899de7db685e6a9f2/bundle.js', [], () => ({
  /* content */
  /* handler:onDelete */
  ['onDelete'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'PageFilter')) == 'Created') {
    ___arguments.context.pageData['PageFilter'] = '';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3a4106331cb86b6899de7db685e6a9f2'))['background-color'] = '#016288';
  }

  },
  /* handler:onDelete */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'PageFilter')) != 'Created') {
    ___arguments.context.pageData['PageFilter'] = 'Created';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3a4106331cb86b6899de7db685e6a9f2'))['background-color'] = '#A00000';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('86684ec8198c47f8c1a80e08638823b6'))['background-color'] = '#016288';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('50d8bec85069e1ce0198f5e8c4670bd8'))['background-color'] = '#016288';
  } else {
    ___arguments.context.pageData['CreatedDirectionDown'] = (!(getObjectProperty(___arguments.context.pageData, 'CreatedDirectionDown')));
    await (async function() {
    	const icon = document.querySelector('.created-chip-class i')

    	if (icon.innerHTML === 'arrow_circle_up') {
    	    icon.innerHTML = 'arrow_circle_down'
    	 } else {
    	    icon.innerHTML = 'arrow_circle_up'
    	 }
    })();
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/5-10-b1_Home/components/86684ec8198c47f8c1a80e08638823b6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'PageFilter')) != 'Viewed') {
    ___arguments.context.pageData['PageFilter'] = 'Viewed';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3a4106331cb86b6899de7db685e6a9f2'))['background-color'] = '#016288';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('86684ec8198c47f8c1a80e08638823b6'))['background-color'] = '#A00000';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('50d8bec85069e1ce0198f5e8c4670bd8'))['background-color'] = '#016288';
  } else {
    ___arguments.context.pageData['ViewedDirectionDown'] = (!(getObjectProperty(___arguments.context.pageData, 'ViewedDirectionDown')));
    await (async function() {
    	const icon = document.querySelector('.viewed-chip-class i')

    	if (icon.innerHTML === 'arrow_circle_up') {
    	    icon.innerHTML = 'arrow_circle_down'
    	 } else {
    	    icon.innerHTML = 'arrow_circle_up'
    	 }
    })();
  }

  },
  /* handler:onClick */
  /* handler:onDelete */
  ['onDelete'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'PageFilter')) == 'Viewed') {
    ___arguments.context.pageData['PageFilter'] = '';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('86684ec8198c47f8c1a80e08638823b6'))['background-color'] = '#016288';
  }

  },
  /* handler:onDelete */
  /* content */
}))

define('./pages/5-10-b1_Home/components/50d8bec85069e1ce0198f5e8c4670bd8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'PageFilter')) != 'Modified') {
    ___arguments.context.pageData['PageFilter'] = 'Modified';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3a4106331cb86b6899de7db685e6a9f2'))['background-color'] = '#016288';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('86684ec8198c47f8c1a80e08638823b6'))['background-color'] = '#016288';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('50d8bec85069e1ce0198f5e8c4670bd8'))['background-color'] = '#A00000';
  } else {
    ___arguments.context.pageData['ModifiedDirectionDown'] = (!(getObjectProperty(___arguments.context.pageData, 'ModifiedDirectionDown')));
    await (async function() {
    	const icon = document.querySelector('.modified-chip-class i')

    	if (icon.innerHTML === 'arrow_circle_up') {
    	    icon.innerHTML = 'arrow_circle_down'
    	 } else {
    	    icon.innerHTML = 'arrow_circle_up'
    	 }
    })();
  }

  },
  /* handler:onClick */
  /* handler:onDelete */
  ['onDelete'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'PageFilter')) == 'Modified') {
    ___arguments.context.pageData['PageFilter'] = '';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('50d8bec85069e1ce0198f5e8c4670bd8'))['background-color'] = '#016288';
  }

  },
  /* handler:onDelete */
  /* content */
}))

define('./pages/5-10-b1_Home/components/c8486c55ffb833b1731c386d281e1628/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var retrievedContacts, results;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function Search_Contacts() {
  if ((getObjectProperty(___arguments.context.pageData, 'TOGGLE_IncludeCompany')) == true) {
    retrievedContacts = (getObjectProperty((await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((['https://mgr.pockethost.io/api/collections/ACCOContacts/records?perPage=50&sort=+LastName,FirstName&filter=(','LastName~\'',(getObjectProperty(___arguments.context.pageData, 'DBSearchTerm')),'\' || FirstName~\'',(getObjectProperty(___arguments.context.pageData, 'DBSearchTerm')),'\' || Company~\'',(getObjectProperty(___arguments.context.pageData, 'DBSearchTerm')),'\')'].join('')))).set(({ [`Authorization`]: ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOContactsToken')) })).setEncoding('utf8').send()), 'items'));
  } else {
    retrievedContacts = (getObjectProperty((await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((['https://mgr.pockethost.io/api/collections/ACCOContacts/records?perPage=50&sort=+LastName,FirstName&filter=(','LastName~\'',(getObjectProperty(___arguments.context.pageData, 'DBSearchTerm')),'\' || FirstName~\'',(getObjectProperty(___arguments.context.pageData, 'DBSearchTerm')),'\')'].join('')))).set(({ [`Authorization`]: ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOContactsToken')) })).setEncoding('utf8').send()), 'items'));
  }
  return retrievedContacts
}


  if (___arguments.value == true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a1a8e4d209da625868a898e85398323e'))['color'] = '#990000';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a1a8e4d209da625868a898e85398323e'))['font-weight'] = 'bold';
    ___arguments.context.pageData['TOGGLE_IncludeCompany'] = true;
    results = await Search_Contacts();
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a1a8e4d209da625868a898e85398323e'))['color'] = '#000000';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a1a8e4d209da625868a898e85398323e'))['font-weight'] = 'normal';
    ___arguments.context.pageData['TOGGLE_IncludeCompany'] = false;
    results = await Search_Contacts();
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', results);

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/5-10-b1_Home/components/96b815b891276784d638d95fab3833cd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var currentUser, retrievedContactsRawResponse, CurrentPageNumber;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  CurrentPageNumber = 0;
  ___arguments.context.pageData['pageCurser'] = 1;
  if (currentUser != false) {
    retrievedContactsRawResponse = (await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((String('https://mgr.pockethost.io/api/collections/ACCOContacts/records?perPage=25&sort=+LastName,FirstName&page=') + String(JSON.stringify((getObjectProperty(___arguments.context.pageData, 'pageCurser'))))))).set(({ [`Authorization`]: ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOContactsToken')) })).setEncoding('utf8').send());
    ___arguments.context.pageData['page'] = (getObjectProperty(retrievedContactsRawResponse, 'page'));
    ___arguments.context.pageData['perPage'] = (getObjectProperty(retrievedContactsRawResponse, 'perPage'));
    ___arguments.context.pageData['totalItems'] = (getObjectProperty(retrievedContactsRawResponse, 'totalItems'));
    ___arguments.context.pageData['totalPages'] = (getObjectProperty(retrievedContactsRawResponse, 'totalPages'));
    console.log('RetrievedContactsRawResponse:');
    console.log(retrievedContactsRawResponse);
    ___arguments.context.pageData['RetrievedContacts'] = (getObjectProperty(retrievedContactsRawResponse, 'items'));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', ({  }));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', (getObjectProperty(___arguments.context.pageData, 'RetrievedContacts')));
    ___arguments.context.pageData['DisplayingContactsMessage'] = (['Contact: ',(Number((getObjectProperty(___arguments.context.pageData, 'page')))) * (Number((getObjectProperty(___arguments.context.pageData, 'perPage')))),' | Page: ',(getObjectProperty(___arguments.context.pageData, 'page')),' (',(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8'))[0]), 'LastName')),' To ',(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8')).slice(-1)[0]), 'LastName')),') | Total Pages: ',(getObjectProperty(___arguments.context.pageData, 'totalPages')),' | Total Contacts: ',(getObjectProperty(___arguments.context.pageData, 'totalItems'))].join(''));
    console.log(currentUser);
    ___arguments.context.appData['currentUser'] = currentUser;
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('UserLogin', undefined);
  }
  ___arguments.context.pageData['DisplayingContactsMessage'] = (['Contact: ',(Number((getObjectProperty(___arguments.context.pageData, 'page')))) * (Number((getObjectProperty(___arguments.context.pageData, 'perPage')))),' | Page: ',(getObjectProperty(___arguments.context.pageData, 'page')),' (',(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8'))[0]), 'LastName')),' To ',(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8')).slice(-1)[0]), 'LastName')),') | Total Pages: ',(getObjectProperty(___arguments.context.pageData, 'totalPages')),' | Total Contacts: ',(getObjectProperty(___arguments.context.pageData, 'totalItems'))].join(''));

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'page')) == 1) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('96b815b891276784d638d95fab3833cd'))['background-color'] = '#9A91A6';
    return true;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('96b815b891276784d638d95fab3833cd'))['background-color'] = '#0A0A0A';
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/5-10-b1_Home/components/f1542a58df082559e03864f8db487678/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var currentUser, retrievedContactsRawResponse, ContactsCountReturn, CurrentPageNumber;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['pageCurser'] = ((Number((getObjectProperty(___arguments.context.pageData, 'page')))) - 10);
  if (currentUser != false) {
    retrievedContactsRawResponse = (await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((String('https://mgr.pockethost.io/api/collections/ACCOContacts/records?perPage=25&sort=+LastName,FirstName&page=') + String(JSON.stringify((getObjectProperty(___arguments.context.pageData, 'pageCurser'))))))).set(({ [`Authorization`]: ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOContactsToken')) })).setEncoding('utf8').send());
    ___arguments.context.pageData['page'] = (getObjectProperty(retrievedContactsRawResponse, 'page'));
    ___arguments.context.pageData['perPage'] = (getObjectProperty(retrievedContactsRawResponse, 'perPage'));
    ___arguments.context.pageData['totalItems'] = (getObjectProperty(retrievedContactsRawResponse, 'totalItems'));
    ___arguments.context.pageData['totalPages'] = (getObjectProperty(retrievedContactsRawResponse, 'totalPages'));
    console.log('RetrievedContactsRawResponse:');
    console.log(retrievedContactsRawResponse);
    ___arguments.context.pageData['RetrievedContacts'] = (getObjectProperty(retrievedContactsRawResponse, 'items'));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', ({  }));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', (getObjectProperty(___arguments.context.pageData, 'RetrievedContacts')));
    ___arguments.context.pageData['DisplayingContactsMessage'] = (['Contact: ',(Number((getObjectProperty(___arguments.context.pageData, 'page')))) * (Number((getObjectProperty(___arguments.context.pageData, 'perPage')))),' | Page: ',(getObjectProperty(___arguments.context.pageData, 'page')),' (',(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8'))[0]), 'LastName')),' To ',(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8')).slice(-1)[0]), 'LastName')),') | Total Pages: ',(getObjectProperty(___arguments.context.pageData, 'totalPages')),' | Total Contacts: ',(getObjectProperty(___arguments.context.pageData, 'totalItems'))].join(''));
    console.log(currentUser);
    ___arguments.context.appData['currentUser'] = currentUser;
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('UserLogin', undefined);
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'page')) <= 10) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f1542a58df082559e03864f8db487678'))['background-color'] = '#9A91A6';
    return true;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f1542a58df082559e03864f8db487678'))['background-color'] = '#0A0A0A';
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/5-10-b1_Home/components/8df8d2e2bef1ae08efcc44611b5882f1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var currentUser, retrievedContactsRawResponse, ContactsCountReturn, CurrentPageNumber;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['pageCurser'] = ((Number((getObjectProperty(___arguments.context.pageData, 'page')))) + 1);
  if (currentUser != false) {
    retrievedContactsRawResponse = (await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((String('https://mgr.pockethost.io/api/collections/ACCOContacts/records?perPage=25&sort=+LastName,FirstName&page=') + String(JSON.stringify((getObjectProperty(___arguments.context.pageData, 'pageCurser'))))))).set(({ [`Authorization`]: ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOContactsToken')) })).setEncoding('utf8').send());
    ___arguments.context.pageData['page'] = (getObjectProperty(retrievedContactsRawResponse, 'page'));
    ___arguments.context.pageData['perPage'] = (getObjectProperty(retrievedContactsRawResponse, 'perPage'));
    ___arguments.context.pageData['totalItems'] = (getObjectProperty(retrievedContactsRawResponse, 'totalItems'));
    ___arguments.context.pageData['totalPages'] = (getObjectProperty(retrievedContactsRawResponse, 'totalPages'));
    console.log('RetrievedContactsRawResponse:');
    console.log(retrievedContactsRawResponse);
    ___arguments.context.pageData['RetrievedContacts'] = (getObjectProperty(retrievedContactsRawResponse, 'items'));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', ({  }));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', (getObjectProperty(___arguments.context.pageData, 'RetrievedContacts')));
    ___arguments.context.pageData['DisplayingContactsMessage'] = (['Contact: ',(Number((getObjectProperty(___arguments.context.pageData, 'page')))) * (Number((getObjectProperty(___arguments.context.pageData, 'perPage')))),' | Page: ',(getObjectProperty(___arguments.context.pageData, 'page')),' (',(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8'))[0]), 'LastName')),' To ',(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8')).slice(-1)[0]), 'LastName')),') | Total Pages: ',(getObjectProperty(___arguments.context.pageData, 'totalPages')),' | Total Contacts: ',(getObjectProperty(___arguments.context.pageData, 'totalItems'))].join(''));
    console.log(currentUser);
    ___arguments.context.appData['currentUser'] = currentUser;
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('UserLogin', undefined);
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'page')) == (Number((getObjectProperty(___arguments.context.pageData, 'totalPages'))))) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('8df8d2e2bef1ae08efcc44611b5882f1'))['background-color'] = '#9A91A6';
    return true;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('8df8d2e2bef1ae08efcc44611b5882f1'))['background-color'] = '#0A0A0A';
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/5-10-b1_Home/components/eb38a9bcb0711288da0800585d081f5a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var currentUser, retrievedContactsRawResponse, ContactsCountReturn, CurrentPageNumber;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['pageCurser'] = ((Number((getObjectProperty(___arguments.context.pageData, 'page')))) - 1);
  if (currentUser != false) {
    retrievedContactsRawResponse = (await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((String('https://mgr.pockethost.io/api/collections/ACCOContacts/records?perPage=25&sort=+LastName,FirstName&page=') + String(JSON.stringify((getObjectProperty(___arguments.context.pageData, 'pageCurser'))))))).set(({ [`Authorization`]: ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOContactsToken')) })).setEncoding('utf8').send());
    ___arguments.context.pageData['page'] = (getObjectProperty(retrievedContactsRawResponse, 'page'));
    ___arguments.context.pageData['perPage'] = (getObjectProperty(retrievedContactsRawResponse, 'perPage'));
    ___arguments.context.pageData['totalItems'] = (getObjectProperty(retrievedContactsRawResponse, 'totalItems'));
    ___arguments.context.pageData['totalPages'] = (getObjectProperty(retrievedContactsRawResponse, 'totalPages'));
    console.log('RetrievedContactsRawResponse:');
    console.log(retrievedContactsRawResponse);
    ___arguments.context.pageData['RetrievedContacts'] = (getObjectProperty(retrievedContactsRawResponse, 'items'));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', ({  }));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', (getObjectProperty(___arguments.context.pageData, 'RetrievedContacts')));
    ___arguments.context.pageData['DisplayingContactsMessage'] = (['Contact: ',(Number((getObjectProperty(___arguments.context.pageData, 'page')))) * (Number((getObjectProperty(___arguments.context.pageData, 'perPage')))),' | Page: ',(getObjectProperty(___arguments.context.pageData, 'page')),' (',(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8'))[0]), 'LastName')),' To ',(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8')).slice(-1)[0]), 'LastName')),') | Total Pages: ',(getObjectProperty(___arguments.context.pageData, 'totalPages')),' | Total Contacts: ',(getObjectProperty(___arguments.context.pageData, 'totalItems'))].join(''));
    console.log(currentUser);
    ___arguments.context.appData['currentUser'] = currentUser;
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('UserLogin', undefined);
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'page')) == 1) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('eb38a9bcb0711288da0800585d081f5a'))['background-color'] = '#9A91A6';
    return true;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('eb38a9bcb0711288da0800585d081f5a'))['background-color'] = '#0A0A0A';
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/5-10-b1_Home/components/c38b81a1fde808e224a8dc634857c68a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var currentUser, retrievedContactsRawResponse, ContactsCountReturn, CurrentPageNumber;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['pageCurser'] = ((Number((getObjectProperty(___arguments.context.pageData, 'page')))) + 10);
  if (currentUser != false) {
    retrievedContactsRawResponse = (await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((String('https://mgr.pockethost.io/api/collections/ACCOContacts/records?perPage=25&sort=+LastName,FirstName&page=') + String(JSON.stringify((getObjectProperty(___arguments.context.pageData, 'pageCurser'))))))).set(({ [`Authorization`]: ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOContactsToken')) })).setEncoding('utf8').send());
    ___arguments.context.pageData['page'] = (getObjectProperty(retrievedContactsRawResponse, 'page'));
    ___arguments.context.pageData['perPage'] = (getObjectProperty(retrievedContactsRawResponse, 'perPage'));
    ___arguments.context.pageData['totalItems'] = (getObjectProperty(retrievedContactsRawResponse, 'totalItems'));
    ___arguments.context.pageData['totalPages'] = (getObjectProperty(retrievedContactsRawResponse, 'totalPages'));
    console.log('RetrievedContactsRawResponse:');
    console.log(retrievedContactsRawResponse);
    ___arguments.context.pageData['RetrievedContacts'] = (getObjectProperty(retrievedContactsRawResponse, 'items'));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', ({  }));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', (getObjectProperty(___arguments.context.pageData, 'RetrievedContacts')));
    ___arguments.context.pageData['DisplayingContactsMessage'] = (['Contact: ',(Number((getObjectProperty(___arguments.context.pageData, 'page')))) * (Number((getObjectProperty(___arguments.context.pageData, 'perPage')))),' | Page: ',(getObjectProperty(___arguments.context.pageData, 'page')),' (',(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8'))[0]), 'LastName')),' To ',(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8')).slice(-1)[0]), 'LastName')),') | Total Pages: ',(getObjectProperty(___arguments.context.pageData, 'totalPages')),' | Total Contacts: ',(getObjectProperty(___arguments.context.pageData, 'totalItems'))].join(''));
    console.log(currentUser);
    ___arguments.context.appData['currentUser'] = currentUser;
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('UserLogin', undefined);
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'page')) > (Number((getObjectProperty(___arguments.context.pageData, 'totalPages')))) - 10) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c38b81a1fde808e224a8dc634857c68a'))['background-color'] = '#9A91A6';
    return true;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c38b81a1fde808e224a8dc634857c68a'))['background-color'] = '#0A0A0A';
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/5-10-b1_Home/components/3f18a098cf5807a87b084d784a98910c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var currentUser, retrievedContactsRawResponse, CurrentPageNumber;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  CurrentPageNumber = 0;
  ___arguments.context.pageData['pageCurser'] = (Number((getObjectProperty(___arguments.context.pageData, 'totalPages'))));
  if (currentUser != false) {
    retrievedContactsRawResponse = (await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((String('https://mgr.pockethost.io/api/collections/ACCOContacts/records?perPage=25&sort=+LastName,FirstName&page=') + String(JSON.stringify((getObjectProperty(___arguments.context.pageData, 'pageCurser'))))))).set(({ [`Authorization`]: ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOContactsToken')) })).setEncoding('utf8').send());
    ___arguments.context.pageData['page'] = (getObjectProperty(retrievedContactsRawResponse, 'page'));
    ___arguments.context.pageData['perPage'] = (getObjectProperty(retrievedContactsRawResponse, 'perPage'));
    ___arguments.context.pageData['totalItems'] = (getObjectProperty(retrievedContactsRawResponse, 'totalItems'));
    ___arguments.context.pageData['totalPages'] = (getObjectProperty(retrievedContactsRawResponse, 'totalPages'));
    console.log('RetrievedContactsRawResponse:');
    console.log(retrievedContactsRawResponse);
    ___arguments.context.pageData['RetrievedContacts'] = (getObjectProperty(retrievedContactsRawResponse, 'items'));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', ({  }));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', (getObjectProperty(___arguments.context.pageData, 'RetrievedContacts')));
    ___arguments.context.pageData['DisplayingContactsMessage'] = (['Contact: ',(Number((getObjectProperty(___arguments.context.pageData, 'page')))) * (Number((getObjectProperty(___arguments.context.pageData, 'perPage')))),' | Page: ',(getObjectProperty(___arguments.context.pageData, 'page')),' (',(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8'))[0]), 'LastName')),' To ',(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8')).slice(-1)[0]), 'LastName')),') | Total Pages: ',(getObjectProperty(___arguments.context.pageData, 'totalPages')),' | Total Contacts: ',(getObjectProperty(___arguments.context.pageData, 'totalItems'))].join(''));
    console.log(currentUser);
    ___arguments.context.appData['currentUser'] = currentUser;
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('UserLogin', undefined);
  }
  ___arguments.context.pageData['DisplayingContactsMessage'] = (['Contact: ',(Number((getObjectProperty(___arguments.context.pageData, 'page')))) * (Number((getObjectProperty(___arguments.context.pageData, 'perPage')))),' | Page: ',(getObjectProperty(___arguments.context.pageData, 'page')),' (',(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8'))[0]), 'LastName')),' To ',(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8')).slice(-1)[0]), 'LastName')),') | Total Pages: ',(getObjectProperty(___arguments.context.pageData, 'totalPages')),' | Total Contacts: ',(getObjectProperty(___arguments.context.pageData, 'totalItems'))].join(''));

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'page')) == (Number((getObjectProperty(___arguments.context.pageData, 'totalPages'))))) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3f18a098cf5807a87b084d784a98910c'))['background-color'] = '#9A91A6';
    return true;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3f18a098cf5807a87b084d784a98910c'))['background-color'] = '#0A0A0A';
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/5-10-b1_Home/components/8bf48e763098bc9bd82790dc5238e3c8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log(___arguments.context.getComponentDataStoreByUid('f548849959d80918247fdbdd7f982de8'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/5-11b1_Home/components/ab288c9ed0e835b89a08e4b88e03dc16/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOUserToken'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/5-11b1_Home/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var currentUser, retrievedContactsRawResponse, storedTokenFromCookie;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['RetrievedContactsRawResponse'] = ({  });
  ___arguments.context.pageData['OpenDrawer'] = false;
  ___arguments.context.pageData['DisplayingContactsPageNumber'] = 0;
  storedTokenFromCookie = ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOUserToken'));
  currentUser = (await BackendlessUI.Functions.Custom['fn_fb29ed716ee40c6ec05a6af2fb62b61d'](storedTokenFromCookie));
  if (currentUser != false) {
    ___arguments.context.appData['currentUser'] = currentUser;
    retrievedContactsRawResponse = (await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://mgr.pockethost.io/api/collections/ACCOContacts/records?perPage=25&sort=+LastName,FirstName')).set(({ [`Authorization`]: ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOContactsToken')) })).setEncoding('utf8').send());
    ___arguments.context.pageData['pageCursor'] = 0;
    ___arguments.context.pageData['page'] = (getObjectProperty(retrievedContactsRawResponse, 'page'));
    ___arguments.context.pageData['perPage'] = (getObjectProperty(retrievedContactsRawResponse, 'perPage'));
    ___arguments.context.pageData['totalItems'] = (getObjectProperty(retrievedContactsRawResponse, 'totalItems'));
    ___arguments.context.pageData['totalPages'] = (getObjectProperty(retrievedContactsRawResponse, 'totalPages'));
    console.log('RetrievedContactsRawResponse:');
    console.log(retrievedContactsRawResponse);
    ___arguments.context.pageData['RetrievedContacts'] = (getObjectProperty(retrievedContactsRawResponse, 'items'));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', (getObjectProperty(___arguments.context.pageData, 'RetrievedContacts')));
    console.log(currentUser);
    ___arguments.context.pageData['DisplayingContactsMessage'] = (['Contact: ',(Number((getObjectProperty(___arguments.context.pageData, 'page')))) * (Number((getObjectProperty(___arguments.context.pageData, 'perPage')))),' | Page: ',(getObjectProperty(___arguments.context.pageData, 'page')),' (',(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8'))[0]), 'LastName')),' To ',(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8')).slice(-1)[0]), 'LastName')),') | Total Pages: ',(getObjectProperty(___arguments.context.pageData, 'totalPages')),' | Total Contacts: ',(getObjectProperty(___arguments.context.pageData, 'totalItems'))].join(''));
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('UserLogin', undefined);
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/5-11b1_Home/components/54081436bb6842a82788d1d8c2a7dbc1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(getObjectProperty(___arguments.context.appData, 'currentUser'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/5-11b1_Home/components/e65831ef35789938da8896bca018c4e8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      localStorage.removeItem('ACCOUserToken');
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('UserLogin', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/5-11b1_Home/components/cb980528d6cebac8f0984878c8985798/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(getObjectProperty(___arguments.context.pageData, 'RetrievedContacts'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/5-11b1_Home/components/26c848494068ad8874b4b73208376878/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await (async function(TextToCopy) {
  	navigator.clipboard.writeText(TextToCopy);
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5e3f583561b818f8a1786ac80fa77ec8'), 'BusinessPhone')));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9954b1e8ff38cc68d3f769a8c488aa1c'))['color'] = '#A00000';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9954b1e8ff38cc68d3f769a8c488aa1c'))['text-decoration-line'] = 'underline';
  await new Promise(r => setTimeout(r, 400 || 0));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9954b1e8ff38cc68d3f769a8c488aa1c'))['color'] = '#000000';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9954b1e8ff38cc68d3f769a8c488aa1c'))['text-decoration-line'] = 'none';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/5-11b1_Home/components/8c26d238ec58efa916980c5156989ff8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('14160948a388f4c82618c6e80fc67fec');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/5-11b1_Home/components/9f18306e287839f6b688b2785af8c8ec/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var decision, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'isContactSelected')) == true) {
    console.log(await asyncListFilter(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8')), async (item) => {
       if ((getObjectProperty(item, 'CurrentlySelectedContact')) == true) {
        delete item['CurrentlySelectedContact'];
        decision = true;
      } else {
        decision = true;
      }


     return ;
    }));
  }
  ___arguments.context.pageData['OpenDrawer'] = false;
  ___arguments.context.pageData['CurrentlySelectedContact'] = false;
  ___arguments.context.pageData['CurrentlySelectedContactObjectID'] = '';
  ___arguments.context.pageData['isContactSelected'] = false;
  ___arguments.context.pageData['EditMode'] = false;
  await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('d5e8e785986ad5d8c618fb16527f9038', undefined);
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bb85878828193def9f8054853f8949b'))['min-height'] = '100%';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/5-11b1_Home/components/34b170cf59982968ddc866980023ca7f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var decision, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function Set_pageData_Variables() {
  ___arguments.context.pageData['AddScrollDelay'] = true;
  ___arguments.context.pageData['OpenDrawer'] = true;
  ___arguments.context.pageData['CurrentlySelectedContact'] = true;
  ___arguments.context.pageData['isContactSelected'] = true;
  ___arguments.context.getComponentDataStoreByUid('f548849959d80918247fdbdd7f982de8')['CurrentlySelectedContact'] = true;
  ___arguments.context.pageData['CurrentlySelectedContactID'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f548849959d80918247fdbdd7f982de8'), 'id'));
  ___arguments.context.pageData['CurrentlySelectedContactData'] = (JSON.parse((JSON.stringify(___arguments.context.getComponentDataStoreByUid('f548849959d80918247fdbdd7f982de8')))));
}


  if ((getObjectProperty(___arguments.context.pageData, 'isContactSelected')) == true) {
    console.log(await asyncListFilter(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8')), async (item) => {
       if ((getObjectProperty(item, 'CurrentlySelectedContact')) == true) {
        delete item['CurrentlySelectedContact'];
        decision = true;
      } else {
        decision = true;
      }


     return decision;
    }));
  }
  await Set_pageData_Variables();
  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('be99ba0526853a96ade9ec3aa8aa9513', (JSON.parse((JSON.stringify(___arguments.context.getComponentDataStoreByUid('f548849959d80918247fdbdd7f982de8'))))));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bb85878828193def9f8054853f8949b'))['min-height'] = '125%';
  await (async function() {
  	const elements = document.getElementsByClassName('MainContactsRow');
  	const currentHeight = elements[0].clientHeight; // Get the current height
  	newHeight = currentHeight
  	
  	// newHeight = currentHeight * (1 + percentageIncrease / 100); // Calculate new height
  	if (newHeight < 1150) {
  	  newHeight = 1150;
  	}
  	elements[0].style.minHeight = newHeight + 'px'; // Set the new height
  	// alert('The current height is: '+ currentHeight);

  })();
  (function (component) { component.el.scrollIntoView() })((getObjectProperty(___arguments.context.pageData, (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f548849959d80918247fdbdd7f982de8'), 'id')))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/5-11b1_Home/components/d5e8e785986ad5d8c618fb16527f9038/bundle.js', [], () => ({
  /* content */
  /* handler:isOpenLogic */
  ['isOpenLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'OpenDrawer'))

  },
  /* handler:isOpenLogic */
  /* handler:onClose */
  async ['onClose'](___arguments) {
    var item, result, decision;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  ___arguments.context.pageData['OpenDrawer'] = false;
  if ((getObjectProperty(___arguments.context.pageData, 'isContactSelected')) == true) {
    console.log(await asyncListFilter(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8')), async (item) => {
       if ((getObjectProperty(item, 'CurrentlySelectedContact')) == true) {
        delete item['CurrentlySelectedContact'];
        decision = true;
      } else {
        decision = true;
      }


     return ;
    }));
  }
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bb85878828193def9f8054853f8949b'))['height'] = 'auto';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bb85878828193def9f8054853f8949b'))['min-height'] = 'auto';
  ___arguments.context.pageData['isContactSelected'] = false;
  ___arguments.context.pageData['EditMode'] = false;
  result = (await (async function(modifiedData) {
  	var userPreference;
  	
  	if (modifiedData) {
  	
  	  if (confirm("Save your changes? [Enter] to save | [Esc] to cancel") == true) {
  	    userPreference = "Save Requested";
  	  } else {
  	    userPreference = "Save Cancelled!";
  	  }
  	// console.log(userPreference)
  	return userPreference
  	  
  	}

  })((getObjectProperty(___arguments.context.pageData, 'ModifiedData'))));
  if (result == 'Save Requested') {
    console.log('Save Data Requested');
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', (await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8')).map(async item => {  if ((getObjectProperty(item, 'id')) == (getObjectProperty(___arguments.context.pageData, 'CurrentlySelectedContactID'))) {
        item['NeedToSave'] = true;
        item['FirstName'] = (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6672cef89de766787f2889f880d8b618')), 'value'));
        item['MiddleName'] = (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ac22d7a23f48b4a88ef44e890c58d724')), 'value'));
        item['LastName'] = (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('af7832b8d436d7bdb868946446a9d5fc')), 'value'));
        item['Suffix'] = (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('390d1ad861e8a4a817487017ebcec028')), 'value'));
      }
    ; return item;}))));
  } else {
    console.log('Save Data Cancelled!');
  }
  ___arguments.context.pageData['ModifiedData'] = false;

  },
  /* handler:onClose */
  /* content */
}))

define('./pages/5-11b1_Home/components/715ffae88be9507ff0b894488f3f2571/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f548849959d80918247fdbdd7f982de8'), 'CurrentlySelectedContact')) == true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f548849959d80918247fdbdd7f982de8'))['background-color'] = '#990939';
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f548849959d80918247fdbdd7f982de8'))['background-color'] = '#016288';
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/5-11b1_Home/components/f548849959d80918247fdbdd7f982de8/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData[(getObjectProperty(___arguments.context.dataModel, 'id'))] = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f548849959d80918247fdbdd7f982de8'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/5-11b1_Home/components/c4e88a1ec9685fd8d8c459588a08e548/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f548849959d80918247fdbdd7f982de8'), 'EmailAddress')) != '') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c4e88a1ec9685fd8d8c459588a08e548'))['color'] = '#FFFFFF';
  }

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f548849959d80918247fdbdd7f982de8'), 'EmailAddress')) != '') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c4e88a1ec9685fd8d8c459588a08e548'))['color'] = '#B4B4B4';
  }

  },
  /* handler:onMouseOut */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('3d1800088b7fe3386f380083d4e8b13d')), 'text')) != '') {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/5-11b1_Home/components/9a38cdb1fe6889b8853c0d7891b8ca88/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var response, DBSearchTerm, retrievedContacts;

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setTimeouts'); if (timerId && timers[timerId]) {    clearTimeout(timers[timerId]);    delete timers[timerId]; }}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setTimeouts'); const timer = setTimeout(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function Search_Contacts() {
  if ((getObjectProperty(___arguments.context.pageData, 'TOGGLE_IncludeCompany')) == true) {
    retrievedContacts = (getObjectProperty((await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((['https://mgr.pockethost.io/api/collections/ACCOContacts/records?perPage=50&sort=+LastName,FirstName&filter=(','LastName~\'',___arguments.value,'\' || FirstName~\'',___arguments.value,'\' || Company~\'',___arguments.value,'\')'].join('')))).set(({ [`Authorization`]: ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOContactsToken')) })).setEncoding('utf8').send()), 'items'));
    ___arguments.context.pageData['RetrievedContacts'] = retrievedContacts;
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9048e37ecae67908d8bd408823dce8d8'))['background-color'] = '#A00000';
    ___arguments.context.pageData['MAKEITWHITE'] = true;
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ee68b608a0ec67383ffecb48626858c8'))['color'] = '#FFFFFF';
  } else {
    retrievedContacts = (getObjectProperty((await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((['https://mgr.pockethost.io/api/collections/ACCOContacts/records?perPage=50&sort=+LastName,FirstName&filter=(','LastName~\'',___arguments.value,'\' || FirstName~\'',___arguments.value,'\')'].join('')))).set(({ [`Authorization`]: ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOContactsToken')) })).setEncoding('utf8').send()), 'items'));
  }
  return retrievedContacts
}

/**
 * Describe this function...
 */
async function Reset_Search() {
  retrievedContacts = (getObjectProperty((await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((String('https://mgr.pockethost.io/api/collections/ACCOContacts/records?perPage=25&sort=+LastName,FirstName')))).set(({ [`Authorization`]: ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOContactsToken')) })).setEncoding('utf8').send()), 'items'));
  ___arguments.context.pageData['RetrievedContacts'] = retrievedContacts;
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9048e37ecae67908d8bd408823dce8d8'))['background-color'] = '#F5F5F5';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9a38cdb1fe6889b8853c0d7891b8ca88'))['color'] = '#000000';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ee68b608a0ec67383ffecb48626858c8'))['color'] = '#AD0505';
  ___arguments.context.pageData['MAKEITWHITE'] = false;
  ___arguments.context.appData['ForceSearch'] = false;
  return retrievedContacts
}


  stopSetTimeout('lazySearch');

  ;(function() {
    const callback = async () => {
        DBSearchTerm = ___arguments.value;
    ___arguments.context.pageData['DBSearchTerm'] = DBSearchTerm;
    response = await Search_Contacts();
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', ({  }));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', response);
    ___arguments.context.appData['ForceSearch'] = true;

    };

    const timerId = 'lazySearch';
    const timerDelay = 1000;

    runSetTimeout(timerId, callback, timerDelay)
  })()
  if (___arguments.value == '') {
    response = await Search_Contacts();
    response = await Reset_Search();
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', ({  }));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', response);
    ___arguments.context.appData['ForceSearch'] = false;
    ___arguments.context.pageData['DBSearchTerm'] = '';
  } else {
    response = await Search_Contacts();
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', ({  }));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', response);
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9048e37ecae67908d8bd408823dce8d8'))['background-color'] = '#A00000';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9a38cdb1fe6889b8853c0d7891b8ca88'))['color'] = '#FFFFFF';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ee68b608a0ec67383ffecb48626858c8'))['color'] = '#FFFFFF';
    ___arguments.context.pageData['MAKEITWHITE'] = true;
    ___arguments.context.appData['ForceSearch'] = true;
  }
  if (getValueLength(___arguments.value) == 0) {
    ___arguments.context.pageData['DBSearchTerm'] = '';
    stopSetTimeout('lazySearch');
  }

  },
  /* handler:onChange */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    var classList;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'MAKEITWHITE')) == true) {
    classList = ['input-white'];
  } else {
    classList = ['input-black'];
  }
  return classList;

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/5-11b1_Home/components/ee68b608a0ec67383ffecb48626858c8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var retrievedContacts;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setTimeouts'); if (timerId && timers[timerId]) {    clearTimeout(timers[timerId]);    delete timers[timerId]; }}

/**
 * Describe this function...
 */
async function Reset_Search() {
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', ({  }));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', (getObjectProperty((await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((String('https://mgr.pockethost.io/api/collections/ACCOContacts/records?perPage=25&sort=+LastName,FirstName')))).set(({ [`Authorization`]: ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOContactsToken')) })).setEncoding('utf8').send()), 'items')));
  ___arguments.context.pageData['RetrievedContacts'] = retrievedContacts;
}


  await Reset_Search();
  ___arguments.context.pageData['DBSearchTerm'] = '';
  ___arguments.context.pageData['value'] = '';
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('9a38cdb1fe6889b8853c0d7891b8ca88'))['value'] = '';
  ___arguments.context.pageData['ForceSearch'] = false;
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9048e37ecae67908d8bd408823dce8d8'))['background-color'] = '#F5F5F5';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ee68b608a0ec67383ffecb48626858c8'))['color'] = '#AD0505';
  ___arguments.context.pageData['MAKEITWHITE'] = false;
  ___arguments.context.pageData['MAKEITBLACK'] = (!(getObjectProperty(___arguments.context.pageData, 'MAKEITWHITE')));
  stopSetTimeout('lazySearch');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/5-11b1_Home/components/3a4106331cb86b6899de7db685e6a9f2/bundle.js', [], () => ({
  /* content */
  /* handler:onDelete */
  ['onDelete'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'PageFilter')) == 'Created') {
    ___arguments.context.pageData['PageFilter'] = '';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3a4106331cb86b6899de7db685e6a9f2'))['background-color'] = '#016288';
  }

  },
  /* handler:onDelete */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'PageFilter')) != 'Created') {
    ___arguments.context.pageData['PageFilter'] = 'Created';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3a4106331cb86b6899de7db685e6a9f2'))['background-color'] = '#A00000';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('86684ec8198c47f8c1a80e08638823b6'))['background-color'] = '#016288';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('50d8bec85069e1ce0198f5e8c4670bd8'))['background-color'] = '#016288';
  } else {
    ___arguments.context.pageData['CreatedDirectionDown'] = (!(getObjectProperty(___arguments.context.pageData, 'CreatedDirectionDown')));
    await (async function() {
    	const icon = document.querySelector('.created-chip-class i')

    	if (icon.innerHTML === 'arrow_circle_up') {
    	    icon.innerHTML = 'arrow_circle_down'
    	 } else {
    	    icon.innerHTML = 'arrow_circle_up'
    	 }
    })();
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/5-11b1_Home/components/86684ec8198c47f8c1a80e08638823b6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'PageFilter')) != 'Viewed') {
    ___arguments.context.pageData['PageFilter'] = 'Viewed';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3a4106331cb86b6899de7db685e6a9f2'))['background-color'] = '#016288';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('86684ec8198c47f8c1a80e08638823b6'))['background-color'] = '#A00000';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('50d8bec85069e1ce0198f5e8c4670bd8'))['background-color'] = '#016288';
  } else {
    ___arguments.context.pageData['ViewedDirectionDown'] = (!(getObjectProperty(___arguments.context.pageData, 'ViewedDirectionDown')));
    await (async function() {
    	const icon = document.querySelector('.viewed-chip-class i')

    	if (icon.innerHTML === 'arrow_circle_up') {
    	    icon.innerHTML = 'arrow_circle_down'
    	 } else {
    	    icon.innerHTML = 'arrow_circle_up'
    	 }
    })();
  }

  },
  /* handler:onClick */
  /* handler:onDelete */
  ['onDelete'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'PageFilter')) == 'Viewed') {
    ___arguments.context.pageData['PageFilter'] = '';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('86684ec8198c47f8c1a80e08638823b6'))['background-color'] = '#016288';
  }

  },
  /* handler:onDelete */
  /* content */
}))

define('./pages/5-11b1_Home/components/50d8bec85069e1ce0198f5e8c4670bd8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'PageFilter')) != 'Modified') {
    ___arguments.context.pageData['PageFilter'] = 'Modified';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3a4106331cb86b6899de7db685e6a9f2'))['background-color'] = '#016288';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('86684ec8198c47f8c1a80e08638823b6'))['background-color'] = '#016288';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('50d8bec85069e1ce0198f5e8c4670bd8'))['background-color'] = '#A00000';
  } else {
    ___arguments.context.pageData['ModifiedDirectionDown'] = (!(getObjectProperty(___arguments.context.pageData, 'ModifiedDirectionDown')));
    await (async function() {
    	const icon = document.querySelector('.modified-chip-class i')

    	if (icon.innerHTML === 'arrow_circle_up') {
    	    icon.innerHTML = 'arrow_circle_down'
    	 } else {
    	    icon.innerHTML = 'arrow_circle_up'
    	 }
    })();
  }

  },
  /* handler:onClick */
  /* handler:onDelete */
  ['onDelete'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'PageFilter')) == 'Modified') {
    ___arguments.context.pageData['PageFilter'] = '';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('50d8bec85069e1ce0198f5e8c4670bd8'))['background-color'] = '#016288';
  }

  },
  /* handler:onDelete */
  /* content */
}))

define('./pages/5-11b1_Home/components/c8486c55ffb833b1731c386d281e1628/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var retrievedContacts, results;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function Search_Contacts() {
  if ((getObjectProperty(___arguments.context.pageData, 'TOGGLE_IncludeCompany')) == true) {
    retrievedContacts = (getObjectProperty((await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((['https://mgr.pockethost.io/api/collections/ACCOContacts/records?perPage=50&sort=+LastName,FirstName&filter=(','LastName~\'',(getObjectProperty(___arguments.context.pageData, 'DBSearchTerm')),'\' || FirstName~\'',(getObjectProperty(___arguments.context.pageData, 'DBSearchTerm')),'\' || Company~\'',(getObjectProperty(___arguments.context.pageData, 'DBSearchTerm')),'\')'].join('')))).set(({ [`Authorization`]: ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOContactsToken')) })).setEncoding('utf8').send()), 'items'));
  } else {
    retrievedContacts = (getObjectProperty((await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((['https://mgr.pockethost.io/api/collections/ACCOContacts/records?perPage=50&sort=+LastName,FirstName&filter=(','LastName~\'',(getObjectProperty(___arguments.context.pageData, 'DBSearchTerm')),'\' || FirstName~\'',(getObjectProperty(___arguments.context.pageData, 'DBSearchTerm')),'\')'].join('')))).set(({ [`Authorization`]: ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOContactsToken')) })).setEncoding('utf8').send()), 'items'));
  }
  return retrievedContacts
}


  if (___arguments.value == true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a1a8e4d209da625868a898e85398323e'))['color'] = '#990000';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a1a8e4d209da625868a898e85398323e'))['font-weight'] = 'bold';
    ___arguments.context.pageData['TOGGLE_IncludeCompany'] = true;
    results = await Search_Contacts();
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a1a8e4d209da625868a898e85398323e'))['color'] = '#000000';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a1a8e4d209da625868a898e85398323e'))['font-weight'] = 'normal';
    ___arguments.context.pageData['TOGGLE_IncludeCompany'] = false;
    results = await Search_Contacts();
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', results);

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/5-11b1_Home/components/96b815b891276784d638d95fab3833cd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var currentUser, retrievedContactsRawResponse, CurrentPageNumber;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  CurrentPageNumber = 0;
  ___arguments.context.pageData['pageCurser'] = 1;
  if (currentUser != false) {
    retrievedContactsRawResponse = (await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((String('https://mgr.pockethost.io/api/collections/ACCOContacts/records?perPage=25&sort=+LastName,FirstName&page=') + String(JSON.stringify((getObjectProperty(___arguments.context.pageData, 'pageCurser'))))))).set(({ [`Authorization`]: ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOContactsToken')) })).setEncoding('utf8').send());
    ___arguments.context.pageData['page'] = (getObjectProperty(retrievedContactsRawResponse, 'page'));
    ___arguments.context.pageData['perPage'] = (getObjectProperty(retrievedContactsRawResponse, 'perPage'));
    ___arguments.context.pageData['totalItems'] = (getObjectProperty(retrievedContactsRawResponse, 'totalItems'));
    ___arguments.context.pageData['totalPages'] = (getObjectProperty(retrievedContactsRawResponse, 'totalPages'));
    console.log('RetrievedContactsRawResponse:');
    console.log(retrievedContactsRawResponse);
    ___arguments.context.pageData['RetrievedContacts'] = (getObjectProperty(retrievedContactsRawResponse, 'items'));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', ({  }));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', (getObjectProperty(___arguments.context.pageData, 'RetrievedContacts')));
    ___arguments.context.pageData['DisplayingContactsMessage'] = (['Contact: ',(Number((getObjectProperty(___arguments.context.pageData, 'page')))) * (Number((getObjectProperty(___arguments.context.pageData, 'perPage')))),' | Page: ',(getObjectProperty(___arguments.context.pageData, 'page')),' (',(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8'))[0]), 'LastName')),' To ',(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8')).slice(-1)[0]), 'LastName')),') | Total Pages: ',(getObjectProperty(___arguments.context.pageData, 'totalPages')),' | Total Contacts: ',(getObjectProperty(___arguments.context.pageData, 'totalItems'))].join(''));
    console.log(currentUser);
    ___arguments.context.appData['currentUser'] = currentUser;
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('UserLogin', undefined);
  }
  ___arguments.context.pageData['DisplayingContactsMessage'] = (['Contact: ',(Number((getObjectProperty(___arguments.context.pageData, 'page')))) * (Number((getObjectProperty(___arguments.context.pageData, 'perPage')))),' | Page: ',(getObjectProperty(___arguments.context.pageData, 'page')),' (',(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8'))[0]), 'LastName')),' To ',(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8')).slice(-1)[0]), 'LastName')),') | Total Pages: ',(getObjectProperty(___arguments.context.pageData, 'totalPages')),' | Total Contacts: ',(getObjectProperty(___arguments.context.pageData, 'totalItems'))].join(''));

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'page')) == 1) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('96b815b891276784d638d95fab3833cd'))['background-color'] = '#9A91A6';
    return true;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('96b815b891276784d638d95fab3833cd'))['background-color'] = '#0A0A0A';
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/5-11b1_Home/components/f1542a58df082559e03864f8db487678/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var currentUser, retrievedContactsRawResponse, ContactsCountReturn, CurrentPageNumber;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['pageCurser'] = ((Number((getObjectProperty(___arguments.context.pageData, 'page')))) - 10);
  if (currentUser != false) {
    retrievedContactsRawResponse = (await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((String('https://mgr.pockethost.io/api/collections/ACCOContacts/records?perPage=25&sort=+LastName,FirstName&page=') + String(JSON.stringify((getObjectProperty(___arguments.context.pageData, 'pageCurser'))))))).set(({ [`Authorization`]: ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOContactsToken')) })).setEncoding('utf8').send());
    ___arguments.context.pageData['page'] = (getObjectProperty(retrievedContactsRawResponse, 'page'));
    ___arguments.context.pageData['perPage'] = (getObjectProperty(retrievedContactsRawResponse, 'perPage'));
    ___arguments.context.pageData['totalItems'] = (getObjectProperty(retrievedContactsRawResponse, 'totalItems'));
    ___arguments.context.pageData['totalPages'] = (getObjectProperty(retrievedContactsRawResponse, 'totalPages'));
    console.log('RetrievedContactsRawResponse:');
    console.log(retrievedContactsRawResponse);
    ___arguments.context.pageData['RetrievedContacts'] = (getObjectProperty(retrievedContactsRawResponse, 'items'));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', ({  }));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', (getObjectProperty(___arguments.context.pageData, 'RetrievedContacts')));
    ___arguments.context.pageData['DisplayingContactsMessage'] = (['Contact: ',(Number((getObjectProperty(___arguments.context.pageData, 'page')))) * (Number((getObjectProperty(___arguments.context.pageData, 'perPage')))),' | Page: ',(getObjectProperty(___arguments.context.pageData, 'page')),' (',(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8'))[0]), 'LastName')),' To ',(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8')).slice(-1)[0]), 'LastName')),') | Total Pages: ',(getObjectProperty(___arguments.context.pageData, 'totalPages')),' | Total Contacts: ',(getObjectProperty(___arguments.context.pageData, 'totalItems'))].join(''));
    console.log(currentUser);
    ___arguments.context.appData['currentUser'] = currentUser;
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('UserLogin', undefined);
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'page')) <= 10) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f1542a58df082559e03864f8db487678'))['background-color'] = '#9A91A6';
    return true;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f1542a58df082559e03864f8db487678'))['background-color'] = '#0A0A0A';
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/5-11b1_Home/components/8df8d2e2bef1ae08efcc44611b5882f1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var currentUser, retrievedContactsRawResponse, ContactsCountReturn, CurrentPageNumber;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['pageCurser'] = ((Number((getObjectProperty(___arguments.context.pageData, 'page')))) + 1);
  if (currentUser != false) {
    retrievedContactsRawResponse = (await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((String('https://mgr.pockethost.io/api/collections/ACCOContacts/records?perPage=25&sort=+LastName,FirstName&page=') + String(JSON.stringify((getObjectProperty(___arguments.context.pageData, 'pageCurser'))))))).set(({ [`Authorization`]: ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOContactsToken')) })).setEncoding('utf8').send());
    ___arguments.context.pageData['page'] = (getObjectProperty(retrievedContactsRawResponse, 'page'));
    ___arguments.context.pageData['perPage'] = (getObjectProperty(retrievedContactsRawResponse, 'perPage'));
    ___arguments.context.pageData['totalItems'] = (getObjectProperty(retrievedContactsRawResponse, 'totalItems'));
    ___arguments.context.pageData['totalPages'] = (getObjectProperty(retrievedContactsRawResponse, 'totalPages'));
    console.log('RetrievedContactsRawResponse:');
    console.log(retrievedContactsRawResponse);
    ___arguments.context.pageData['RetrievedContacts'] = (getObjectProperty(retrievedContactsRawResponse, 'items'));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', ({  }));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', (getObjectProperty(___arguments.context.pageData, 'RetrievedContacts')));
    ___arguments.context.pageData['DisplayingContactsMessage'] = (['Contact: ',(Number((getObjectProperty(___arguments.context.pageData, 'page')))) * (Number((getObjectProperty(___arguments.context.pageData, 'perPage')))),' | Page: ',(getObjectProperty(___arguments.context.pageData, 'page')),' (',(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8'))[0]), 'LastName')),' To ',(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8')).slice(-1)[0]), 'LastName')),') | Total Pages: ',(getObjectProperty(___arguments.context.pageData, 'totalPages')),' | Total Contacts: ',(getObjectProperty(___arguments.context.pageData, 'totalItems'))].join(''));
    console.log(currentUser);
    ___arguments.context.appData['currentUser'] = currentUser;
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('UserLogin', undefined);
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'page')) == (Number((getObjectProperty(___arguments.context.pageData, 'totalPages'))))) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('8df8d2e2bef1ae08efcc44611b5882f1'))['background-color'] = '#9A91A6';
    return true;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('8df8d2e2bef1ae08efcc44611b5882f1'))['background-color'] = '#0A0A0A';
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/5-11b1_Home/components/eb38a9bcb0711288da0800585d081f5a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var currentUser, retrievedContactsRawResponse, ContactsCountReturn, CurrentPageNumber;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['pageCurser'] = ((Number((getObjectProperty(___arguments.context.pageData, 'page')))) - 1);
  if (currentUser != false) {
    retrievedContactsRawResponse = (await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((String('https://mgr.pockethost.io/api/collections/ACCOContacts/records?perPage=25&sort=+LastName,FirstName&page=') + String(JSON.stringify((getObjectProperty(___arguments.context.pageData, 'pageCurser'))))))).set(({ [`Authorization`]: ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOContactsToken')) })).setEncoding('utf8').send());
    ___arguments.context.pageData['page'] = (getObjectProperty(retrievedContactsRawResponse, 'page'));
    ___arguments.context.pageData['perPage'] = (getObjectProperty(retrievedContactsRawResponse, 'perPage'));
    ___arguments.context.pageData['totalItems'] = (getObjectProperty(retrievedContactsRawResponse, 'totalItems'));
    ___arguments.context.pageData['totalPages'] = (getObjectProperty(retrievedContactsRawResponse, 'totalPages'));
    console.log('RetrievedContactsRawResponse:');
    console.log(retrievedContactsRawResponse);
    ___arguments.context.pageData['RetrievedContacts'] = (getObjectProperty(retrievedContactsRawResponse, 'items'));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', ({  }));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', (getObjectProperty(___arguments.context.pageData, 'RetrievedContacts')));
    ___arguments.context.pageData['DisplayingContactsMessage'] = (['Contact: ',(Number((getObjectProperty(___arguments.context.pageData, 'page')))) * (Number((getObjectProperty(___arguments.context.pageData, 'perPage')))),' | Page: ',(getObjectProperty(___arguments.context.pageData, 'page')),' (',(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8'))[0]), 'LastName')),' To ',(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8')).slice(-1)[0]), 'LastName')),') | Total Pages: ',(getObjectProperty(___arguments.context.pageData, 'totalPages')),' | Total Contacts: ',(getObjectProperty(___arguments.context.pageData, 'totalItems'))].join(''));
    console.log(currentUser);
    ___arguments.context.appData['currentUser'] = currentUser;
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('UserLogin', undefined);
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'page')) == 1) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('eb38a9bcb0711288da0800585d081f5a'))['background-color'] = '#9A91A6';
    return true;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('eb38a9bcb0711288da0800585d081f5a'))['background-color'] = '#0A0A0A';
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/5-11b1_Home/components/c38b81a1fde808e224a8dc634857c68a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var currentUser, retrievedContactsRawResponse, ContactsCountReturn, CurrentPageNumber;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['pageCurser'] = ((Number((getObjectProperty(___arguments.context.pageData, 'page')))) + 10);
  if (currentUser != false) {
    retrievedContactsRawResponse = (await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((String('https://mgr.pockethost.io/api/collections/ACCOContacts/records?perPage=25&sort=+LastName,FirstName&page=') + String(JSON.stringify((getObjectProperty(___arguments.context.pageData, 'pageCurser'))))))).set(({ [`Authorization`]: ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOContactsToken')) })).setEncoding('utf8').send());
    ___arguments.context.pageData['page'] = (getObjectProperty(retrievedContactsRawResponse, 'page'));
    ___arguments.context.pageData['perPage'] = (getObjectProperty(retrievedContactsRawResponse, 'perPage'));
    ___arguments.context.pageData['totalItems'] = (getObjectProperty(retrievedContactsRawResponse, 'totalItems'));
    ___arguments.context.pageData['totalPages'] = (getObjectProperty(retrievedContactsRawResponse, 'totalPages'));
    console.log('RetrievedContactsRawResponse:');
    console.log(retrievedContactsRawResponse);
    ___arguments.context.pageData['RetrievedContacts'] = (getObjectProperty(retrievedContactsRawResponse, 'items'));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', ({  }));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', (getObjectProperty(___arguments.context.pageData, 'RetrievedContacts')));
    ___arguments.context.pageData['DisplayingContactsMessage'] = (['Contact: ',(Number((getObjectProperty(___arguments.context.pageData, 'page')))) * (Number((getObjectProperty(___arguments.context.pageData, 'perPage')))),' | Page: ',(getObjectProperty(___arguments.context.pageData, 'page')),' (',(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8'))[0]), 'LastName')),' To ',(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8')).slice(-1)[0]), 'LastName')),') | Total Pages: ',(getObjectProperty(___arguments.context.pageData, 'totalPages')),' | Total Contacts: ',(getObjectProperty(___arguments.context.pageData, 'totalItems'))].join(''));
    console.log(currentUser);
    ___arguments.context.appData['currentUser'] = currentUser;
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('UserLogin', undefined);
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'page')) > (Number((getObjectProperty(___arguments.context.pageData, 'totalPages')))) - 10) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c38b81a1fde808e224a8dc634857c68a'))['background-color'] = '#9A91A6';
    return true;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c38b81a1fde808e224a8dc634857c68a'))['background-color'] = '#0A0A0A';
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/5-11b1_Home/components/3f18a098cf5807a87b084d784a98910c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var currentUser, retrievedContactsRawResponse, CurrentPageNumber;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  CurrentPageNumber = 0;
  ___arguments.context.pageData['pageCurser'] = (Number((getObjectProperty(___arguments.context.pageData, 'totalPages'))));
  if (currentUser != false) {
    retrievedContactsRawResponse = (await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((String('https://mgr.pockethost.io/api/collections/ACCOContacts/records?perPage=25&sort=+LastName,FirstName&page=') + String(JSON.stringify((getObjectProperty(___arguments.context.pageData, 'pageCurser'))))))).set(({ [`Authorization`]: ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOContactsToken')) })).setEncoding('utf8').send());
    ___arguments.context.pageData['page'] = (getObjectProperty(retrievedContactsRawResponse, 'page'));
    ___arguments.context.pageData['perPage'] = (getObjectProperty(retrievedContactsRawResponse, 'perPage'));
    ___arguments.context.pageData['totalItems'] = (getObjectProperty(retrievedContactsRawResponse, 'totalItems'));
    ___arguments.context.pageData['totalPages'] = (getObjectProperty(retrievedContactsRawResponse, 'totalPages'));
    console.log('RetrievedContactsRawResponse:');
    console.log(retrievedContactsRawResponse);
    ___arguments.context.pageData['RetrievedContacts'] = (getObjectProperty(retrievedContactsRawResponse, 'items'));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', ({  }));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', (getObjectProperty(___arguments.context.pageData, 'RetrievedContacts')));
    ___arguments.context.pageData['DisplayingContactsMessage'] = (['Contact: ',(Number((getObjectProperty(___arguments.context.pageData, 'page')))) * (Number((getObjectProperty(___arguments.context.pageData, 'perPage')))),' | Page: ',(getObjectProperty(___arguments.context.pageData, 'page')),' (',(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8'))[0]), 'LastName')),' To ',(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8')).slice(-1)[0]), 'LastName')),') | Total Pages: ',(getObjectProperty(___arguments.context.pageData, 'totalPages')),' | Total Contacts: ',(getObjectProperty(___arguments.context.pageData, 'totalItems'))].join(''));
    console.log(currentUser);
    ___arguments.context.appData['currentUser'] = currentUser;
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('UserLogin', undefined);
  }
  ___arguments.context.pageData['DisplayingContactsMessage'] = (['Contact: ',(Number((getObjectProperty(___arguments.context.pageData, 'page')))) * (Number((getObjectProperty(___arguments.context.pageData, 'perPage')))),' | Page: ',(getObjectProperty(___arguments.context.pageData, 'page')),' (',(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8'))[0]), 'LastName')),' To ',(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8')).slice(-1)[0]), 'LastName')),') | Total Pages: ',(getObjectProperty(___arguments.context.pageData, 'totalPages')),' | Total Contacts: ',(getObjectProperty(___arguments.context.pageData, 'totalItems'))].join(''));

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'page')) == (Number((getObjectProperty(___arguments.context.pageData, 'totalPages'))))) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3f18a098cf5807a87b084d784a98910c'))['background-color'] = '#9A91A6';
    return true;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3f18a098cf5807a87b084d784a98910c'))['background-color'] = '#0A0A0A';
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/5-11b1_Home/components/8bf48e763098bc9bd82790dc5238e3c8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log(___arguments.context.getComponentDataStoreByUid('f548849959d80918247fdbdd7f982de8'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/5-11b1_Home/components/b1d3e8684cdf46a8fe882c58ccf881cb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('#Bottom', false, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/5-11b1_Home/components/5b9545ea538797582b284eb9c91349e8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('#Top', false, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/5-11b1_Home/components/fbefd2bb6fec4718d6382d38ad733348/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/5-11b1_Home/components/8bff4213c16c9ab8ba8a46588f28c3f2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log(___arguments.context.getComponentDataStoreByUid('be99ba0526853a96ade9ec3aa8aa9513'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/5-11b1_Home/components/92b96158c4d823916c18019a5b28fd83/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'CurrentlySelectedContactData')), 'FirstName'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/5-11b1_Home/components/31f864bdf9b8c4982b985e46c2a8175a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'CurrentlySelectedContactData')), 'LastName'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/5-11b1_Home/components/6672cef89de766787f2889f880d8b618/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'CurrentlySelectedContactData')), 'FirstName'))

  },
  /* handler:onValueAssignment */
  /* handler:onReadOnlyStateAssignment */
  ['onReadOnlyStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.pageData, 'EditMode')))

  },
  /* handler:onReadOnlyStateAssignment */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6672cef89de766787f2889f880d8b618')), 'value')) == '') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('6672cef89de766787f2889f880d8b618'))['border-color'] = '#AE0530';
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('6672cef89de766787f2889f880d8b618'))['border-color'] = '#0520AE';
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/5-11b1_Home/components/af7832b8d436d7bdb868946446a9d5fc/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'CurrentlySelectedContactData')), 'LastName'))

  },
  /* handler:onValueAssignment */
  /* handler:onReadOnlyStateAssignment */
  ['onReadOnlyStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.pageData, 'EditMode')))

  },
  /* handler:onReadOnlyStateAssignment */
  /* content */
}))

define('./pages/5-11b1_Home/components/ac22d7a23f48b4a88ef44e890c58d724/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'CurrentlySelectedContactData')), 'MiddleName'))

  },
  /* handler:onValueAssignment */
  /* handler:onReadOnlyStateAssignment */
  ['onReadOnlyStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.pageData, 'EditMode')))

  },
  /* handler:onReadOnlyStateAssignment */
  /* content */
}))

define('./pages/5-11b1_Home/components/c6d8a878da6ee2a81d1818587298aef2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['EditMode'] = true;
  ___arguments.context.pageData['ModifiedData'] = true;
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c6d8a878da6ee2a81d1818587298aef2'))['background-color'] = '#A00000';

  },
  /* handler:onClick */
  /* handler:onDelete */
  ['onDelete'](___arguments) {
      ___arguments.context.pageData['EditMode'] = false;
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c6d8a878da6ee2a81d1818587298aef2'))['background-color'] = '#016288';

  },
  /* handler:onDelete */
  /* content */
}))

define('./pages/5-11b1_Home/components/99a8df394f156cc874813c38d937d968/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('99a8df394f156cc874813c38d937d968'))['color'] = '#03B935';

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f548849959d80918247fdbdd7f982de8'), 'NeedToSave')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/5-11b1_Home/components/390d1ad861e8a4a817487017ebcec028/bundle.js', [], () => ({
  /* content */
  /* handler:onReadOnlyStateAssignment */
  ['onReadOnlyStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.pageData, 'EditMode')))

  },
  /* handler:onReadOnlyStateAssignment */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'CurrentlySelectedContactData')), 'Suffix'))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/5-8_Home_Backup/components/ab288c9ed0e835b89a08e4b88e03dc16/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOUserToken'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/5-8_Home_Backup/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var currentUser, storedTokenFromCookie;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['OpenDrawer'] = false;
  storedTokenFromCookie = ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOUserToken'));
  currentUser = (await BackendlessUI.Functions.Custom['fn_fb29ed716ee40c6ec05a6af2fb62b61d'](storedTokenFromCookie));
  if (currentUser != false) {
    ___arguments.context.appData['currentUser'] = currentUser;
    ___arguments.context.pageData['RetrievedContacts'] = (getObjectProperty((await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://mgr.pockethost.io/api/collections/ACCOContacts/records?perPage=25')).set(({ [`Authorization`]: ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOContactsToken')) })).setEncoding('utf8').send()), 'items'));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', (getObjectProperty(___arguments.context.pageData, 'RetrievedContacts')));
    console.log(currentUser);
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('UserLogin', undefined);
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/5-8_Home_Backup/components/54081436bb6842a82788d1d8c2a7dbc1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(getObjectProperty(___arguments.context.appData, 'currentUser'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/5-8_Home_Backup/components/e65831ef35789938da8896bca018c4e8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      localStorage.removeItem('ACCOUserToken');
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('UserLogin', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/5-8_Home_Backup/components/cb980528d6cebac8f0984878c8985798/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(getObjectProperty(___arguments.context.pageData, 'RetrievedContacts'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/5-8_Home_Backup/components/26c848494068ad8874b4b73208376878/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await (async function(TextToCopy) {
  	navigator.clipboard.writeText(TextToCopy);
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5e3f583561b818f8a1786ac80fa77ec8'), 'BusinessPhone')));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9954b1e8ff38cc68d3f769a8c488aa1c'))['color'] = '#A00000';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9954b1e8ff38cc68d3f769a8c488aa1c'))['text-decoration-line'] = 'underline';
  await new Promise(r => setTimeout(r, 400 || 0));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9954b1e8ff38cc68d3f769a8c488aa1c'))['color'] = '#000000';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9954b1e8ff38cc68d3f769a8c488aa1c'))['text-decoration-line'] = 'none';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/5-8_Home_Backup/components/8c26d238ec58efa916980c5156989ff8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('14160948a388f4c82618c6e80fc67fec');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/5-8_Home_Backup/components/9f18306e287839f6b688b2785af8c8ec/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var decision, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'isContactSelected')) == true) {
    console.log(await asyncListFilter(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8')), async (item) => {
       if ((getObjectProperty(item, 'CurrentlySelectedContact')) == true) {
        delete item['CurrentlySelectedContact'];
        decision = true;
      } else {
        decision = true;
      }


     return ;
    }));
  }
  ___arguments.context.pageData['OpenDrawer'] = false;
  ___arguments.context.pageData['CurrentlySelectedContact'] = false;
  ___arguments.context.pageData['CurrentlySelectedContactObjectID'] = '';
  ___arguments.context.pageData['isContactSelected'] = false;
  await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('d5e8e785986ad5d8c618fb16527f9038', undefined);
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bb85878828193def9f8054853f8949b'))['min-height'] = '100%';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/5-8_Home_Backup/components/34b170cf59982968ddc866980023ca7f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var decision, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'isContactSelected')) == true) {
    console.log(await asyncListFilter(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8')), async (item) => {
       if ((getObjectProperty(item, 'CurrentlySelectedContact')) == true) {
        delete item['CurrentlySelectedContact'];
        decision = true;
      } else {
        decision = true;
      }


     return decision;
    }));
    ___arguments.context.pageData['AddScrollDelay'] = false;
  } else {
    ___arguments.context.pageData['AddScrollDelay'] = true;
  }
  ___arguments.context.pageData['OpenDrawer'] = true;
  ___arguments.context.pageData['CurrentlySelectedContact'] = true;
  ___arguments.context.pageData['isContactSelected'] = true;
  ___arguments.context.getComponentDataStoreByUid('f548849959d80918247fdbdd7f982de8')['CurrentlySelectedContact'] = true;
  ___arguments.context.pageData['CurrentlySelectedContactID'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f548849959d80918247fdbdd7f982de8'), 'id'));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bb85878828193def9f8054853f8949b'))['min-height'] = '122%';
  if ((getObjectProperty(___arguments.context.pageData, 'AddScrollDelay')) == true) {
    await new Promise(r => setTimeout(r, 300 || 0));
  }
  (function (component) { component.el.scrollIntoView() })((getObjectProperty(___arguments.context.pageData, (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f548849959d80918247fdbdd7f982de8'), 'id')))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/5-8_Home_Backup/components/d5e8e785986ad5d8c618fb16527f9038/bundle.js', [], () => ({
  /* content */
  /* handler:isOpenLogic */
  ['isOpenLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'OpenDrawer'))

  },
  /* handler:isOpenLogic */
  /* handler:onClose */
  async ['onClose'](___arguments) {
    var decision, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  ___arguments.context.pageData['OpenDrawer'] = false;
  if ((getObjectProperty(___arguments.context.pageData, 'isContactSelected')) == true) {
    console.log(await asyncListFilter(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8')), async (item) => {
       if ((getObjectProperty(item, 'CurrentlySelectedContact')) == true) {
        delete item['CurrentlySelectedContact'];
        decision = true;
      } else {
        decision = true;
      }


     return ;
    }));
  }
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bb85878828193def9f8054853f8949b'))['min-height'] = '100%';
  ___arguments.context.pageData['isContactSelected'] = false;

  },
  /* handler:onClose */
  /* content */
}))

define('./pages/5-8_Home_Backup/components/715ffae88be9507ff0b894488f3f2571/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f548849959d80918247fdbdd7f982de8'), 'CurrentlySelectedContact')) == true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f548849959d80918247fdbdd7f982de8'))['background-color'] = '#990939';
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f548849959d80918247fdbdd7f982de8'))['background-color'] = '#016288';
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/5-8_Home_Backup/components/f548849959d80918247fdbdd7f982de8/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData[(getObjectProperty(___arguments.context.dataModel, 'id'))] = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f548849959d80918247fdbdd7f982de8'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/5-8_Home_Backup/components/c4e88a1ec9685fd8d8c459588a08e548/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f548849959d80918247fdbdd7f982de8'), 'EmailAddress')) != '') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c4e88a1ec9685fd8d8c459588a08e548'))['color'] = '#FFFFFF';
  }

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f548849959d80918247fdbdd7f982de8'), 'EmailAddress')) != '') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c4e88a1ec9685fd8d8c459588a08e548'))['color'] = '#B4B4B4';
  }

  },
  /* handler:onMouseOut */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('3d1800088b7fe3386f380083d4e8b13d')), 'text')) != '') {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/5-8_Home_Backup/components/9a38cdb1fe6889b8853c0d7891b8ca88/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var DBSearchTerm;

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setTimeouts'); if (timerId && timers[timerId]) {    clearTimeout(timers[timerId]);    delete timers[timerId]; }}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setTimeouts'); const timer = setTimeout(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}


  stopSetTimeout('lazySearch');

  ;(function() {
    const callback = async () => {
        ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9048e37ecae67908d8bd408823dce8d8'))['background-color'] = '#A00000';
    DBSearchTerm = ___arguments.value;
    ___arguments.context.pageData['MAKEITWHITE'] = true;
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ee68b608a0ec67383ffecb48626858c8'))['color'] = '#FFFFFF';
    ___arguments.context.appData['ForceSearch'] = true;

    };

    const timerId = 'lazySearch';
    const timerDelay = 1000;

    runSetTimeout(timerId, callback, timerDelay)
  })()
  if (___arguments.value == '') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9048e37ecae67908d8bd408823dce8d8'))['background-color'] = '#F5F5F5';
    ___arguments.context.pageData['MAKEITWHITE'] = false;
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ee68b608a0ec67383ffecb48626858c8'))['color'] = '#AD0505';
    ___arguments.context.appData['ForceSearch'] = false;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9048e37ecae67908d8bd408823dce8d8'))['background-color'] = '#A00000';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9a38cdb1fe6889b8853c0d7891b8ca88'))['color'] = '#FFFFFF';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ee68b608a0ec67383ffecb48626858c8'))['color'] = '#FFFFFF';
    ___arguments.context.pageData['MAKEITWHITE'] = true;
    ___arguments.context.appData['ForceSearch'] = true;
  }
  if (getValueLength(___arguments.value) == 0) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9048e37ecae67908d8bd408823dce8d8'))['background-color'] = '#F5F5F5';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9a38cdb1fe6889b8853c0d7891b8ca88'))['color'] = '#000000';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ee68b608a0ec67383ffecb48626858c8'))['color'] = '#AD0505';
    ___arguments.context.pageData['MAKEITWHITE'] = true;
    ___arguments.context.appData['ForceSearch'] = false;
    stopSetTimeout('lazySearch');
  }

  },
  /* handler:onChange */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    var classList;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'MAKEITWHITE')) == true) {
    classList = ['input-white'];
    console.log(classList);
  } else {
    classList = ['input-black'];
    console.log(classList);
  }
  return classList;

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/5-8_Home_Backup/components/ee68b608a0ec67383ffecb48626858c8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setTimeouts'); if (timerId && timers[timerId]) {    clearTimeout(timers[timerId]);    delete timers[timerId]; }}


  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('9a38cdb1fe6889b8853c0d7891b8ca88'))['value'] = '';
  ___arguments.context.pageData['ForceSearch'] = false;
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9048e37ecae67908d8bd408823dce8d8'))['background-color'] = '#F5F5F5';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ee68b608a0ec67383ffecb48626858c8'))['color'] = '#AD0505';
  ___arguments.context.pageData['MAKEITWHITE'] = false;
  ___arguments.context.pageData['MAKEITBLACK'] = (!(getObjectProperty(___arguments.context.pageData, 'MAKEITWHITE')));
  stopSetTimeout('lazySearch');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/5-8_Home_Backup/components/3a4106331cb86b6899de7db685e6a9f2/bundle.js', [], () => ({
  /* content */
  /* handler:onDelete */
  ['onDelete'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'PageFilter')) == 'Created') {
    ___arguments.context.pageData['PageFilter'] = '';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3a4106331cb86b6899de7db685e6a9f2'))['background-color'] = '#016288';
  }

  },
  /* handler:onDelete */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'PageFilter')) != 'Created') {
    ___arguments.context.pageData['PageFilter'] = 'Created';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3a4106331cb86b6899de7db685e6a9f2'))['background-color'] = '#A00000';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('86684ec8198c47f8c1a80e08638823b6'))['background-color'] = '#016288';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('50d8bec85069e1ce0198f5e8c4670bd8'))['background-color'] = '#016288';
  } else {
    ___arguments.context.pageData['CreatedDirectionDown'] = (!(getObjectProperty(___arguments.context.pageData, 'CreatedDirectionDown')));
    await (async function() {
    	const icon = document.querySelector('.created-chip-class i')

    	if (icon.innerHTML === 'arrow_circle_up') {
    	    icon.innerHTML = 'arrow_circle_down'
    	 } else {
    	    icon.innerHTML = 'arrow_circle_up'
    	 }
    })();
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/5-8_Home_Backup/components/86684ec8198c47f8c1a80e08638823b6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'PageFilter')) != 'Viewed') {
    ___arguments.context.pageData['PageFilter'] = 'Viewed';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3a4106331cb86b6899de7db685e6a9f2'))['background-color'] = '#016288';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('86684ec8198c47f8c1a80e08638823b6'))['background-color'] = '#A00000';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('50d8bec85069e1ce0198f5e8c4670bd8'))['background-color'] = '#016288';
  } else {
    ___arguments.context.pageData['ViewedDirectionDown'] = (!(getObjectProperty(___arguments.context.pageData, 'ViewedDirectionDown')));
    await (async function() {
    	const icon = document.querySelector('.viewed-chip-class i')

    	if (icon.innerHTML === 'arrow_circle_up') {
    	    icon.innerHTML = 'arrow_circle_down'
    	 } else {
    	    icon.innerHTML = 'arrow_circle_up'
    	 }
    })();
  }

  },
  /* handler:onClick */
  /* handler:onDelete */
  ['onDelete'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'PageFilter')) == 'Viewed') {
    ___arguments.context.pageData['PageFilter'] = '';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('86684ec8198c47f8c1a80e08638823b6'))['background-color'] = '#016288';
  }

  },
  /* handler:onDelete */
  /* content */
}))

define('./pages/5-8_Home_Backup/components/50d8bec85069e1ce0198f5e8c4670bd8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'PageFilter')) != 'Modified') {
    ___arguments.context.pageData['PageFilter'] = 'Modified';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3a4106331cb86b6899de7db685e6a9f2'))['background-color'] = '#016288';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('86684ec8198c47f8c1a80e08638823b6'))['background-color'] = '#016288';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('50d8bec85069e1ce0198f5e8c4670bd8'))['background-color'] = '#A00000';
  } else {
    ___arguments.context.pageData['ModifiedDirectionDown'] = (!(getObjectProperty(___arguments.context.pageData, 'ModifiedDirectionDown')));
    await (async function() {
    	const icon = document.querySelector('.modified-chip-class i')

    	if (icon.innerHTML === 'arrow_circle_up') {
    	    icon.innerHTML = 'arrow_circle_down'
    	 } else {
    	    icon.innerHTML = 'arrow_circle_up'
    	 }
    })();
  }

  },
  /* handler:onClick */
  /* handler:onDelete */
  ['onDelete'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'PageFilter')) == 'Modified') {
    ___arguments.context.pageData['PageFilter'] = '';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('50d8bec85069e1ce0198f5e8c4670bd8'))['background-color'] = '#016288';
  }

  },
  /* handler:onDelete */
  /* content */
}))

define('./pages/5-9-b2_Home/components/ab288c9ed0e835b89a08e4b88e03dc16/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOUserToken'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/5-9-b2_Home/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var currentUser, retrievedContactsRawResponse, storedTokenFromCookie;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['RetrievedContactsRawResponse'] = ({  });
  ___arguments.context.pageData['OpenDrawer'] = false;
  ___arguments.context.pageData['DisplayingContactsPageNumber'] = 0;
  storedTokenFromCookie = ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOUserToken'));
  currentUser = (await BackendlessUI.Functions.Custom['fn_fb29ed716ee40c6ec05a6af2fb62b61d'](storedTokenFromCookie));
  if (currentUser != false) {
    ___arguments.context.appData['currentUser'] = currentUser;
    retrievedContactsRawResponse = (await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://mgr.pockethost.io/api/collections/ACCOContacts/records?perPage=25&sort=+LastName,FirstName')).set(({ [`Authorization`]: ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOContactsToken')) })).setEncoding('utf8').send());
    ___arguments.context.pageData['pageCursor'] = 0;
    ___arguments.context.pageData['page'] = (getObjectProperty(retrievedContactsRawResponse, 'page'));
    ___arguments.context.pageData['perPage'] = (getObjectProperty(retrievedContactsRawResponse, 'perPage'));
    ___arguments.context.pageData['totalItems'] = (getObjectProperty(retrievedContactsRawResponse, 'totalItems'));
    ___arguments.context.pageData['totalPages'] = (getObjectProperty(retrievedContactsRawResponse, 'totalPages'));
    console.log('RetrievedContactsRawResponse:');
    console.log(retrievedContactsRawResponse);
    ___arguments.context.pageData['RetrievedContacts'] = (getObjectProperty(retrievedContactsRawResponse, 'items'));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', (getObjectProperty(___arguments.context.pageData, 'RetrievedContacts')));
    console.log(currentUser);
    ___arguments.context.pageData['DisplayingContactsMessage'] = (['Contact: ',(Number((getObjectProperty(___arguments.context.pageData, 'page')))) * (Number((getObjectProperty(___arguments.context.pageData, 'perPage')))),' | Page: ',(getObjectProperty(___arguments.context.pageData, 'page')),' (',(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8'))[0]), 'LastName')),' To ',(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8')).slice(-1)[0]), 'LastName')),') | Total Pages: ',(getObjectProperty(___arguments.context.pageData, 'totalPages')),' | Total Contacts: ',(getObjectProperty(___arguments.context.pageData, 'totalItems'))].join(''));
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('UserLogin', undefined);
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/5-9-b2_Home/components/54081436bb6842a82788d1d8c2a7dbc1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(getObjectProperty(___arguments.context.appData, 'currentUser'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/5-9-b2_Home/components/e65831ef35789938da8896bca018c4e8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      localStorage.removeItem('ACCOUserToken');
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('UserLogin', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/5-9-b2_Home/components/cb980528d6cebac8f0984878c8985798/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(getObjectProperty(___arguments.context.pageData, 'RetrievedContacts'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/5-9-b2_Home/components/26c848494068ad8874b4b73208376878/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await (async function(TextToCopy) {
  	navigator.clipboard.writeText(TextToCopy);
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5e3f583561b818f8a1786ac80fa77ec8'), 'BusinessPhone')));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9954b1e8ff38cc68d3f769a8c488aa1c'))['color'] = '#A00000';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9954b1e8ff38cc68d3f769a8c488aa1c'))['text-decoration-line'] = 'underline';
  await new Promise(r => setTimeout(r, 400 || 0));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9954b1e8ff38cc68d3f769a8c488aa1c'))['color'] = '#000000';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9954b1e8ff38cc68d3f769a8c488aa1c'))['text-decoration-line'] = 'none';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/5-9-b2_Home/components/8c26d238ec58efa916980c5156989ff8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('14160948a388f4c82618c6e80fc67fec');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/5-9-b2_Home/components/9f18306e287839f6b688b2785af8c8ec/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var decision, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'isContactSelected')) == true) {
    console.log(await asyncListFilter(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8')), async (item) => {
       if ((getObjectProperty(item, 'CurrentlySelectedContact')) == true) {
        delete item['CurrentlySelectedContact'];
        decision = true;
      } else {
        decision = true;
      }


     return ;
    }));
  }
  ___arguments.context.pageData['OpenDrawer'] = false;
  ___arguments.context.pageData['CurrentlySelectedContact'] = false;
  ___arguments.context.pageData['CurrentlySelectedContactObjectID'] = '';
  ___arguments.context.pageData['isContactSelected'] = false;
  await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('d5e8e785986ad5d8c618fb16527f9038', undefined);
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bb85878828193def9f8054853f8949b'))['min-height'] = '100%';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/5-9-b2_Home/components/34b170cf59982968ddc866980023ca7f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var decision, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'isContactSelected')) == true) {
    console.log(await asyncListFilter(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8')), async (item) => {
       if ((getObjectProperty(item, 'CurrentlySelectedContact')) == true) {
        delete item['CurrentlySelectedContact'];
        decision = true;
      } else {
        decision = true;
      }


     return decision;
    }));
    ___arguments.context.pageData['AddScrollDelay'] = false;
  } else {
    ___arguments.context.pageData['AddScrollDelay'] = true;
  }
  ___arguments.context.pageData['OpenDrawer'] = true;
  ___arguments.context.pageData['CurrentlySelectedContact'] = true;
  ___arguments.context.pageData['isContactSelected'] = true;
  ___arguments.context.getComponentDataStoreByUid('f548849959d80918247fdbdd7f982de8')['CurrentlySelectedContact'] = true;
  ___arguments.context.pageData['CurrentlySelectedContactID'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f548849959d80918247fdbdd7f982de8'), 'id'));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bb85878828193def9f8054853f8949b'))['min-height'] = '122%';
  if ((getObjectProperty(___arguments.context.pageData, 'AddScrollDelay')) == true) {
    await new Promise(r => setTimeout(r, 300 || 0));
  }
  (function (component) { component.el.scrollIntoView() })((getObjectProperty(___arguments.context.pageData, (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f548849959d80918247fdbdd7f982de8'), 'id')))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/5-9-b2_Home/components/d5e8e785986ad5d8c618fb16527f9038/bundle.js', [], () => ({
  /* content */
  /* handler:isOpenLogic */
  ['isOpenLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'OpenDrawer'))

  },
  /* handler:isOpenLogic */
  /* handler:onClose */
  async ['onClose'](___arguments) {
    var decision, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  ___arguments.context.pageData['OpenDrawer'] = false;
  if ((getObjectProperty(___arguments.context.pageData, 'isContactSelected')) == true) {
    console.log(await asyncListFilter(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8')), async (item) => {
       if ((getObjectProperty(item, 'CurrentlySelectedContact')) == true) {
        delete item['CurrentlySelectedContact'];
        decision = true;
      } else {
        decision = true;
      }


     return ;
    }));
  }
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bb85878828193def9f8054853f8949b'))['min-height'] = '100%';
  ___arguments.context.pageData['isContactSelected'] = false;

  },
  /* handler:onClose */
  /* content */
}))

define('./pages/5-9-b2_Home/components/715ffae88be9507ff0b894488f3f2571/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f548849959d80918247fdbdd7f982de8'), 'CurrentlySelectedContact')) == true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f548849959d80918247fdbdd7f982de8'))['background-color'] = '#990939';
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f548849959d80918247fdbdd7f982de8'))['background-color'] = '#016288';
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/5-9-b2_Home/components/f548849959d80918247fdbdd7f982de8/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData[(getObjectProperty(___arguments.context.dataModel, 'id'))] = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f548849959d80918247fdbdd7f982de8'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/5-9-b2_Home/components/c4e88a1ec9685fd8d8c459588a08e548/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f548849959d80918247fdbdd7f982de8'), 'EmailAddress')) != '') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c4e88a1ec9685fd8d8c459588a08e548'))['color'] = '#FFFFFF';
  }

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f548849959d80918247fdbdd7f982de8'), 'EmailAddress')) != '') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c4e88a1ec9685fd8d8c459588a08e548'))['color'] = '#B4B4B4';
  }

  },
  /* handler:onMouseOut */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('3d1800088b7fe3386f380083d4e8b13d')), 'text')) != '') {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/5-9-b2_Home/components/9a38cdb1fe6889b8853c0d7891b8ca88/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var response, DBSearchTerm, retrievedContacts;

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setTimeouts'); if (timerId && timers[timerId]) {    clearTimeout(timers[timerId]);    delete timers[timerId]; }}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setTimeouts'); const timer = setTimeout(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function Search_Contacts() {
  if ((getObjectProperty(___arguments.context.pageData, 'TOGGLE_IncludeCompany')) == true) {
    retrievedContacts = (getObjectProperty((await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((['https://mgr.pockethost.io/api/collections/ACCOContacts/records?perPage=50&sort=+LastName,FirstName&filter=(','LastName~\'',___arguments.value,'\' || FirstName~\'',___arguments.value,'\' || Company~\'',___arguments.value,'\')'].join('')))).set(({ [`Authorization`]: ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOContactsToken')) })).setEncoding('utf8').send()), 'items'));
    ___arguments.context.pageData['RetrievedContacts'] = retrievedContacts;
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9048e37ecae67908d8bd408823dce8d8'))['background-color'] = '#A00000';
    ___arguments.context.pageData['MAKEITWHITE'] = true;
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ee68b608a0ec67383ffecb48626858c8'))['color'] = '#FFFFFF';
  } else {
    retrievedContacts = (getObjectProperty((await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((['https://mgr.pockethost.io/api/collections/ACCOContacts/records?perPage=50&sort=+LastName,FirstName&filter=(','LastName~\'',___arguments.value,'\' || FirstName~\'',___arguments.value,'\')'].join('')))).set(({ [`Authorization`]: ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOContactsToken')) })).setEncoding('utf8').send()), 'items'));
  }
  return retrievedContacts
}

/**
 * Describe this function...
 */
async function Reset_Search() {
  retrievedContacts = (getObjectProperty((await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((String('https://mgr.pockethost.io/api/collections/ACCOContacts/records?perPage=25&sort=+LastName,FirstName')))).set(({ [`Authorization`]: ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOContactsToken')) })).setEncoding('utf8').send()), 'items'));
  ___arguments.context.pageData['RetrievedContacts'] = retrievedContacts;
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9048e37ecae67908d8bd408823dce8d8'))['background-color'] = '#F5F5F5';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9a38cdb1fe6889b8853c0d7891b8ca88'))['color'] = '#000000';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ee68b608a0ec67383ffecb48626858c8'))['color'] = '#AD0505';
  ___arguments.context.pageData['MAKEITWHITE'] = false;
  ___arguments.context.appData['ForceSearch'] = false;
  return retrievedContacts
}


  stopSetTimeout('lazySearch');

  ;(function() {
    const callback = async () => {
        DBSearchTerm = ___arguments.value;
    ___arguments.context.pageData['DBSearchTerm'] = DBSearchTerm;
    response = await Search_Contacts();
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', response);
    ___arguments.context.appData['ForceSearch'] = true;

    };

    const timerId = 'lazySearch';
    const timerDelay = 1000;

    runSetTimeout(timerId, callback, timerDelay)
  })()
  if (___arguments.value == '') {
    response = await Search_Contacts();
    response = await Reset_Search();
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', response);
    ___arguments.context.appData['ForceSearch'] = false;
    ___arguments.context.pageData['DBSearchTerm'] = '';
  } else {
    response = await Search_Contacts();
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', response);
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9048e37ecae67908d8bd408823dce8d8'))['background-color'] = '#A00000';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9a38cdb1fe6889b8853c0d7891b8ca88'))['color'] = '#FFFFFF';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ee68b608a0ec67383ffecb48626858c8'))['color'] = '#FFFFFF';
    ___arguments.context.pageData['MAKEITWHITE'] = true;
    ___arguments.context.appData['ForceSearch'] = true;
  }
  if (getValueLength(___arguments.value) == 0) {
    ___arguments.context.pageData['DBSearchTerm'] = '';
    stopSetTimeout('lazySearch');
  }

  },
  /* handler:onChange */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    var classList;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'MAKEITWHITE')) == true) {
    classList = ['input-white'];
  } else {
    classList = ['input-black'];
  }
  return classList;

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/5-9-b2_Home/components/ee68b608a0ec67383ffecb48626858c8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var retrievedContacts;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setTimeouts'); if (timerId && timers[timerId]) {    clearTimeout(timers[timerId]);    delete timers[timerId]; }}

/**
 * Describe this function...
 */
async function Reset_Search() {
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', (getObjectProperty((await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((String('https://mgr.pockethost.io/api/collections/ACCOContacts/records?perPage=25&sort=+LastName,FirstName')))).set(({ [`Authorization`]: ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOContactsToken')) })).setEncoding('utf8').send()), 'items')));
  ___arguments.context.pageData['RetrievedContacts'] = retrievedContacts;
}


  await Reset_Search();
  ___arguments.context.pageData['DBSearchTerm'] = '';
  ___arguments.context.pageData['value'] = '';
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('9a38cdb1fe6889b8853c0d7891b8ca88'))['value'] = '';
  ___arguments.context.pageData['ForceSearch'] = false;
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9048e37ecae67908d8bd408823dce8d8'))['background-color'] = '#F5F5F5';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ee68b608a0ec67383ffecb48626858c8'))['color'] = '#AD0505';
  ___arguments.context.pageData['MAKEITWHITE'] = false;
  ___arguments.context.pageData['MAKEITBLACK'] = (!(getObjectProperty(___arguments.context.pageData, 'MAKEITWHITE')));
  stopSetTimeout('lazySearch');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/5-9-b2_Home/components/3a4106331cb86b6899de7db685e6a9f2/bundle.js', [], () => ({
  /* content */
  /* handler:onDelete */
  ['onDelete'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'PageFilter')) == 'Created') {
    ___arguments.context.pageData['PageFilter'] = '';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3a4106331cb86b6899de7db685e6a9f2'))['background-color'] = '#016288';
  }

  },
  /* handler:onDelete */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'PageFilter')) != 'Created') {
    ___arguments.context.pageData['PageFilter'] = 'Created';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3a4106331cb86b6899de7db685e6a9f2'))['background-color'] = '#A00000';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('86684ec8198c47f8c1a80e08638823b6'))['background-color'] = '#016288';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('50d8bec85069e1ce0198f5e8c4670bd8'))['background-color'] = '#016288';
  } else {
    ___arguments.context.pageData['CreatedDirectionDown'] = (!(getObjectProperty(___arguments.context.pageData, 'CreatedDirectionDown')));
    await (async function() {
    	const icon = document.querySelector('.created-chip-class i')

    	if (icon.innerHTML === 'arrow_circle_up') {
    	    icon.innerHTML = 'arrow_circle_down'
    	 } else {
    	    icon.innerHTML = 'arrow_circle_up'
    	 }
    })();
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/5-9-b2_Home/components/86684ec8198c47f8c1a80e08638823b6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'PageFilter')) != 'Viewed') {
    ___arguments.context.pageData['PageFilter'] = 'Viewed';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3a4106331cb86b6899de7db685e6a9f2'))['background-color'] = '#016288';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('86684ec8198c47f8c1a80e08638823b6'))['background-color'] = '#A00000';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('50d8bec85069e1ce0198f5e8c4670bd8'))['background-color'] = '#016288';
  } else {
    ___arguments.context.pageData['ViewedDirectionDown'] = (!(getObjectProperty(___arguments.context.pageData, 'ViewedDirectionDown')));
    await (async function() {
    	const icon = document.querySelector('.viewed-chip-class i')

    	if (icon.innerHTML === 'arrow_circle_up') {
    	    icon.innerHTML = 'arrow_circle_down'
    	 } else {
    	    icon.innerHTML = 'arrow_circle_up'
    	 }
    })();
  }

  },
  /* handler:onClick */
  /* handler:onDelete */
  ['onDelete'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'PageFilter')) == 'Viewed') {
    ___arguments.context.pageData['PageFilter'] = '';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('86684ec8198c47f8c1a80e08638823b6'))['background-color'] = '#016288';
  }

  },
  /* handler:onDelete */
  /* content */
}))

define('./pages/5-9-b2_Home/components/50d8bec85069e1ce0198f5e8c4670bd8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'PageFilter')) != 'Modified') {
    ___arguments.context.pageData['PageFilter'] = 'Modified';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3a4106331cb86b6899de7db685e6a9f2'))['background-color'] = '#016288';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('86684ec8198c47f8c1a80e08638823b6'))['background-color'] = '#016288';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('50d8bec85069e1ce0198f5e8c4670bd8'))['background-color'] = '#A00000';
  } else {
    ___arguments.context.pageData['ModifiedDirectionDown'] = (!(getObjectProperty(___arguments.context.pageData, 'ModifiedDirectionDown')));
    await (async function() {
    	const icon = document.querySelector('.modified-chip-class i')

    	if (icon.innerHTML === 'arrow_circle_up') {
    	    icon.innerHTML = 'arrow_circle_down'
    	 } else {
    	    icon.innerHTML = 'arrow_circle_up'
    	 }
    })();
  }

  },
  /* handler:onClick */
  /* handler:onDelete */
  ['onDelete'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'PageFilter')) == 'Modified') {
    ___arguments.context.pageData['PageFilter'] = '';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('50d8bec85069e1ce0198f5e8c4670bd8'))['background-color'] = '#016288';
  }

  },
  /* handler:onDelete */
  /* content */
}))

define('./pages/5-9-b2_Home/components/c8486c55ffb833b1731c386d281e1628/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var retrievedContacts, results;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function Search_Contacts() {
  if ((getObjectProperty(___arguments.context.pageData, 'TOGGLE_IncludeCompany')) == true) {
    retrievedContacts = (getObjectProperty((await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((['https://mgr.pockethost.io/api/collections/ACCOContacts/records?perPage=50&sort=+LastName,FirstName&filter=(','LastName~\'',(getObjectProperty(___arguments.context.pageData, 'DBSearchTerm')),'\' || FirstName~\'',(getObjectProperty(___arguments.context.pageData, 'DBSearchTerm')),'\' || Company~\'',(getObjectProperty(___arguments.context.pageData, 'DBSearchTerm')),'\')'].join('')))).set(({ [`Authorization`]: ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOContactsToken')) })).setEncoding('utf8').send()), 'items'));
  } else {
    retrievedContacts = (getObjectProperty((await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((['https://mgr.pockethost.io/api/collections/ACCOContacts/records?perPage=50&sort=+LastName,FirstName&filter=(','LastName~\'',(getObjectProperty(___arguments.context.pageData, 'DBSearchTerm')),'\' || FirstName~\'',(getObjectProperty(___arguments.context.pageData, 'DBSearchTerm')),'\')'].join('')))).set(({ [`Authorization`]: ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOContactsToken')) })).setEncoding('utf8').send()), 'items'));
  }
  return retrievedContacts
}


  if (___arguments.value == true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a1a8e4d209da625868a898e85398323e'))['color'] = '#990000';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a1a8e4d209da625868a898e85398323e'))['font-weight'] = 'bold';
    ___arguments.context.pageData['TOGGLE_IncludeCompany'] = true;
    results = await Search_Contacts();
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a1a8e4d209da625868a898e85398323e'))['color'] = '#000000';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a1a8e4d209da625868a898e85398323e'))['font-weight'] = 'normal';
    ___arguments.context.pageData['TOGGLE_IncludeCompany'] = false;
    results = await Search_Contacts();
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', results);

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/5-9-b2_Home/components/96b815b891276784d638d95fab3833cd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var CurrentPageNumber, currentUser, retrievedContactsRawResponse;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  CurrentPageNumber = 0;
  ___arguments.context.pageData['pageCurser'] = 1;
  if (currentUser != false) {
    retrievedContactsRawResponse = (await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((String('https://mgr.pockethost.io/api/collections/ACCOContacts/records?perPage=25&sort=+LastName,FirstName&page=') + String(JSON.stringify((getObjectProperty(___arguments.context.pageData, 'pageCurser'))))))).set(({ [`Authorization`]: ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOContactsToken')) })).setEncoding('utf8').send());
    ___arguments.context.pageData['page'] = (getObjectProperty(retrievedContactsRawResponse, 'page'));
    ___arguments.context.pageData['perPage'] = (getObjectProperty(retrievedContactsRawResponse, 'perPage'));
    ___arguments.context.pageData['totalItems'] = (getObjectProperty(retrievedContactsRawResponse, 'totalItems'));
    ___arguments.context.pageData['totalPages'] = (getObjectProperty(retrievedContactsRawResponse, 'totalPages'));
    console.log('RetrievedContactsRawResponse:');
    console.log(retrievedContactsRawResponse);
    ___arguments.context.pageData['RetrievedContacts'] = (getObjectProperty(retrievedContactsRawResponse, 'items'));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', (getObjectProperty(___arguments.context.pageData, 'RetrievedContacts')));
    ___arguments.context.pageData['DisplayingContactsMessage'] = (['Contact: ',(Number((getObjectProperty(___arguments.context.pageData, 'page')))) * (Number((getObjectProperty(___arguments.context.pageData, 'perPage')))),' | Page: ',(getObjectProperty(___arguments.context.pageData, 'page')),' (',(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8'))[0]), 'LastName')),' To ',(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8')).slice(-1)[0]), 'LastName')),') | Total Pages: ',(getObjectProperty(___arguments.context.pageData, 'totalPages')),' | Total Contacts: ',(getObjectProperty(___arguments.context.pageData, 'totalItems'))].join(''));
    console.log(currentUser);
    ___arguments.context.appData['currentUser'] = currentUser;
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('UserLogin', undefined);
  }
  ___arguments.context.pageData['DisplayingContactsMessage'] = (['Contact: ',(Number((getObjectProperty(___arguments.context.pageData, 'page')))) * (Number((getObjectProperty(___arguments.context.pageData, 'perPage')))),' | Page: ',(getObjectProperty(___arguments.context.pageData, 'page')),' (',(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8'))[0]), 'LastName')),' To ',(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8')).slice(-1)[0]), 'LastName')),') | Total Pages: ',(getObjectProperty(___arguments.context.pageData, 'totalPages')),' | Total Contacts: ',(getObjectProperty(___arguments.context.pageData, 'totalItems'))].join(''));

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'page')) == 1) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('96b815b891276784d638d95fab3833cd'))['background-color'] = '#9A91A6';
    return true;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('96b815b891276784d638d95fab3833cd'))['background-color'] = '#0A0A0A';
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/5-9-b2_Home/components/f1542a58df082559e03864f8db487678/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var CurrentPageNumber, currentUser, retrievedContactsRawResponse, ContactsCountReturn;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['pageCurser'] = ((Number((getObjectProperty(___arguments.context.pageData, 'page')))) - 10);
  if (currentUser != false) {
    retrievedContactsRawResponse = (await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((String('https://mgr.pockethost.io/api/collections/ACCOContacts/records?perPage=25&sort=+LastName,FirstName&page=') + String(JSON.stringify((getObjectProperty(___arguments.context.pageData, 'pageCurser'))))))).set(({ [`Authorization`]: ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOContactsToken')) })).setEncoding('utf8').send());
    ___arguments.context.pageData['page'] = (getObjectProperty(retrievedContactsRawResponse, 'page'));
    ___arguments.context.pageData['perPage'] = (getObjectProperty(retrievedContactsRawResponse, 'perPage'));
    ___arguments.context.pageData['totalItems'] = (getObjectProperty(retrievedContactsRawResponse, 'totalItems'));
    ___arguments.context.pageData['totalPages'] = (getObjectProperty(retrievedContactsRawResponse, 'totalPages'));
    console.log('RetrievedContactsRawResponse:');
    console.log(retrievedContactsRawResponse);
    ___arguments.context.pageData['RetrievedContacts'] = (getObjectProperty(retrievedContactsRawResponse, 'items'));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', (getObjectProperty(___arguments.context.pageData, 'RetrievedContacts')));
    ___arguments.context.pageData['DisplayingContactsMessage'] = (['Contact: ',(Number((getObjectProperty(___arguments.context.pageData, 'page')))) * (Number((getObjectProperty(___arguments.context.pageData, 'perPage')))),' | Page: ',(getObjectProperty(___arguments.context.pageData, 'page')),' (',(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8'))[0]), 'LastName')),' To ',(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8')).slice(-1)[0]), 'LastName')),') | Total Pages: ',(getObjectProperty(___arguments.context.pageData, 'totalPages')),' | Total Contacts: ',(getObjectProperty(___arguments.context.pageData, 'totalItems'))].join(''));
    console.log(currentUser);
    ___arguments.context.appData['currentUser'] = currentUser;
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('UserLogin', undefined);
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'page')) <= 10) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f1542a58df082559e03864f8db487678'))['background-color'] = '#9A91A6';
    return true;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f1542a58df082559e03864f8db487678'))['background-color'] = '#0A0A0A';
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/5-9-b2_Home/components/8df8d2e2bef1ae08efcc44611b5882f1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var currentUser, retrievedContactsRawResponse, ContactsCountReturn, CurrentPageNumber;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['pageCurser'] = ((Number((getObjectProperty(___arguments.context.pageData, 'page')))) + 1);
  if (currentUser != false) {
    retrievedContactsRawResponse = (await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((String('https://mgr.pockethost.io/api/collections/ACCOContacts/records?perPage=25&sort=+LastName,FirstName&page=') + String(JSON.stringify((getObjectProperty(___arguments.context.pageData, 'pageCurser'))))))).set(({ [`Authorization`]: ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOContactsToken')) })).setEncoding('utf8').send());
    ___arguments.context.pageData['page'] = (getObjectProperty(retrievedContactsRawResponse, 'page'));
    ___arguments.context.pageData['perPage'] = (getObjectProperty(retrievedContactsRawResponse, 'perPage'));
    ___arguments.context.pageData['totalItems'] = (getObjectProperty(retrievedContactsRawResponse, 'totalItems'));
    ___arguments.context.pageData['totalPages'] = (getObjectProperty(retrievedContactsRawResponse, 'totalPages'));
    console.log('RetrievedContactsRawResponse:');
    console.log(retrievedContactsRawResponse);
    ___arguments.context.pageData['RetrievedContacts'] = (getObjectProperty(retrievedContactsRawResponse, 'items'));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', (getObjectProperty(___arguments.context.pageData, 'RetrievedContacts')));
    ___arguments.context.pageData['DisplayingContactsMessage'] = (['Contact: ',(Number((getObjectProperty(___arguments.context.pageData, 'page')))) * (Number((getObjectProperty(___arguments.context.pageData, 'perPage')))),' | Page: ',(getObjectProperty(___arguments.context.pageData, 'page')),' (',(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8'))[0]), 'LastName')),' To ',(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8')).slice(-1)[0]), 'LastName')),') | Total Pages: ',(getObjectProperty(___arguments.context.pageData, 'totalPages')),' | Total Contacts: ',(getObjectProperty(___arguments.context.pageData, 'totalItems'))].join(''));
    console.log(currentUser);
    ___arguments.context.appData['currentUser'] = currentUser;
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('UserLogin', undefined);
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'page')) == (Number((getObjectProperty(___arguments.context.pageData, 'totalPages'))))) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('8df8d2e2bef1ae08efcc44611b5882f1'))['background-color'] = '#9A91A6';
    return true;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('8df8d2e2bef1ae08efcc44611b5882f1'))['background-color'] = '#0A0A0A';
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/5-9-b2_Home/components/eb38a9bcb0711288da0800585d081f5a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var currentUser, retrievedContactsRawResponse, ContactsCountReturn, CurrentPageNumber;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['pageCurser'] = ((Number((getObjectProperty(___arguments.context.pageData, 'page')))) - 1);
  if (currentUser != false) {
    retrievedContactsRawResponse = (await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((String('https://mgr.pockethost.io/api/collections/ACCOContacts/records?perPage=25&sort=+LastName,FirstName&page=') + String(JSON.stringify((getObjectProperty(___arguments.context.pageData, 'pageCurser'))))))).set(({ [`Authorization`]: ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOContactsToken')) })).setEncoding('utf8').send());
    ___arguments.context.pageData['page'] = (getObjectProperty(retrievedContactsRawResponse, 'page'));
    ___arguments.context.pageData['perPage'] = (getObjectProperty(retrievedContactsRawResponse, 'perPage'));
    ___arguments.context.pageData['totalItems'] = (getObjectProperty(retrievedContactsRawResponse, 'totalItems'));
    ___arguments.context.pageData['totalPages'] = (getObjectProperty(retrievedContactsRawResponse, 'totalPages'));
    console.log('RetrievedContactsRawResponse:');
    console.log(retrievedContactsRawResponse);
    ___arguments.context.pageData['RetrievedContacts'] = (getObjectProperty(retrievedContactsRawResponse, 'items'));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', (getObjectProperty(___arguments.context.pageData, 'RetrievedContacts')));
    ___arguments.context.pageData['DisplayingContactsMessage'] = (['Contact: ',(Number((getObjectProperty(___arguments.context.pageData, 'page')))) * (Number((getObjectProperty(___arguments.context.pageData, 'perPage')))),' | Page: ',(getObjectProperty(___arguments.context.pageData, 'page')),' (',(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8'))[0]), 'LastName')),' To ',(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8')).slice(-1)[0]), 'LastName')),') | Total Pages: ',(getObjectProperty(___arguments.context.pageData, 'totalPages')),' | Total Contacts: ',(getObjectProperty(___arguments.context.pageData, 'totalItems'))].join(''));
    console.log(currentUser);
    ___arguments.context.appData['currentUser'] = currentUser;
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('UserLogin', undefined);
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'page')) == 1) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('eb38a9bcb0711288da0800585d081f5a'))['background-color'] = '#9A91A6';
    return true;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('eb38a9bcb0711288da0800585d081f5a'))['background-color'] = '#0A0A0A';
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/5-9-b2_Home/components/c38b81a1fde808e224a8dc634857c68a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var currentUser, retrievedContactsRawResponse, ContactsCountReturn, CurrentPageNumber;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['pageCurser'] = ((Number((getObjectProperty(___arguments.context.pageData, 'page')))) + 10);
  if (currentUser != false) {
    retrievedContactsRawResponse = (await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((String('https://mgr.pockethost.io/api/collections/ACCOContacts/records?perPage=25&sort=+LastName,FirstName&page=') + String(JSON.stringify((getObjectProperty(___arguments.context.pageData, 'pageCurser'))))))).set(({ [`Authorization`]: ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOContactsToken')) })).setEncoding('utf8').send());
    ___arguments.context.pageData['page'] = (getObjectProperty(retrievedContactsRawResponse, 'page'));
    ___arguments.context.pageData['perPage'] = (getObjectProperty(retrievedContactsRawResponse, 'perPage'));
    ___arguments.context.pageData['totalItems'] = (getObjectProperty(retrievedContactsRawResponse, 'totalItems'));
    ___arguments.context.pageData['totalPages'] = (getObjectProperty(retrievedContactsRawResponse, 'totalPages'));
    console.log('RetrievedContactsRawResponse:');
    console.log(retrievedContactsRawResponse);
    ___arguments.context.pageData['RetrievedContacts'] = (getObjectProperty(retrievedContactsRawResponse, 'items'));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', (getObjectProperty(___arguments.context.pageData, 'RetrievedContacts')));
    ___arguments.context.pageData['DisplayingContactsMessage'] = (['Contact: ',(Number((getObjectProperty(___arguments.context.pageData, 'page')))) * (Number((getObjectProperty(___arguments.context.pageData, 'perPage')))),' | Page: ',(getObjectProperty(___arguments.context.pageData, 'page')),' (',(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8'))[0]), 'LastName')),' To ',(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8')).slice(-1)[0]), 'LastName')),') | Total Pages: ',(getObjectProperty(___arguments.context.pageData, 'totalPages')),' | Total Contacts: ',(getObjectProperty(___arguments.context.pageData, 'totalItems'))].join(''));
    console.log(currentUser);
    ___arguments.context.appData['currentUser'] = currentUser;
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('UserLogin', undefined);
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'page')) > (Number((getObjectProperty(___arguments.context.pageData, 'totalPages')))) - 10) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c38b81a1fde808e224a8dc634857c68a'))['background-color'] = '#9A91A6';
    return true;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c38b81a1fde808e224a8dc634857c68a'))['background-color'] = '#0A0A0A';
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/5-9-b2_Home/components/3f18a098cf5807a87b084d784a98910c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var currentUser, retrievedContactsRawResponse, CurrentPageNumber;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  CurrentPageNumber = 0;
  ___arguments.context.pageData['pageCurser'] = (Number((getObjectProperty(___arguments.context.pageData, 'totalPages'))));
  if (currentUser != false) {
    retrievedContactsRawResponse = (await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((String('https://mgr.pockethost.io/api/collections/ACCOContacts/records?perPage=25&sort=+LastName,FirstName&page=') + String(JSON.stringify((getObjectProperty(___arguments.context.pageData, 'pageCurser'))))))).set(({ [`Authorization`]: ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOContactsToken')) })).setEncoding('utf8').send());
    ___arguments.context.pageData['page'] = (getObjectProperty(retrievedContactsRawResponse, 'page'));
    ___arguments.context.pageData['perPage'] = (getObjectProperty(retrievedContactsRawResponse, 'perPage'));
    ___arguments.context.pageData['totalItems'] = (getObjectProperty(retrievedContactsRawResponse, 'totalItems'));
    ___arguments.context.pageData['totalPages'] = (getObjectProperty(retrievedContactsRawResponse, 'totalPages'));
    console.log('RetrievedContactsRawResponse:');
    console.log(retrievedContactsRawResponse);
    ___arguments.context.pageData['RetrievedContacts'] = (getObjectProperty(retrievedContactsRawResponse, 'items'));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', (getObjectProperty(___arguments.context.pageData, 'RetrievedContacts')));
    ___arguments.context.pageData['DisplayingContactsMessage'] = (['Contact: ',(Number((getObjectProperty(___arguments.context.pageData, 'page')))) * (Number((getObjectProperty(___arguments.context.pageData, 'perPage')))),' | Page: ',(getObjectProperty(___arguments.context.pageData, 'page')),' (',(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8'))[0]), 'LastName')),' To ',(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8')).slice(-1)[0]), 'LastName')),') | Total Pages: ',(getObjectProperty(___arguments.context.pageData, 'totalPages')),' | Total Contacts: ',(getObjectProperty(___arguments.context.pageData, 'totalItems'))].join(''));
    console.log(currentUser);
    ___arguments.context.appData['currentUser'] = currentUser;
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('UserLogin', undefined);
  }
  ___arguments.context.pageData['DisplayingContactsMessage'] = (['Contact: ',(Number((getObjectProperty(___arguments.context.pageData, 'page')))) * (Number((getObjectProperty(___arguments.context.pageData, 'perPage')))),' | Page: ',(getObjectProperty(___arguments.context.pageData, 'page')),' (',(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8'))[0]), 'LastName')),' To ',(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8')).slice(-1)[0]), 'LastName')),') | Total Pages: ',(getObjectProperty(___arguments.context.pageData, 'totalPages')),' | Total Contacts: ',(getObjectProperty(___arguments.context.pageData, 'totalItems'))].join(''));

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'page')) == (Number((getObjectProperty(___arguments.context.pageData, 'totalPages'))))) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3f18a098cf5807a87b084d784a98910c'))['background-color'] = '#9A91A6';
    return true;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3f18a098cf5807a87b084d784a98910c'))['background-color'] = '#0A0A0A';
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/5-9_Home/components/ab288c9ed0e835b89a08e4b88e03dc16/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOUserToken'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/5-9_Home/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var currentUser, storedTokenFromCookie;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['OpenDrawer'] = false;
  storedTokenFromCookie = ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOUserToken'));
  currentUser = (await BackendlessUI.Functions.Custom['fn_fb29ed716ee40c6ec05a6af2fb62b61d'](storedTokenFromCookie));
  if (currentUser != false) {
    ___arguments.context.appData['currentUser'] = currentUser;
    ___arguments.context.pageData['RetrievedContacts'] = (getObjectProperty((await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://mgr.pockethost.io/api/collections/ACCOContacts/records?perPage=25&sort=+LastName,FirstName')).set(({ [`Authorization`]: ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOContactsToken')) })).setEncoding('utf8').send()), 'items'));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', (getObjectProperty(___arguments.context.pageData, 'RetrievedContacts')));
    console.log(currentUser);
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('UserLogin', undefined);
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/5-9_Home/components/54081436bb6842a82788d1d8c2a7dbc1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(getObjectProperty(___arguments.context.appData, 'currentUser'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/5-9_Home/components/e65831ef35789938da8896bca018c4e8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      localStorage.removeItem('ACCOUserToken');
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('UserLogin', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/5-9_Home/components/cb980528d6cebac8f0984878c8985798/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(getObjectProperty(___arguments.context.pageData, 'RetrievedContacts'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/5-9_Home/components/26c848494068ad8874b4b73208376878/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await (async function(TextToCopy) {
  	navigator.clipboard.writeText(TextToCopy);
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5e3f583561b818f8a1786ac80fa77ec8'), 'BusinessPhone')));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9954b1e8ff38cc68d3f769a8c488aa1c'))['color'] = '#A00000';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9954b1e8ff38cc68d3f769a8c488aa1c'))['text-decoration-line'] = 'underline';
  await new Promise(r => setTimeout(r, 400 || 0));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9954b1e8ff38cc68d3f769a8c488aa1c'))['color'] = '#000000';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9954b1e8ff38cc68d3f769a8c488aa1c'))['text-decoration-line'] = 'none';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/5-9_Home/components/8c26d238ec58efa916980c5156989ff8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('14160948a388f4c82618c6e80fc67fec');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/5-9_Home/components/9f18306e287839f6b688b2785af8c8ec/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var decision, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'isContactSelected')) == true) {
    console.log(await asyncListFilter(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8')), async (item) => {
       if ((getObjectProperty(item, 'CurrentlySelectedContact')) == true) {
        delete item['CurrentlySelectedContact'];
        decision = true;
      } else {
        decision = true;
      }


     return ;
    }));
  }
  ___arguments.context.pageData['OpenDrawer'] = false;
  ___arguments.context.pageData['CurrentlySelectedContact'] = false;
  ___arguments.context.pageData['CurrentlySelectedContactObjectID'] = '';
  ___arguments.context.pageData['isContactSelected'] = false;
  await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('d5e8e785986ad5d8c618fb16527f9038', undefined);
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bb85878828193def9f8054853f8949b'))['min-height'] = '100%';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/5-9_Home/components/34b170cf59982968ddc866980023ca7f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var decision, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'isContactSelected')) == true) {
    console.log(await asyncListFilter(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8')), async (item) => {
       if ((getObjectProperty(item, 'CurrentlySelectedContact')) == true) {
        delete item['CurrentlySelectedContact'];
        decision = true;
      } else {
        decision = true;
      }


     return decision;
    }));
    ___arguments.context.pageData['AddScrollDelay'] = false;
  } else {
    ___arguments.context.pageData['AddScrollDelay'] = true;
  }
  ___arguments.context.pageData['OpenDrawer'] = true;
  ___arguments.context.pageData['CurrentlySelectedContact'] = true;
  ___arguments.context.pageData['isContactSelected'] = true;
  ___arguments.context.getComponentDataStoreByUid('f548849959d80918247fdbdd7f982de8')['CurrentlySelectedContact'] = true;
  ___arguments.context.pageData['CurrentlySelectedContactID'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f548849959d80918247fdbdd7f982de8'), 'id'));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bb85878828193def9f8054853f8949b'))['min-height'] = '122%';
  if ((getObjectProperty(___arguments.context.pageData, 'AddScrollDelay')) == true) {
    await new Promise(r => setTimeout(r, 300 || 0));
  }
  (function (component) { component.el.scrollIntoView() })((getObjectProperty(___arguments.context.pageData, (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f548849959d80918247fdbdd7f982de8'), 'id')))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/5-9_Home/components/d5e8e785986ad5d8c618fb16527f9038/bundle.js', [], () => ({
  /* content */
  /* handler:isOpenLogic */
  ['isOpenLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'OpenDrawer'))

  },
  /* handler:isOpenLogic */
  /* handler:onClose */
  async ['onClose'](___arguments) {
    var decision, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  ___arguments.context.pageData['OpenDrawer'] = false;
  if ((getObjectProperty(___arguments.context.pageData, 'isContactSelected')) == true) {
    console.log(await asyncListFilter(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8')), async (item) => {
       if ((getObjectProperty(item, 'CurrentlySelectedContact')) == true) {
        delete item['CurrentlySelectedContact'];
        decision = true;
      } else {
        decision = true;
      }


     return ;
    }));
  }
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bb85878828193def9f8054853f8949b'))['min-height'] = '100%';
  ___arguments.context.pageData['isContactSelected'] = false;

  },
  /* handler:onClose */
  /* content */
}))

define('./pages/5-9_Home/components/715ffae88be9507ff0b894488f3f2571/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f548849959d80918247fdbdd7f982de8'), 'CurrentlySelectedContact')) == true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f548849959d80918247fdbdd7f982de8'))['background-color'] = '#990939';
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f548849959d80918247fdbdd7f982de8'))['background-color'] = '#016288';
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/5-9_Home/components/f548849959d80918247fdbdd7f982de8/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData[(getObjectProperty(___arguments.context.dataModel, 'id'))] = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f548849959d80918247fdbdd7f982de8'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/5-9_Home/components/c4e88a1ec9685fd8d8c459588a08e548/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f548849959d80918247fdbdd7f982de8'), 'EmailAddress')) != '') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c4e88a1ec9685fd8d8c459588a08e548'))['color'] = '#FFFFFF';
  }

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f548849959d80918247fdbdd7f982de8'), 'EmailAddress')) != '') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c4e88a1ec9685fd8d8c459588a08e548'))['color'] = '#B4B4B4';
  }

  },
  /* handler:onMouseOut */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('3d1800088b7fe3386f380083d4e8b13d')), 'text')) != '') {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/5-9_Home/components/9a38cdb1fe6889b8853c0d7891b8ca88/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var response, DBSearchTerm, retrievedContacts;

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setTimeouts'); if (timerId && timers[timerId]) {    clearTimeout(timers[timerId]);    delete timers[timerId]; }}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setTimeouts'); const timer = setTimeout(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function Search_Contacts() {
  if ((getObjectProperty(___arguments.context.pageData, 'TOGGLE_IncludeCompany')) == true) {
    retrievedContacts = (getObjectProperty((await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((['https://mgr.pockethost.io/api/collections/ACCOContacts/records?perPage=50&sort=+LastName,FirstName&filter=(','LastName~\'',___arguments.value,'\' || FirstName~\'',___arguments.value,'\' || Company~\'',___arguments.value,'\')'].join('')))).set(({ [`Authorization`]: ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOContactsToken')) })).setEncoding('utf8').send()), 'items'));
    ___arguments.context.pageData['RetrievedContacts'] = retrievedContacts;
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9048e37ecae67908d8bd408823dce8d8'))['background-color'] = '#A00000';
    ___arguments.context.pageData['MAKEITWHITE'] = true;
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ee68b608a0ec67383ffecb48626858c8'))['color'] = '#FFFFFF';
  } else {
    retrievedContacts = (getObjectProperty((await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((['https://mgr.pockethost.io/api/collections/ACCOContacts/records?perPage=50&sort=+LastName,FirstName&filter=(','LastName~\'',___arguments.value,'\' || FirstName~\'',___arguments.value,'\')'].join('')))).set(({ [`Authorization`]: ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOContactsToken')) })).setEncoding('utf8').send()), 'items'));
  }
  return retrievedContacts
}

/**
 * Describe this function...
 */
async function Reset_Search() {
  retrievedContacts = (getObjectProperty((await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((String('https://mgr.pockethost.io/api/collections/ACCOContacts/records?perPage=25&sort=+LastName,FirstName')))).set(({ [`Authorization`]: ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOContactsToken')) })).setEncoding('utf8').send()), 'items'));
  ___arguments.context.pageData['RetrievedContacts'] = retrievedContacts;
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9048e37ecae67908d8bd408823dce8d8'))['background-color'] = '#F5F5F5';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9a38cdb1fe6889b8853c0d7891b8ca88'))['color'] = '#000000';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ee68b608a0ec67383ffecb48626858c8'))['color'] = '#AD0505';
  ___arguments.context.pageData['MAKEITWHITE'] = false;
  ___arguments.context.appData['ForceSearch'] = false;
  return retrievedContacts
}


  stopSetTimeout('lazySearch');

  ;(function() {
    const callback = async () => {
        DBSearchTerm = ___arguments.value;
    ___arguments.context.pageData['DBSearchTerm'] = DBSearchTerm;
    response = await Search_Contacts();
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', response);
    ___arguments.context.appData['ForceSearch'] = true;

    };

    const timerId = 'lazySearch';
    const timerDelay = 1000;

    runSetTimeout(timerId, callback, timerDelay)
  })()
  if (___arguments.value == '') {
    response = await Search_Contacts();
    response = await Reset_Search();
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', response);
    ___arguments.context.appData['ForceSearch'] = false;
    ___arguments.context.pageData['DBSearchTerm'] = '';
  } else {
    response = await Search_Contacts();
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', response);
    ___arguments.context.appData['ForceSearch'] = true;
  }
  if (getValueLength(___arguments.value) == 0) {
    ___arguments.context.pageData['DBSearchTerm'] = '';
    stopSetTimeout('lazySearch');
  }

  },
  /* handler:onChange */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    var classList;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'MAKEITWHITE')) == true) {
    classList = ['input-white'];
  } else {
    classList = ['input-black'];
  }
  return classList;

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/5-9_Home/components/ee68b608a0ec67383ffecb48626858c8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var retrievedContacts;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setTimeouts'); if (timerId && timers[timerId]) {    clearTimeout(timers[timerId]);    delete timers[timerId]; }}

/**
 * Describe this function...
 */
async function Reset_Search() {
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', (getObjectProperty((await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((String('https://mgr.pockethost.io/api/collections/ACCOContacts/records?perPage=25&sort=+LastName,FirstName')))).set(({ [`Authorization`]: ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOContactsToken')) })).setEncoding('utf8').send()), 'items')));
  ___arguments.context.pageData['RetrievedContacts'] = retrievedContacts;
}


  await Reset_Search();
  ___arguments.context.pageData['DBSearchTerm'] = '';
  ___arguments.context.pageData['value'] = '';
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('9a38cdb1fe6889b8853c0d7891b8ca88'))['value'] = '';
  ___arguments.context.pageData['ForceSearch'] = false;
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9048e37ecae67908d8bd408823dce8d8'))['background-color'] = '#F5F5F5';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ee68b608a0ec67383ffecb48626858c8'))['color'] = '#AD0505';
  ___arguments.context.pageData['MAKEITWHITE'] = false;
  ___arguments.context.pageData['MAKEITBLACK'] = (!(getObjectProperty(___arguments.context.pageData, 'MAKEITWHITE')));
  stopSetTimeout('lazySearch');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/5-9_Home/components/3a4106331cb86b6899de7db685e6a9f2/bundle.js', [], () => ({
  /* content */
  /* handler:onDelete */
  ['onDelete'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'PageFilter')) == 'Created') {
    ___arguments.context.pageData['PageFilter'] = '';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3a4106331cb86b6899de7db685e6a9f2'))['background-color'] = '#016288';
  }

  },
  /* handler:onDelete */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'PageFilter')) != 'Created') {
    ___arguments.context.pageData['PageFilter'] = 'Created';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3a4106331cb86b6899de7db685e6a9f2'))['background-color'] = '#A00000';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('86684ec8198c47f8c1a80e08638823b6'))['background-color'] = '#016288';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('50d8bec85069e1ce0198f5e8c4670bd8'))['background-color'] = '#016288';
  } else {
    ___arguments.context.pageData['CreatedDirectionDown'] = (!(getObjectProperty(___arguments.context.pageData, 'CreatedDirectionDown')));
    await (async function() {
    	const icon = document.querySelector('.created-chip-class i')

    	if (icon.innerHTML === 'arrow_circle_up') {
    	    icon.innerHTML = 'arrow_circle_down'
    	 } else {
    	    icon.innerHTML = 'arrow_circle_up'
    	 }
    })();
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/5-9_Home/components/86684ec8198c47f8c1a80e08638823b6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'PageFilter')) != 'Viewed') {
    ___arguments.context.pageData['PageFilter'] = 'Viewed';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3a4106331cb86b6899de7db685e6a9f2'))['background-color'] = '#016288';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('86684ec8198c47f8c1a80e08638823b6'))['background-color'] = '#A00000';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('50d8bec85069e1ce0198f5e8c4670bd8'))['background-color'] = '#016288';
  } else {
    ___arguments.context.pageData['ViewedDirectionDown'] = (!(getObjectProperty(___arguments.context.pageData, 'ViewedDirectionDown')));
    await (async function() {
    	const icon = document.querySelector('.viewed-chip-class i')

    	if (icon.innerHTML === 'arrow_circle_up') {
    	    icon.innerHTML = 'arrow_circle_down'
    	 } else {
    	    icon.innerHTML = 'arrow_circle_up'
    	 }
    })();
  }

  },
  /* handler:onClick */
  /* handler:onDelete */
  ['onDelete'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'PageFilter')) == 'Viewed') {
    ___arguments.context.pageData['PageFilter'] = '';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('86684ec8198c47f8c1a80e08638823b6'))['background-color'] = '#016288';
  }

  },
  /* handler:onDelete */
  /* content */
}))

define('./pages/5-9_Home/components/50d8bec85069e1ce0198f5e8c4670bd8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'PageFilter')) != 'Modified') {
    ___arguments.context.pageData['PageFilter'] = 'Modified';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3a4106331cb86b6899de7db685e6a9f2'))['background-color'] = '#016288';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('86684ec8198c47f8c1a80e08638823b6'))['background-color'] = '#016288';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('50d8bec85069e1ce0198f5e8c4670bd8'))['background-color'] = '#A00000';
  } else {
    ___arguments.context.pageData['ModifiedDirectionDown'] = (!(getObjectProperty(___arguments.context.pageData, 'ModifiedDirectionDown')));
    await (async function() {
    	const icon = document.querySelector('.modified-chip-class i')

    	if (icon.innerHTML === 'arrow_circle_up') {
    	    icon.innerHTML = 'arrow_circle_down'
    	 } else {
    	    icon.innerHTML = 'arrow_circle_up'
    	 }
    })();
  }

  },
  /* handler:onClick */
  /* handler:onDelete */
  ['onDelete'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'PageFilter')) == 'Modified') {
    ___arguments.context.pageData['PageFilter'] = '';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('50d8bec85069e1ce0198f5e8c4670bd8'))['background-color'] = '#016288';
  }

  },
  /* handler:onDelete */
  /* content */
}))

define('./pages/5-9_Home/components/c8486c55ffb833b1731c386d281e1628/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var retrievedContacts, results;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function Search_Contacts() {
  if ((getObjectProperty(___arguments.context.pageData, 'TOGGLE_IncludeCompany')) == true) {
    retrievedContacts = (getObjectProperty((await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((['https://mgr.pockethost.io/api/collections/ACCOContacts/records?perPage=50&sort=+LastName,FirstName&filter=(','LastName~\'',(getObjectProperty(___arguments.context.pageData, 'DBSearchTerm')),'\' || FirstName~\'',(getObjectProperty(___arguments.context.pageData, 'DBSearchTerm')),'\' || Company~\'',(getObjectProperty(___arguments.context.pageData, 'DBSearchTerm')),'\')'].join('')))).set(({ [`Authorization`]: ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOContactsToken')) })).setEncoding('utf8').send()), 'items'));
  } else {
    retrievedContacts = (getObjectProperty((await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((['https://mgr.pockethost.io/api/collections/ACCOContacts/records?perPage=50&sort=+LastName,FirstName&filter=(','LastName~\'',(getObjectProperty(___arguments.context.pageData, 'DBSearchTerm')),'\' || FirstName~\'',(getObjectProperty(___arguments.context.pageData, 'DBSearchTerm')),'\')'].join('')))).set(({ [`Authorization`]: ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOContactsToken')) })).setEncoding('utf8').send()), 'items'));
  }
  return retrievedContacts
}


  if (___arguments.value == true) {
    ___arguments.context.pageData['TOGGLE_IncludeCompany'] = true;
    results = await Search_Contacts();
  } else {
    ___arguments.context.pageData['TOGGLE_IncludeCompany'] = false;
    results = await Search_Contacts();
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', results);

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/AdminLogin/components/85dae34486144e2efa2d934bfdddb172/bundle.js', [], () => ({
  /* content */

  /* handler:onSubmit */
  async ['onSubmit'](___arguments) {
    var error, password, username, user, stayLoggedIn, logging, buttonLogin;

/**
 * Describe this function...
 */
async function login() {
  try {
    user = (await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://mgr.pockethost.io/api/collections/_superusers/auth-with-password')).setEncoding('utf8').send(({ [`identity`]: username,[`password`]: password })));

  } catch (error) {
    await setError(error);

  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function setError(error) {
  ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('85dae34486144e2efa2d934bfdddb172'))['error'] = error;
}

/**
 * Describe this function...
 */
async function updateButtonLogin(logging) {
  buttonLogin = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('db5546014b7940ad8771a98d85f83036'));
  buttonLogin['label'] = (logging ? 'Please wait...' : 'Login');
  buttonLogin['disabled'] = logging;
}


  await setError(null);
  username = (getObjectProperty(___arguments.context.dataModel, 'username'));
  password = (getObjectProperty(___arguments.context.dataModel, 'password'));
  stayLoggedIn = (getObjectProperty(___arguments.context.dataModel, 'stayLoggedIn'));
  if (username && password) {
    await updateButtonLogin(true);
    try {
      await login();

    } catch (error) {
      if ((getObjectProperty(error, 'code')) == 3033) {
        await login();
      } else {
        await setError(error);
      }

    } finally {
      console.log(user);
      await updateButtonLogin(false);

    }
  } else {
    await setError((new Error('Username and Password must be filled')));
  }
  if (user) {
    ___arguments.context.appData['currentUser'] = user;
    localStorage.setItem('ACCOUserToken', JSON.stringify((getObjectProperty(user, 'token'))));
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('home', undefined);
  } else {
  }

  },
  /* handler:onSubmit *//* content */
}));

define('./pages/AdminLogin/components/64b59d8dc76823be042c2c89daf855b8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('UserLogin', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/UserLogin/components/85dae34486144e2efa2d934bfdddb172/bundle.js', [], () => ({
  /* content */

  /* handler:onSubmit */
  async ['onSubmit'](___arguments) {
    var error, password, username, user, stayLoggedIn, logging, buttonLogin;

/**
 * Describe this function...
 */
async function login() {
  try {
    user = (await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://mgr.pockethost.io/api/collections/Users/auth-with-password')).setEncoding('utf8').send(({ [`identity`]: username,[`password`]: password })));

  } catch (error) {
    await setError(error);

  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function setError(error) {
  ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('85dae34486144e2efa2d934bfdddb172'))['error'] = error;
}

/**
 * Describe this function...
 */
async function updateButtonLogin(logging) {
  buttonLogin = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('db5546014b7940ad8771a98d85f83036'));
  buttonLogin['label'] = (logging ? 'Please wait...' : 'Login');
  buttonLogin['disabled'] = logging;
}


  await setError(null);
  username = (getObjectProperty(___arguments.context.dataModel, 'username'));
  password = (getObjectProperty(___arguments.context.dataModel, 'password'));
  stayLoggedIn = (getObjectProperty(___arguments.context.dataModel, 'stayLoggedIn'));
  if (username && password) {
    await updateButtonLogin(true);
    try {
      await login();

    } catch (error) {
      if ((getObjectProperty(error, 'code')) == 3033) {
        await login();
      } else {
        await setError(error);
      }

    } finally {
      console.log(user);
      await updateButtonLogin(false);

    }
  } else {
    await setError((new Error('Username and Password must be filled')));
  }
  if (user) {
    console.log(user);
    ___arguments.context.appData['currentUser'] = user;
    localStorage.setItem('ACCOUserToken', JSON.stringify((getObjectProperty(user, 'token'))));
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('home', undefined);
  } else {
  }

  },
  /* handler:onSubmit *//* content */
}));

define('./pages/UserLogin/components/14e8a602134817c5db4e4cdf73f8ec18/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('AdminLogin', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/home/components/ab288c9ed0e835b89a08e4b88e03dc16/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOUserToken'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/home/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var currentUser, retrievedContactsRawResponse, storedTokenFromCookie;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function Set_pageData_Variables() {
  ___arguments.context.pageData['drawerDataModel'] = ({  });
  ___arguments.context.pageData['RetrievedContactsRawResponse'] = ({  });
  ___arguments.context.pageData['OpenDrawer'] = false;
  ___arguments.context.pageData['DisplayingContactsPageNumber'] = 0;
  ___arguments.context.pageData['ContactsModifiedOnPage'] = 0;
  ___arguments.context.pageData['BlockerDivVisible'] = false;
}


  await Set_pageData_Variables();
  storedTokenFromCookie = ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOUserToken'));
  currentUser = (await BackendlessUI.Functions.Custom['fn_fb29ed716ee40c6ec05a6af2fb62b61d'](storedTokenFromCookie));
  if (currentUser != false) {
    ___arguments.context.appData['currentUser'] = currentUser;
    retrievedContactsRawResponse = (await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://mgr.pockethost.io/api/collections/ACCOContacts/records?perPage=25&sort=+LastName,FirstName')).set(({ [`Authorization`]: ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOUserToken')) })).setEncoding('utf8').send());
    ___arguments.context.appData['DarkMode'] = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'currentUser')), 'record')), 'DarkMode'));
    ___arguments.context.pageData['pageCursor'] = 0;
    ___arguments.context.pageData['page'] = (getObjectProperty(retrievedContactsRawResponse, 'page'));
    ___arguments.context.pageData['perPage'] = (getObjectProperty(retrievedContactsRawResponse, 'perPage'));
    ___arguments.context.pageData['totalItems'] = (getObjectProperty(retrievedContactsRawResponse, 'totalItems'));
    ___arguments.context.pageData['totalPages'] = (getObjectProperty(retrievedContactsRawResponse, 'totalPages'));
    console.log('RetrievedContactsRawResponse:');
    console.log(retrievedContactsRawResponse);
    ___arguments.context.pageData['RetrievedContacts'] = (getObjectProperty(retrievedContactsRawResponse, 'items'));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', (getObjectProperty(___arguments.context.pageData, 'RetrievedContacts')));
    console.log(currentUser);
    ___arguments.context.pageData['DisplayingContactsMessage'] = (['Contact: ',(Number((getObjectProperty(___arguments.context.pageData, 'page')))) * (Number((getObjectProperty(___arguments.context.pageData, 'perPage')))),' | Page: ',(getObjectProperty(___arguments.context.pageData, 'page')),' (',(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8'))[0]), 'LastName')),' To ',(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8')).slice(-1)[0]), 'LastName')),') | Total Pages: ',(getObjectProperty(___arguments.context.pageData, 'totalPages')),' | Total Contacts: ',(getObjectProperty(___arguments.context.pageData, 'totalItems'))].join(''));
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('UserLogin', undefined);
  }

  },
  /* handler:onEnter */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'DarkMode')) ? ['easeInAndOut', 'darkMode'] : ['easeInAndOut', 'normalMode'])

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/home/components/54081436bb6842a82788d1d8c2a7dbc1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(JSON.parse((JSON.stringify((getObjectProperty(___arguments.context.appData, 'currentUser'))))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/home/components/e65831ef35789938da8896bca018c4e8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      localStorage.removeItem('ACCOUserToken');
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('UserLogin', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/home/components/cb980528d6cebac8f0984878c8985798/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(getObjectProperty(___arguments.context.pageData, 'RetrievedContacts'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/home/components/26c848494068ad8874b4b73208376878/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await (async function(TextToCopy) {
  	navigator.clipboard.writeText(TextToCopy);
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5e3f583561b818f8a1786ac80fa77ec8'), 'BusinessPhone')));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9954b1e8ff38cc68d3f769a8c488aa1c'))['color'] = '#A00000';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9954b1e8ff38cc68d3f769a8c488aa1c'))['text-decoration-line'] = 'underline';
  await new Promise(r => setTimeout(r, 400 || 0));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9954b1e8ff38cc68d3f769a8c488aa1c'))['color'] = '#000000';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9954b1e8ff38cc68d3f769a8c488aa1c'))['text-decoration-line'] = 'none';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/home/components/8c26d238ec58efa916980c5156989ff8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('14160948a388f4c82618c6e80fc67fec');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/home/components/9f18306e287839f6b688b2785af8c8ec/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var decision, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'isContactSelected')) == true) {
    console.log(await asyncListFilter(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8')), async (item) => {
       if ((getObjectProperty(item, 'CurrentlySelectedContact')) == true) {
        delete item['CurrentlySelectedContact'];
        decision = true;
      } else {
        decision = true;
      }


     return ;
    }));
  }
  ___arguments.context.pageData['OpenDrawer'] = false;
  ___arguments.context.pageData['CurrentlySelectedContact'] = false;
  ___arguments.context.pageData['CurrentlySelectedContactObjectID'] = '';
  ___arguments.context.pageData['isContactSelected'] = false;
  ___arguments.context.pageData['EditMode'] = false;
  await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('d5e8e785986ad5d8c618fb16527f9038', undefined);
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bb85878828193def9f8054853f8949b'))['min-height'] = '100%';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/home/components/34b170cf59982968ddc866980023ca7f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var decision, item, stripOutSelectedContacts;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function Set_pageData_Variables() {
  ___arguments.context.pageData['AddScrollDelay'] = true;
  ___arguments.context.pageData['OpenDrawer'] = true;
  ___arguments.context.pageData['CurrentlySelectedContact'] = true;
  ___arguments.context.pageData['isContactSelected'] = true;
  ___arguments.context.getComponentDataStoreByUid('f548849959d80918247fdbdd7f982de8')['CurrentlySelectedContact'] = true;
  ___arguments.context.pageData['CurrentlySelectedContactID'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f548849959d80918247fdbdd7f982de8'), 'id'));
  ___arguments.context.pageData['CurrentlySelectedContactData'] = (JSON.parse((JSON.stringify(___arguments.context.getComponentDataStoreByUid('f548849959d80918247fdbdd7f982de8')))));
}


  if ((getObjectProperty(___arguments.context.pageData, 'isContactSelected')) == true) {
    stripOutSelectedContacts = (await asyncListFilter(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8')), async (item) => {
       if ((getObjectProperty(item, 'CurrentlySelectedContact')) == true) {
        delete item['CurrentlySelectedContact'];
        decision = true;
      } else {
        decision = true;
      }


     return decision;
    }));
  }
  await Set_pageData_Variables();
  console.log('Pushing selected contact to pageData.drawerDataModel');
  console.log(JSON.parse((JSON.stringify(___arguments.context.getComponentDataStoreByUid('f548849959d80918247fdbdd7f982de8')))));
  ___arguments.context.pageData['drawerDataModel'] = (JSON.parse((JSON.stringify(___arguments.context.getComponentDataStoreByUid('f548849959d80918247fdbdd7f982de8')))));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bb85878828193def9f8054853f8949b'))['min-height'] = '125%';
  await (async function() {
  	const elements = document.getElementsByClassName('MainContactsRow');
  	const currentHeight = elements[0].clientHeight; // Get the current height
  	newHeight = currentHeight
  	
  	// newHeight = currentHeight * (1 + percentageIncrease / 100); // Calculate new height
  	if (newHeight < 1150) {
  	  newHeight = 1150;
  	}
  	elements[0].style.minHeight = newHeight + 'px'; // Set the new height
  	// alert('The current height is: '+ currentHeight);

  })();
  (function (component) { component.el.scrollIntoView() })((getObjectProperty(___arguments.context.pageData, (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f548849959d80918247fdbdd7f982de8'), 'id')))));

  },
  /* handler:onClick */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f548849959d80918247fdbdd7f982de8'), 'FirstName')),' ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f548849959d80918247fdbdd7f982de8'), 'LastName'))].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/home/components/d5e8e785986ad5d8c618fb16527f9038/bundle.js', [], () => ({
  /* content */
  /* handler:isOpenLogic */
  ['isOpenLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'OpenDrawer'))

  },
  /* handler:isOpenLogic */
  /* handler:onClose */
  async ['onClose'](___arguments) {
    var currentCount, item, listCount, result, decision;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  ___arguments.context.pageData['OpenDrawer'] = false;
  if ((getObjectProperty(___arguments.context.pageData, 'isContactSelected')) == true) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', (JSON.parse((JSON.stringify((await asyncListFilter(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8')), async (item) => {
       if ((getObjectProperty(item, 'CurrentlySelectedContact')) == true) {
        delete item['CurrentlySelectedContact'];
        decision = true;
      } else {
        decision = true;
      }


     return decision;
    })))))));
  }
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bb85878828193def9f8054853f8949b'))['height'] = 'auto';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bb85878828193def9f8054853f8949b'))['min-height'] = 'auto';
  ___arguments.context.pageData['isContactSelected'] = false;
  if (((getObjectProperty(___arguments.context.pageData, 'EditMode')) || (getObjectProperty(___arguments.context.pageData, 'AdminEditMode'))) == true) {
    result = (await (async function(modifiedData) {
    	var userPreference;
    	
    	if (modifiedData) {
    	
    	  if (confirm("Save your changes? [Enter] to save or [Esc] to cancel") == true) {
    	    userPreference = "Save Requested";
    	  } else {
    	    userPreference = "Save Cancelled!";
    	  }
    	// console.log(userPreference)
    	return userPreference
    	  
    	}

    })((getObjectProperty(___arguments.context.pageData, 'ModifiedData'))));
    if (result == 'Save Requested') {
      console.log('Save Data Requested');
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', (JSON.parse((JSON.stringify((await asyncListFilter(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8')), async (item) => {
         if ((getObjectProperty(item, 'id')) == (getObjectProperty(___arguments.context.pageData, 'CurrentlySelectedContactID'))) {
          item['NeedToSave'] = true;
          item['FirstName'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'drawerDataModel')), 'FirstName'));
          item['MiddleName'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'drawerDataModel')), 'MiddleName'));
          item['LastName'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'drawerDataModel')), 'LastName'));
          item['Suffix'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'drawerDataModel')), 'Suffix'));
          item['Company'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'drawerDataModel')), 'Company'));
          item['BusinessStreet'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'drawerDataModel')), 'BusinessStreet'));
          item['BusinessCity'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'drawerDataModel')), 'BusinessCity'));
          item['BusinessState'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'drawerDataModel')), 'BusinessState'));
          item['BusinessPostalCode'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'drawerDataModel')), 'BusinessPostalCode'));
          item['EmailAddress'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'drawerDataModel')), 'EmailAddress'));
          item['EmailAddress2'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'drawerDataModel')), 'EmailAddress2'));
          item['BusinessPhone'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'drawerDataModel')), 'BusinessPhone'));
          item['BusinessPhone2'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'drawerDataModel')), 'BusinessPhone2'));
          item['MobilePhone'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'drawerDataModel')), 'MobilePhone'));
          return true;
        } else {
          return true;
        }


       return item;
      })))))));
      ___arguments.context.pageData['BlockerDivVisible'] = true;
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ac384c2fae874c589bd87f588a6bdbc8'))['min-height'] = 157;
    } else {
      console.log('Save Data Cancelled!');
    }
    currentCount = 0;
    listCount = (await asyncListFilter(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8')), async (item) => {
       if ((getObjectProperty(item, 'NeedToSave')) == true) {
        currentCount = currentCount + 1;
      }


     return currentCount;
    }));
    ___arguments.context.pageData['ContactsModifiedOnPage'] = currentCount;
    ___arguments.context.pageData['ModifiedData'] = false;
  }
  if ((getObjectProperty(___arguments.context.pageData, 'AdminEditMode')) != true) {
    if ((getObjectProperty(___arguments.context.pageData, 'EditMode')) == true) {
      ___arguments.context.pageData['EditMode'] = false;
    }
  }

  },
  /* handler:onClose */
  /* handler:onOpen */
  ['onOpen'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'AdminEditMode')) == true) {
    ___arguments.context.pageData['EditMode'] = true;
  }

  },
  /* handler:onOpen */
  /* content */
}))

define('./pages/home/components/715ffae88be9507ff0b894488f3f2571/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f548849959d80918247fdbdd7f982de8'), 'CurrentlySelectedContact')) == true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f548849959d80918247fdbdd7f982de8'))['background-color'] = '#990939';
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f548849959d80918247fdbdd7f982de8'))['background-color'] = '#016288';
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/home/components/f548849959d80918247fdbdd7f982de8/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData[(getObjectProperty(___arguments.context.dataModel, 'id'))] = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f548849959d80918247fdbdd7f982de8'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/home/components/c4e88a1ec9685fd8d8c459588a08e548/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f548849959d80918247fdbdd7f982de8'), 'EmailAddress')) != '') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c4e88a1ec9685fd8d8c459588a08e548'))['color'] = '#FFFFFF';
  }

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f548849959d80918247fdbdd7f982de8'), 'EmailAddress')) != '') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c4e88a1ec9685fd8d8c459588a08e548'))['color'] = '#B4B4B4';
  }

  },
  /* handler:onMouseOut */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('3d1800088b7fe3386f380083d4e8b13d')), 'text')) != '') {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/home/components/9a38cdb1fe6889b8853c0d7891b8ca88/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var response, DBSearchTerm, retrievedContacts;

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setTimeouts'); if (timerId && timers[timerId]) {    clearTimeout(timers[timerId]);    delete timers[timerId]; }}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setTimeouts'); const timer = setTimeout(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function Search_Contacts() {
  if ((getObjectProperty(___arguments.context.pageData, 'TOGGLE_IncludeCompany')) == true) {
    retrievedContacts = (getObjectProperty((await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((['https://mgr.pockethost.io/api/collections/ACCOContacts/records?perPage=50&sort=+LastName,FirstName&filter=(','LastName~\'',___arguments.value,'\' || FirstName~\'',___arguments.value,'\' || Company~\'',___arguments.value,'\')'].join('')))).set(({ [`Authorization`]: ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOUserToken')) })).setEncoding('utf8').send()), 'items'));
    ___arguments.context.pageData['RetrievedContacts'] = retrievedContacts;
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9048e37ecae67908d8bd408823dce8d8'))['background-color'] = '#A00000';
    ___arguments.context.pageData['MAKEITWHITE'] = true;
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ee68b608a0ec67383ffecb48626858c8'))['color'] = '#FFFFFF';
  } else {
    retrievedContacts = (getObjectProperty((await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((['https://mgr.pockethost.io/api/collections/ACCOContacts/records?perPage=50&sort=+LastName,FirstName&filter=(','LastName~\'',___arguments.value,'\' || FirstName~\'',___arguments.value,'\')'].join('')))).set(({ [`Authorization`]: ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOUserToken')) })).setEncoding('utf8').send()), 'items'));
  }
  return retrievedContacts
}

/**
 * Describe this function...
 */
async function Reset_Search() {
  retrievedContacts = (getObjectProperty((await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((String('https://mgr.pockethost.io/api/collections/ACCOContacts/records?perPage=25&sort=+LastName,FirstName')))).set(({ [`Authorization`]: ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOUserToken')) })).setEncoding('utf8').send()), 'items'));
  ___arguments.context.pageData['RetrievedContacts'] = retrievedContacts;
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9048e37ecae67908d8bd408823dce8d8'))['background-color'] = '#F5F5F5';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9a38cdb1fe6889b8853c0d7891b8ca88'))['color'] = '#000000';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ee68b608a0ec67383ffecb48626858c8'))['color'] = '#AD0505';
  ___arguments.context.pageData['MAKEITWHITE'] = false;
  ___arguments.context.appData['ForceSearch'] = false;
  return retrievedContacts
}


  stopSetTimeout('lazySearch');

  ;(function() {
    const callback = async () => {
        DBSearchTerm = ___arguments.value;
    ___arguments.context.pageData['DBSearchTerm'] = DBSearchTerm;
    response = await Search_Contacts();
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', ({  }));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', response);
    ___arguments.context.appData['ForceSearch'] = true;

    };

    const timerId = 'lazySearch';
    const timerDelay = 1000;

    runSetTimeout(timerId, callback, timerDelay)
  })()
  if (___arguments.value == '') {
    response = await Search_Contacts();
    response = await Reset_Search();
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', ({  }));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', response);
    ___arguments.context.appData['ForceSearch'] = false;
    ___arguments.context.pageData['DBSearchTerm'] = '';
  } else {
    response = await Search_Contacts();
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', ({  }));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', response);
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9048e37ecae67908d8bd408823dce8d8'))['background-color'] = '#A00000';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9a38cdb1fe6889b8853c0d7891b8ca88'))['color'] = '#FFFFFF';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ee68b608a0ec67383ffecb48626858c8'))['color'] = '#FFFFFF';
    ___arguments.context.pageData['MAKEITWHITE'] = true;
    ___arguments.context.appData['ForceSearch'] = true;
  }
  if (getValueLength(___arguments.value) == 0) {
    ___arguments.context.pageData['DBSearchTerm'] = '';
    stopSetTimeout('lazySearch');
  }

  },
  /* handler:onChange */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    var classList;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'MAKEITWHITE')) == true) {
    classList = ['input-white'];
  } else {
    classList = ['input-black'];
  }
  return classList;

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/home/components/ee68b608a0ec67383ffecb48626858c8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var retrievedContacts;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setTimeouts'); if (timerId && timers[timerId]) {    clearTimeout(timers[timerId]);    delete timers[timerId]; }}

/**
 * Describe this function...
 */
async function Reset_Search() {
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', ({  }));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', (getObjectProperty((await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((String('https://mgr.pockethost.io/api/collections/ACCOContacts/records?perPage=25&sort=+LastName,FirstName')))).set(({ [`Authorization`]: ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOUserToken')) })).setEncoding('utf8').send()), 'items')));
  ___arguments.context.pageData['RetrievedContacts'] = retrievedContacts;
}


  await Reset_Search();
  ___arguments.context.pageData['DBSearchTerm'] = '';
  ___arguments.context.pageData['value'] = '';
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('9a38cdb1fe6889b8853c0d7891b8ca88'))['value'] = '';
  ___arguments.context.pageData['ForceSearch'] = false;
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9048e37ecae67908d8bd408823dce8d8'))['background-color'] = '#F5F5F5';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ee68b608a0ec67383ffecb48626858c8'))['color'] = '#AD0505';
  ___arguments.context.pageData['MAKEITWHITE'] = false;
  ___arguments.context.pageData['MAKEITBLACK'] = (!(getObjectProperty(___arguments.context.pageData, 'MAKEITWHITE')));
  stopSetTimeout('lazySearch');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/home/components/3a4106331cb86b6899de7db685e6a9f2/bundle.js', [], () => ({
  /* content */
  /* handler:onDelete */
  ['onDelete'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'PageFilter')) == 'Created') {
    ___arguments.context.pageData['PageFilter'] = '';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3a4106331cb86b6899de7db685e6a9f2'))['background-color'] = '#016288';
  }

  },
  /* handler:onDelete */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'PageFilter')) != 'Created') {
    ___arguments.context.pageData['PageFilter'] = 'Created';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3a4106331cb86b6899de7db685e6a9f2'))['background-color'] = '#A00000';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('86684ec8198c47f8c1a80e08638823b6'))['background-color'] = '#016288';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('50d8bec85069e1ce0198f5e8c4670bd8'))['background-color'] = '#016288';
  } else {
    ___arguments.context.pageData['CreatedDirectionDown'] = (!(getObjectProperty(___arguments.context.pageData, 'CreatedDirectionDown')));
    await (async function() {
    	const icon = document.querySelector('.created-chip-class i')

    	if (icon.innerHTML === 'arrow_circle_up') {
    	    icon.innerHTML = 'arrow_circle_down'
    	 } else {
    	    icon.innerHTML = 'arrow_circle_up'
    	 }
    })();
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/home/components/86684ec8198c47f8c1a80e08638823b6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'PageFilter')) != 'Viewed') {
    ___arguments.context.pageData['PageFilter'] = 'Viewed';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3a4106331cb86b6899de7db685e6a9f2'))['background-color'] = '#016288';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('86684ec8198c47f8c1a80e08638823b6'))['background-color'] = '#A00000';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('50d8bec85069e1ce0198f5e8c4670bd8'))['background-color'] = '#016288';
  } else {
    ___arguments.context.pageData['ViewedDirectionDown'] = (!(getObjectProperty(___arguments.context.pageData, 'ViewedDirectionDown')));
    await (async function() {
    	const icon = document.querySelector('.viewed-chip-class i')

    	if (icon.innerHTML === 'arrow_circle_up') {
    	    icon.innerHTML = 'arrow_circle_down'
    	 } else {
    	    icon.innerHTML = 'arrow_circle_up'
    	 }
    })();
  }

  },
  /* handler:onClick */
  /* handler:onDelete */
  ['onDelete'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'PageFilter')) == 'Viewed') {
    ___arguments.context.pageData['PageFilter'] = '';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('86684ec8198c47f8c1a80e08638823b6'))['background-color'] = '#016288';
  }

  },
  /* handler:onDelete */
  /* content */
}))

define('./pages/home/components/50d8bec85069e1ce0198f5e8c4670bd8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'PageFilter')) != 'Modified') {
    ___arguments.context.pageData['PageFilter'] = 'Modified';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3a4106331cb86b6899de7db685e6a9f2'))['background-color'] = '#016288';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('86684ec8198c47f8c1a80e08638823b6'))['background-color'] = '#016288';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('50d8bec85069e1ce0198f5e8c4670bd8'))['background-color'] = '#A00000';
  } else {
    ___arguments.context.pageData['ModifiedDirectionDown'] = (!(getObjectProperty(___arguments.context.pageData, 'ModifiedDirectionDown')));
    await (async function() {
    	const icon = document.querySelector('.modified-chip-class i')

    	if (icon.innerHTML === 'arrow_circle_up') {
    	    icon.innerHTML = 'arrow_circle_down'
    	 } else {
    	    icon.innerHTML = 'arrow_circle_up'
    	 }
    })();
  }

  },
  /* handler:onClick */
  /* handler:onDelete */
  ['onDelete'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'PageFilter')) == 'Modified') {
    ___arguments.context.pageData['PageFilter'] = '';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('50d8bec85069e1ce0198f5e8c4670bd8'))['background-color'] = '#016288';
  }

  },
  /* handler:onDelete */
  /* content */
}))

define('./pages/home/components/c8486c55ffb833b1731c386d281e1628/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var retrievedContacts, results;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function Search_Contacts() {
  if ((getObjectProperty(___arguments.context.pageData, 'TOGGLE_IncludeCompany')) == true) {
    retrievedContacts = (getObjectProperty((await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((['https://mgr.pockethost.io/api/collections/ACCOContacts/records?perPage=50&sort=+LastName,FirstName&filter=(','LastName~\'',(getObjectProperty(___arguments.context.pageData, 'DBSearchTerm')),'\' || FirstName~\'',(getObjectProperty(___arguments.context.pageData, 'DBSearchTerm')),'\' || Company~\'',(getObjectProperty(___arguments.context.pageData, 'DBSearchTerm')),'\')'].join('')))).set(({ [`Authorization`]: ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOUserToken')) })).setEncoding('utf8').send()), 'items'));
  } else {
    retrievedContacts = (getObjectProperty((await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((['https://mgr.pockethost.io/api/collections/ACCOContacts/records?perPage=50&sort=+LastName,FirstName&filter=(','LastName~\'',(getObjectProperty(___arguments.context.pageData, 'DBSearchTerm')),'\' || FirstName~\'',(getObjectProperty(___arguments.context.pageData, 'DBSearchTerm')),'\')'].join('')))).set(({ [`Authorization`]: ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOUserToken')) })).setEncoding('utf8').send()), 'items'));
  }
  return retrievedContacts
}


  if (___arguments.value == true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a1a8e4d209da625868a898e85398323e'))['color'] = '#990000';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a1a8e4d209da625868a898e85398323e'))['font-weight'] = 'bold';
    ___arguments.context.pageData['TOGGLE_IncludeCompany'] = true;
    results = await Search_Contacts();
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a1a8e4d209da625868a898e85398323e'))['color'] = '#000000';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a1a8e4d209da625868a898e85398323e'))['font-weight'] = 'normal';
    ___arguments.context.pageData['TOGGLE_IncludeCompany'] = false;
    results = await Search_Contacts();
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', results);

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/home/components/96b815b891276784d638d95fab3833cd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var currentUser, retrievedContactsRawResponse, CurrentPageNumber;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  CurrentPageNumber = 0;
  ___arguments.context.pageData['pageCursor'] = 1;
  if (currentUser != false) {
    retrievedContactsRawResponse = (await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((String('https://mgr.pockethost.io/api/collections/ACCOContacts/records?perPage=25&sort=+LastName,FirstName&page=') + String(JSON.stringify((getObjectProperty(___arguments.context.pageData, 'pageCursor'))))))).set(({ [`Authorization`]: ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOUserToken')) })).setEncoding('utf8').send());
    ___arguments.context.pageData['page'] = (getObjectProperty(retrievedContactsRawResponse, 'page'));
    ___arguments.context.pageData['perPage'] = (getObjectProperty(retrievedContactsRawResponse, 'perPage'));
    ___arguments.context.pageData['totalItems'] = (getObjectProperty(retrievedContactsRawResponse, 'totalItems'));
    ___arguments.context.pageData['totalPages'] = (getObjectProperty(retrievedContactsRawResponse, 'totalPages'));
    console.log('RetrievedContactsRawResponse:');
    console.log(retrievedContactsRawResponse);
    ___arguments.context.pageData['RetrievedContacts'] = (getObjectProperty(retrievedContactsRawResponse, 'items'));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', ({  }));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', (getObjectProperty(___arguments.context.pageData, 'RetrievedContacts')));
    ___arguments.context.pageData['DisplayingContactsMessage'] = (['Contact: ',(Number((getObjectProperty(___arguments.context.pageData, 'page')))) * (Number((getObjectProperty(___arguments.context.pageData, 'perPage')))),' | Page: ',(getObjectProperty(___arguments.context.pageData, 'page')),' (',(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8'))[0]), 'LastName')),' To ',(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8')).slice(-1)[0]), 'LastName')),') | Total Pages: ',(getObjectProperty(___arguments.context.pageData, 'totalPages')),' | Total Contacts: ',(getObjectProperty(___arguments.context.pageData, 'totalItems'))].join(''));
    console.log(currentUser);
    ___arguments.context.appData['currentUser'] = currentUser;
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('UserLogin', undefined);
  }
  ___arguments.context.pageData['DisplayingContactsMessage'] = (['Contact: ',(Number((getObjectProperty(___arguments.context.pageData, 'page')))) * (Number((getObjectProperty(___arguments.context.pageData, 'perPage')))),' | Page: ',(getObjectProperty(___arguments.context.pageData, 'page')),' (',(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8'))[0]), 'LastName')),' To ',(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8')).slice(-1)[0]), 'LastName')),') | Total Pages: ',(getObjectProperty(___arguments.context.pageData, 'totalPages')),' | Total Contacts: ',(getObjectProperty(___arguments.context.pageData, 'totalItems'))].join(''));

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'page')) == 1) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('96b815b891276784d638d95fab3833cd'))['background-color'] = '#9A91A6';
    return true;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('96b815b891276784d638d95fab3833cd'))['background-color'] = '#0A0A0A';
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/home/components/f1542a58df082559e03864f8db487678/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var currentUser, retrievedContactsRawResponse, ContactsCountReturn, CurrentPageNumber;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['pageCursor'] = ((Number((getObjectProperty(___arguments.context.pageData, 'page')))) - 10);
  if (currentUser != false) {
    retrievedContactsRawResponse = (await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((String('https://mgr.pockethost.io/api/collections/ACCOContacts/records?perPage=25&sort=+LastName,FirstName&page=') + String(JSON.stringify((getObjectProperty(___arguments.context.pageData, 'pageCursor'))))))).set(({ [`Authorization`]: ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOUserToken')) })).setEncoding('utf8').send());
    ___arguments.context.pageData['page'] = (getObjectProperty(retrievedContactsRawResponse, 'page'));
    ___arguments.context.pageData['perPage'] = (getObjectProperty(retrievedContactsRawResponse, 'perPage'));
    ___arguments.context.pageData['totalItems'] = (getObjectProperty(retrievedContactsRawResponse, 'totalItems'));
    ___arguments.context.pageData['totalPages'] = (getObjectProperty(retrievedContactsRawResponse, 'totalPages'));
    console.log('RetrievedContactsRawResponse:');
    console.log(retrievedContactsRawResponse);
    ___arguments.context.pageData['RetrievedContacts'] = (getObjectProperty(retrievedContactsRawResponse, 'items'));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', ({  }));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', (getObjectProperty(___arguments.context.pageData, 'RetrievedContacts')));
    ___arguments.context.pageData['DisplayingContactsMessage'] = (['Contact: ',(Number((getObjectProperty(___arguments.context.pageData, 'page')))) * (Number((getObjectProperty(___arguments.context.pageData, 'perPage')))),' | Page: ',(getObjectProperty(___arguments.context.pageData, 'page')),' (',(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8'))[0]), 'LastName')),' To ',(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8')).slice(-1)[0]), 'LastName')),') | Total Pages: ',(getObjectProperty(___arguments.context.pageData, 'totalPages')),' | Total Contacts: ',(getObjectProperty(___arguments.context.pageData, 'totalItems'))].join(''));
    console.log(currentUser);
    ___arguments.context.appData['currentUser'] = currentUser;
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('UserLogin', undefined);
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'page')) <= 10) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f1542a58df082559e03864f8db487678'))['background-color'] = '#9A91A6';
    return true;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f1542a58df082559e03864f8db487678'))['background-color'] = '#0A0A0A';
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/home/components/8df8d2e2bef1ae08efcc44611b5882f1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var currentUser, retrievedContactsRawResponse, ContactsCountReturn, CurrentPageNumber;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['pageCursor'] = ((Number((getObjectProperty(___arguments.context.pageData, 'page')))) + 1);
  if (currentUser != false) {
    retrievedContactsRawResponse = (await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((String('https://mgr.pockethost.io/api/collections/ACCOContacts/records?perPage=25&sort=+LastName,FirstName&page=') + String(JSON.stringify((getObjectProperty(___arguments.context.pageData, 'pageCursor'))))))).set(({ [`Authorization`]: ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOUserToken')) })).setEncoding('utf8').send());
    ___arguments.context.pageData['page'] = (getObjectProperty(retrievedContactsRawResponse, 'page'));
    ___arguments.context.pageData['perPage'] = (getObjectProperty(retrievedContactsRawResponse, 'perPage'));
    ___arguments.context.pageData['totalItems'] = (getObjectProperty(retrievedContactsRawResponse, 'totalItems'));
    ___arguments.context.pageData['totalPages'] = (getObjectProperty(retrievedContactsRawResponse, 'totalPages'));
    console.log('RetrievedContactsRawResponse:');
    console.log(retrievedContactsRawResponse);
    ___arguments.context.pageData['RetrievedContacts'] = (getObjectProperty(retrievedContactsRawResponse, 'items'));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', ({  }));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', (getObjectProperty(___arguments.context.pageData, 'RetrievedContacts')));
    ___arguments.context.pageData['DisplayingContactsMessage'] = (['Contact: ',(Number((getObjectProperty(___arguments.context.pageData, 'page')))) * (Number((getObjectProperty(___arguments.context.pageData, 'perPage')))),' | Page: ',(getObjectProperty(___arguments.context.pageData, 'page')),' (',(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8'))[0]), 'LastName')),' To ',(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8')).slice(-1)[0]), 'LastName')),') | Total Pages: ',(getObjectProperty(___arguments.context.pageData, 'totalPages')),' | Total Contacts: ',(getObjectProperty(___arguments.context.pageData, 'totalItems'))].join(''));
    console.log(currentUser);
    ___arguments.context.appData['currentUser'] = currentUser;
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('UserLogin', undefined);
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'page')) == (Number((getObjectProperty(___arguments.context.pageData, 'totalPages'))))) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('8df8d2e2bef1ae08efcc44611b5882f1'))['background-color'] = '#9A91A6';
    return true;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('8df8d2e2bef1ae08efcc44611b5882f1'))['background-color'] = '#0A0A0A';
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/home/components/eb38a9bcb0711288da0800585d081f5a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var currentUser, retrievedContactsRawResponse, ContactsCountReturn, CurrentPageNumber;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['pageCursor'] = ((Number((getObjectProperty(___arguments.context.pageData, 'page')))) - 1);
  if (currentUser != false) {
    retrievedContactsRawResponse = (await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((String('https://mgr.pockethost.io/api/collections/ACCOContacts/records?perPage=25&sort=+LastName,FirstName&page=') + String(JSON.stringify((getObjectProperty(___arguments.context.pageData, 'pageCursor'))))))).set(({ [`Authorization`]: ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOUserToken')) })).setEncoding('utf8').send());
    ___arguments.context.pageData['page'] = (getObjectProperty(retrievedContactsRawResponse, 'page'));
    ___arguments.context.pageData['perPage'] = (getObjectProperty(retrievedContactsRawResponse, 'perPage'));
    ___arguments.context.pageData['totalItems'] = (getObjectProperty(retrievedContactsRawResponse, 'totalItems'));
    ___arguments.context.pageData['totalPages'] = (getObjectProperty(retrievedContactsRawResponse, 'totalPages'));
    console.log('RetrievedContactsRawResponse:');
    console.log(retrievedContactsRawResponse);
    ___arguments.context.pageData['RetrievedContacts'] = (getObjectProperty(retrievedContactsRawResponse, 'items'));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', ({  }));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', (getObjectProperty(___arguments.context.pageData, 'RetrievedContacts')));
    ___arguments.context.pageData['DisplayingContactsMessage'] = (['Contact: ',(Number((getObjectProperty(___arguments.context.pageData, 'page')))) * (Number((getObjectProperty(___arguments.context.pageData, 'perPage')))),' | Page: ',(getObjectProperty(___arguments.context.pageData, 'page')),' (',(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8'))[0]), 'LastName')),' To ',(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8')).slice(-1)[0]), 'LastName')),') | Total Pages: ',(getObjectProperty(___arguments.context.pageData, 'totalPages')),' | Total Contacts: ',(getObjectProperty(___arguments.context.pageData, 'totalItems'))].join(''));
    console.log(currentUser);
    ___arguments.context.appData['currentUser'] = currentUser;
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('UserLogin', undefined);
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'page')) == 1) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('eb38a9bcb0711288da0800585d081f5a'))['background-color'] = '#9A91A6';
    return true;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('eb38a9bcb0711288da0800585d081f5a'))['background-color'] = '#0A0A0A';
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/home/components/c38b81a1fde808e224a8dc634857c68a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var currentUser, retrievedContactsRawResponse, ContactsCountReturn, CurrentPageNumber;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['pageCursor'] = ((Number((getObjectProperty(___arguments.context.pageData, 'page')))) + 10);
  if (currentUser != false) {
    retrievedContactsRawResponse = (await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((String('https://mgr.pockethost.io/api/collections/ACCOContacts/records?perPage=25&sort=+LastName,FirstName&page=') + String(JSON.stringify((getObjectProperty(___arguments.context.pageData, 'pageCursor'))))))).set(({ [`Authorization`]: ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOUserToken')) })).setEncoding('utf8').send());
    ___arguments.context.pageData['page'] = (getObjectProperty(retrievedContactsRawResponse, 'page'));
    ___arguments.context.pageData['perPage'] = (getObjectProperty(retrievedContactsRawResponse, 'perPage'));
    ___arguments.context.pageData['totalItems'] = (getObjectProperty(retrievedContactsRawResponse, 'totalItems'));
    ___arguments.context.pageData['totalPages'] = (getObjectProperty(retrievedContactsRawResponse, 'totalPages'));
    console.log('RetrievedContactsRawResponse:');
    console.log(retrievedContactsRawResponse);
    ___arguments.context.pageData['RetrievedContacts'] = (getObjectProperty(retrievedContactsRawResponse, 'items'));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', ({  }));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', (getObjectProperty(___arguments.context.pageData, 'RetrievedContacts')));
    ___arguments.context.pageData['DisplayingContactsMessage'] = (['Contact: ',(Number((getObjectProperty(___arguments.context.pageData, 'page')))) * (Number((getObjectProperty(___arguments.context.pageData, 'perPage')))),' | Page: ',(getObjectProperty(___arguments.context.pageData, 'page')),' (',(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8'))[0]), 'LastName')),' To ',(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8')).slice(-1)[0]), 'LastName')),') | Total Pages: ',(getObjectProperty(___arguments.context.pageData, 'totalPages')),' | Total Contacts: ',(getObjectProperty(___arguments.context.pageData, 'totalItems'))].join(''));
    console.log(currentUser);
    ___arguments.context.appData['currentUser'] = currentUser;
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('UserLogin', undefined);
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'page')) > (Number((getObjectProperty(___arguments.context.pageData, 'totalPages')))) - 10) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c38b81a1fde808e224a8dc634857c68a'))['background-color'] = '#9A91A6';
    return true;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c38b81a1fde808e224a8dc634857c68a'))['background-color'] = '#0A0A0A';
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/home/components/3f18a098cf5807a87b084d784a98910c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var currentUser, retrievedContactsRawResponse, CurrentPageNumber;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  CurrentPageNumber = 0;
  ___arguments.context.pageData['pageCursor'] = (Number((getObjectProperty(___arguments.context.pageData, 'totalPages'))));
  if (currentUser != false) {
    retrievedContactsRawResponse = (await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((String('https://mgr.pockethost.io/api/collections/ACCOContacts/records?perPage=25&sort=+LastName,FirstName&page=') + String(JSON.stringify((getObjectProperty(___arguments.context.pageData, 'pageCursor'))))))).set(({ [`Authorization`]: ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOUserToken')) })).setEncoding('utf8').send());
    ___arguments.context.pageData['page'] = (getObjectProperty(retrievedContactsRawResponse, 'page'));
    ___arguments.context.pageData['perPage'] = (getObjectProperty(retrievedContactsRawResponse, 'perPage'));
    ___arguments.context.pageData['totalItems'] = (getObjectProperty(retrievedContactsRawResponse, 'totalItems'));
    ___arguments.context.pageData['totalPages'] = (getObjectProperty(retrievedContactsRawResponse, 'totalPages'));
    console.log('RetrievedContactsRawResponse:');
    console.log(retrievedContactsRawResponse);
    ___arguments.context.pageData['RetrievedContacts'] = (getObjectProperty(retrievedContactsRawResponse, 'items'));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', ({  }));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', (getObjectProperty(___arguments.context.pageData, 'RetrievedContacts')));
    ___arguments.context.pageData['DisplayingContactsMessage'] = (['Contact: ',(Number((getObjectProperty(___arguments.context.pageData, 'page')))) * (Number((getObjectProperty(___arguments.context.pageData, 'perPage')))),' | Page: ',(getObjectProperty(___arguments.context.pageData, 'page')),' (',(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8'))[0]), 'LastName')),' To ',(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8')).slice(-1)[0]), 'LastName')),') | Total Pages: ',(getObjectProperty(___arguments.context.pageData, 'totalPages')),' | Total Contacts: ',(getObjectProperty(___arguments.context.pageData, 'totalItems'))].join(''));
    console.log(currentUser);
    ___arguments.context.appData['currentUser'] = currentUser;
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('UserLogin', undefined);
  }
  ___arguments.context.pageData['DisplayingContactsMessage'] = (['Contact: ',(Number((getObjectProperty(___arguments.context.pageData, 'page')))) * (Number((getObjectProperty(___arguments.context.pageData, 'perPage')))),' | Page: ',(getObjectProperty(___arguments.context.pageData, 'page')),' (',(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8'))[0]), 'LastName')),' To ',(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8')).slice(-1)[0]), 'LastName')),') | Total Pages: ',(getObjectProperty(___arguments.context.pageData, 'totalPages')),' | Total Contacts: ',(getObjectProperty(___arguments.context.pageData, 'totalItems'))].join(''));

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'page')) == (Number((getObjectProperty(___arguments.context.pageData, 'totalPages'))))) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3f18a098cf5807a87b084d784a98910c'))['background-color'] = '#9A91A6';
    return true;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3f18a098cf5807a87b084d784a98910c'))['background-color'] = '#0A0A0A';
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/home/components/8bf48e763098bc9bd82790dc5238e3c8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(JSON.parse((JSON.stringify(___arguments.context.getComponentDataStoreByUid('5e3f583561b818f8a1786ac80fa77ec8')))));
  console.log(JSON.parse((JSON.stringify((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'drawerDataModel')), 'MiddleName'))))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/home/components/b1d3e8684cdf46a8fe882c58ccf881cb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('#Bottom', false, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/home/components/5b9545ea538797582b284eb9c91349e8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('#Top', false, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/home/components/fbefd2bb6fec4718d6382d38ad733348/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/home/components/92b96158c4d823916c18019a5b28fd83/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'CurrentlySelectedContactData')), 'FirstName'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/home/components/31f864bdf9b8c4982b985e46c2a8175a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'CurrentlySelectedContactData')), 'LastName'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/home/components/6672cef89de766787f2889f880d8b618/bundle.js', [], () => ({
  /* content */
  /* handler:onReadOnlyStateAssignment */
  ['onReadOnlyStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.pageData, 'EditMode')))

  },
  /* handler:onReadOnlyStateAssignment */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6672cef89de766787f2889f880d8b618')), 'value')) == '') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('6672cef89de766787f2889f880d8b618'))['border-color'] = '#AE0530';
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('6672cef89de766787f2889f880d8b618'))['border-color'] = '#0520AE';
  }

  },
  /* handler:onBlur */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'drawerDataModel')), 'FirstName'))

  },
  /* handler:onValueAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Object.assign((getObjectProperty(___arguments.context.pageData, 'drawerDataModel')), ({ [`FirstName`]: ___arguments.value }));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/home/components/af7832b8d436d7bdb868946446a9d5fc/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'drawerDataModel')), 'LastName'))

  },
  /* handler:onValueAssignment */
  /* handler:onReadOnlyStateAssignment */
  ['onReadOnlyStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.pageData, 'EditMode')))

  },
  /* handler:onReadOnlyStateAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Object.assign((getObjectProperty(___arguments.context.pageData, 'drawerDataModel')), ({ [`LastName`]: ___arguments.value }));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/home/components/ac22d7a23f48b4a88ef44e890c58d724/bundle.js', [], () => ({
  /* content */
  /* handler:onReadOnlyStateAssignment */
  ['onReadOnlyStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.pageData, 'EditMode')))

  },
  /* handler:onReadOnlyStateAssignment */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'drawerDataModel')), 'MiddleName'))

  },
  /* handler:onValueAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Object.assign((getObjectProperty(___arguments.context.pageData, 'drawerDataModel')), ({ [`MiddleName`]: ___arguments.value }));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/home/components/c6d8a878da6ee2a81d1818587298aef2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['EditMode'] = true;
  ___arguments.context.pageData['ModifiedData'] = true;
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c6d8a878da6ee2a81d1818587298aef2'))['background-color'] = '#A00000';

  },
  /* handler:onClick */
  /* handler:onDelete */
  ['onDelete'](___arguments) {
      ___arguments.context.pageData['EditMode'] = false;
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c6d8a878da6ee2a81d1818587298aef2'))['background-color'] = '#016288';

  },
  /* handler:onDelete */
  /* content */
}))

define('./pages/home/components/99a8df394f156cc874813c38d937d968/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('99a8df394f156cc874813c38d937d968')), 'color')) != '#03B935') {
    console.log('We need to save this contacts\' details...');
    ___arguments.context.pageData['ContactsModifiedOnPage'] = ((getObjectProperty(___arguments.context.pageData, 'ContactsModifiedOnPage')) - 1);
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('99a8df394f156cc874813c38d937d968'))['color'] = '#03B935';
    await new Promise(r => setTimeout(r, 3000 || 0));
    ___arguments.context.getComponentDataStoreByUid('f548849959d80918247fdbdd7f982de8')['NeedToSave'] = false;
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('99a8df394f156cc874813c38d937d968'))['color'] = '#FF0004';
    console.log('Data to save: ');
    console.log(___arguments.context.getComponentDataStoreByUid('f548849959d80918247fdbdd7f982de8'));
    if ((getObjectProperty(___arguments.context.pageData, 'ContactsModifiedOnPage')) == 0) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ac384c2fae874c589bd87f588a6bdbc8'))['min-height'] = 10;
    }
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var item, listCount;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f548849959d80918247fdbdd7f982de8'), 'NeedToSave')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/home/components/390d1ad861e8a4a817487017ebcec028/bundle.js', [], () => ({
  /* content */
  /* handler:onReadOnlyStateAssignment */
  ['onReadOnlyStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.pageData, 'EditMode')))

  },
  /* handler:onReadOnlyStateAssignment */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'drawerDataModel')), 'Suffix'))

  },
  /* handler:onValueAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Object.assign((getObjectProperty(___arguments.context.pageData, 'drawerDataModel')), ({ [`Suffix`]: ___arguments.value }));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/home/components/60d8097a61c88c0d830a43e79398466a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(JSON.parse((JSON.stringify((getObjectProperty(___arguments.context.pageData, 'drawerDataModel'))))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/home/components/4e289aefe01b9378bf79b7f89fc4a648/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, targetObject, sourceObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', (await asyncListFilter(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8')), async (item) => {
     if ((getObjectProperty(item, 'id')) == (getObjectProperty(___arguments.context.pageData, 'CurrentlySelectedContactID'))) {
      item['NeedToSave'] = true;
      item['FirstName'] = (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6672cef89de766787f2889f880d8b618')), 'value'));
      item['MiddleName'] = (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ac22d7a23f48b4a88ef44e890c58d724')), 'value'));
      item['MiddleName_Modified'] = (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ac22d7a23f48b4a88ef44e890c58d724')), 'value'));
      item['LastName'] = (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('af7832b8d436d7bdb868946446a9d5fc')), 'value'));
      item['Contact_Name'] = ([(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6672cef89de766787f2889f880d8b618')), 'value')),' ',(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('af7832b8d436d7bdb868946446a9d5fc')), 'value'))].join(''));
      return true;
    } else {
      return true;
    }


   return item;
  })));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/home/components/4858b01879e8f3e64732c02ec845eda9/bundle.js', [], () => ({
  /* content */
  /* handler:onReadOnlyStateAssignment */
  ['onReadOnlyStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.pageData, 'EditMode')))

  },
  /* handler:onReadOnlyStateAssignment */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'drawerDataModel')), 'Company'))

  },
  /* handler:onValueAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Object.assign((getObjectProperty(___arguments.context.pageData, 'drawerDataModel')), ({ [`Company`]: ___arguments.value }));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/home/components/4221dcc8d2d947a85538184f6448fe98/bundle.js', [], () => ({
  /* content */
  /* handler:onReadOnlyStateAssignment */
  ['onReadOnlyStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.pageData, 'EditMode')))

  },
  /* handler:onReadOnlyStateAssignment */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'drawerDataModel')), 'JobTitle'))

  },
  /* handler:onValueAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Object.assign((getObjectProperty(___arguments.context.pageData, 'drawerDataModel')), ({ [`JobTitle`]: ___arguments.value }));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/home/components/550713e5e12288185c18386c85a1f806/bundle.js', [], () => ({
  /* content */
  /* handler:onReadOnlyStateAssignment */
  ['onReadOnlyStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.pageData, 'EditMode')))

  },
  /* handler:onReadOnlyStateAssignment */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'drawerDataModel')), 'BusinessStreet'))

  },
  /* handler:onValueAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Object.assign((getObjectProperty(___arguments.context.pageData, 'drawerDataModel')), ({ [`BusinessStreet`]: ___arguments.value }));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/home/components/0f74f9883e8523488538b3f88cfba288/bundle.js', [], () => ({
  /* content */
  /* handler:onReadOnlyStateAssignment */
  ['onReadOnlyStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.pageData, 'EditMode')))

  },
  /* handler:onReadOnlyStateAssignment */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'drawerDataModel')), 'BusinessCity'))

  },
  /* handler:onValueAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Object.assign((getObjectProperty(___arguments.context.pageData, 'drawerDataModel')), ({ [`BusinessCity`]: ___arguments.value }));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/home/components/88c14e78df588d38de180a48b8c1a5a8/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'drawerDataModel')), 'BusinessState'))

  },
  /* handler:onValueAssignment */
  /* handler:onReadOnlyStateAssignment */
  ['onReadOnlyStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.pageData, 'EditMode')))

  },
  /* handler:onReadOnlyStateAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Object.assign((getObjectProperty(___arguments.context.pageData, 'drawerDataModel')), ({ [`BusinessState`]: ___arguments.value }));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/home/components/f9881ba8c9566a99d80d0c464588eb28/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'drawerDataModel')), 'BusinessPostalCode'))

  },
  /* handler:onValueAssignment */
  /* handler:onReadOnlyStateAssignment */
  ['onReadOnlyStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.pageData, 'EditMode')))

  },
  /* handler:onReadOnlyStateAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Object.assign((getObjectProperty(___arguments.context.pageData, 'drawerDataModel')), ({ [`BusinessPostalCode`]: ___arguments.value }));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/home/components/703ecff8b328a55880c89cd846884c37/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'drawerDataModel')), 'EmailAddress'))

  },
  /* handler:onValueAssignment */
  /* handler:onReadOnlyStateAssignment */
  ['onReadOnlyStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.pageData, 'EditMode')))

  },
  /* handler:onReadOnlyStateAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Object.assign((getObjectProperty(___arguments.context.pageData, 'drawerDataModel')), ({ [`EmailAddress`]: ___arguments.value }));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/home/components/818af1d835280ed8b6f531582568ef08/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'drawerDataModel')), 'EmailAddress2'))

  },
  /* handler:onValueAssignment */
  /* handler:onReadOnlyStateAssignment */
  ['onReadOnlyStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.pageData, 'EditMode')))

  },
  /* handler:onReadOnlyStateAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Object.assign((getObjectProperty(___arguments.context.pageData, 'drawerDataModel')), ({ [`EmailAddress2`]: ___arguments.value }));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/home/components/f968043a1ef6440ab3a9e3f84de3ca98/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'drawerDataModel')), 'BusinessPhone'))

  },
  /* handler:onValueAssignment */
  /* handler:onReadOnlyStateAssignment */
  ['onReadOnlyStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.pageData, 'EditMode')))

  },
  /* handler:onReadOnlyStateAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Object.assign((getObjectProperty(___arguments.context.pageData, 'drawerDataModel')), ({ [`BusinessPhone`]: ___arguments.value }));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/home/components/f918db08fea5aaf8f7689b09d9281d0c/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'drawerDataModel')), 'BusinessPhone2'))

  },
  /* handler:onValueAssignment */
  /* handler:onReadOnlyStateAssignment */
  ['onReadOnlyStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.pageData, 'EditMode')))

  },
  /* handler:onReadOnlyStateAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Object.assign((getObjectProperty(___arguments.context.pageData, 'drawerDataModel')), ({ [`BusinessPhone2`]: ___arguments.value }));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/home/components/8798c77db678d7f82cb8e16eeeb8d8d8/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'drawerDataModel')), 'MobilePhone'))

  },
  /* handler:onValueAssignment */
  /* handler:onReadOnlyStateAssignment */
  ['onReadOnlyStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.pageData, 'EditMode')))

  },
  /* handler:onReadOnlyStateAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Object.assign((getObjectProperty(___arguments.context.pageData, 'drawerDataModel')), ({ [`MobilePhone`]: ___arguments.value }));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/home/components/da08f538e9f87698723c23311ed8027a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('Contacts Modified on Page: ') + String(getObjectProperty(___arguments.context.pageData, 'ContactsModifiedOnPage')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/home/components/45e853dd24b7d0d8a374d9359ea9db18/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'AdminEditMode')) != true) {
    ___arguments.context.pageData['AdminEditMode'] = true;
    ___arguments.context.pageData['EditMode'] = true;
    ___arguments.context.pageData['ModifiedData'] = true;
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('45e853dd24b7d0d8a374d9359ea9db18'))['background-color'] = '#A00000';
  } else {
    ___arguments.context.pageData['AdminEditMode'] = false;
    ___arguments.context.pageData['EditMode'] = false;
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('45e853dd24b7d0d8a374d9359ea9db18'))['background-color'] = '#016288';
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/home/components/34e859c84eb8a5d367772312422c5668/bundle.js', [], () => ({
  /* content */
  /* handler:onCheckedStateAssignment */
  ['onCheckedStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'AdminEditMode')) == true) {
    return true;
  }
  if ((getObjectProperty(___arguments.context.pageData, 'EditMode')) == true) {
    return true;
  }

  },
  /* handler:onCheckedStateAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
      if (___arguments.value == false) {
    ___arguments.context.pageData['EditMode'] = false;
  } else {
    ___arguments.context.pageData['EditMode'] = true;
    ___arguments.context.pageData['ModifiedData'] = true;
  }

  },
  /* handler:onChange */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'AdminEditMode')) == true) {
    return true;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/home/components/be99ba0526853a96ade9ec3aa8aa9513/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'AdminEditMode')) == true || (getObjectProperty(___arguments.context.pageData, 'EditMode')) == true) {
    ___arguments.context.pageData['ModifiedData'] = true;
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/home/components/ac384c2fae874c589bd87f588a6bdbc8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'ContactsModifiedOnPage')) > 0)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/home/components/b148d888c90afcf8617158a32b3cbdc8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'ContactsModifiedOnPage')) > 0) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/home/components/7bbfad1806fdddd83fc49ca857181fbc/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['ContactsModifiedOnPage'] = 0;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/home/components/67687bed2e4a382c420b90cb134d95ce/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var result;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.appData['DarkMode'] = true;
  result = (await Backendless.Request['patch']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((String('https://mgr.pockethost.io/api/collections/Users/records/') + String(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'currentUser')), 'record')), 'id'))))).set(({ [`Authorization`]: ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOUserToken')) })).setEncoding('utf8').send(({ [`DarkMode`]: true })));
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('67687bed2e4a382c420b90cb134d95ce'))['label'] = 'Dark';

  },
  /* handler:onClick */
  /* handler:onDelete */
  async ['onDelete'](___arguments) {
    var result;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.appData['DarkMode'] = false;
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('67687bed2e4a382c420b90cb134d95ce'))['label'] = 'Light';
  result = (await Backendless.Request['patch']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((String('https://mgr.pockethost.io/api/collections/Users/records/') + String(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'currentUser')), 'record')), 'id'))))).set(({ [`Authorization`]: ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOUserToken')) })).setEncoding('utf8').send(({ [`DarkMode`]: false })));

  },
  /* handler:onDelete */
  /* handler:onFrontIconAssignment */
  ['onFrontIconAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'DarkMode')) != true) {
    return 'light_mode';
  } else {
    return 'dark_mode';
  }

  },
  /* handler:onFrontIconAssignment */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'DarkMode')) == true) {
    return ['easeInAndOut', 'darkMode'];
  } else {
    return ['easeInAndOut', 'lightMode'];
  }

  },
  /* handler:onClassListAssignment */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'DarkMode')) == true) {
    return 'Dark';
  } else {
    return 'Light';
  }

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/home/components/b8580f282111677852f8e668487b966c/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'drawerDataModel')), 'Website'))

  },
  /* handler:onValueAssignment */
  /* handler:onReadOnlyStateAssignment */
  ['onReadOnlyStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.pageData, 'EditMode')))

  },
  /* handler:onReadOnlyStateAssignment */
  /* content */
}))

define('./pages/home/components/ba5855d15958fc0851b8bab16468ef72/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'drawerDataModel')), 'ContactImage'));

  return 'https://mgr.pockethost.io/api/files/pbc_328457761/DD233CBC449BC65F133C2C56BAD4FEA5/jenny_abbott_oxa72mi70w.jpg'

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/home-previous/components/ab288c9ed0e835b89a08e4b88e03dc16/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOUserToken'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/home-previous/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var currentUser, retrievedContactsRawResponse, storedTokenFromCookie;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function Set_pageData_Variables() {
  ___arguments.context.pageData['drawerDataModel'] = ({  });
  ___arguments.context.pageData['RetrievedContactsRawResponse'] = ({  });
  ___arguments.context.pageData['OpenDrawer'] = false;
  ___arguments.context.pageData['DisplayingContactsPageNumber'] = 0;
  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('99683348f21a0478cb18ff2b2078896a', []);
}


  await Set_pageData_Variables();
  storedTokenFromCookie = ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOUserToken'));
  currentUser = (await BackendlessUI.Functions.Custom['fn_fb29ed716ee40c6ec05a6af2fb62b61d'](storedTokenFromCookie));
  if (currentUser != false) {
    ___arguments.context.appData['currentUser'] = currentUser;
    retrievedContactsRawResponse = (await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://mgr.pockethost.io/api/collections/ACCOContacts/records?perPage=25&sort=+LastName,FirstName')).set(({ [`Authorization`]: ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOContactsToken')) })).setEncoding('utf8').send());
    ___arguments.context.pageData['pageCursor'] = 0;
    ___arguments.context.pageData['page'] = (getObjectProperty(retrievedContactsRawResponse, 'page'));
    ___arguments.context.pageData['perPage'] = (getObjectProperty(retrievedContactsRawResponse, 'perPage'));
    ___arguments.context.pageData['totalItems'] = (getObjectProperty(retrievedContactsRawResponse, 'totalItems'));
    ___arguments.context.pageData['totalPages'] = (getObjectProperty(retrievedContactsRawResponse, 'totalPages'));
    console.log('RetrievedContactsRawResponse:');
    console.log(retrievedContactsRawResponse);
    ___arguments.context.pageData['RetrievedContacts'] = (getObjectProperty(retrievedContactsRawResponse, 'items'));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', (getObjectProperty(___arguments.context.pageData, 'RetrievedContacts')));
    console.log(currentUser);
    ___arguments.context.pageData['DisplayingContactsMessage'] = (['Contact: ',(Number((getObjectProperty(___arguments.context.pageData, 'page')))) * (Number((getObjectProperty(___arguments.context.pageData, 'perPage')))),' | Page: ',(getObjectProperty(___arguments.context.pageData, 'page')),' (',(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8'))[0]), 'LastName')),' To ',(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8')).slice(-1)[0]), 'LastName')),') | Total Pages: ',(getObjectProperty(___arguments.context.pageData, 'totalPages')),' | Total Contacts: ',(getObjectProperty(___arguments.context.pageData, 'totalItems'))].join(''));
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('UserLogin', undefined);
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/home-previous/components/54081436bb6842a82788d1d8c2a7dbc1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(getObjectProperty(___arguments.context.appData, 'currentUser'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/home-previous/components/e65831ef35789938da8896bca018c4e8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      localStorage.removeItem('ACCOUserToken');
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('UserLogin', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/home-previous/components/cb980528d6cebac8f0984878c8985798/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(getObjectProperty(___arguments.context.pageData, 'RetrievedContacts'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/home-previous/components/26c848494068ad8874b4b73208376878/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await (async function(TextToCopy) {
  	navigator.clipboard.writeText(TextToCopy);
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5e3f583561b818f8a1786ac80fa77ec8'), 'BusinessPhone')));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9954b1e8ff38cc68d3f769a8c488aa1c'))['color'] = '#A00000';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9954b1e8ff38cc68d3f769a8c488aa1c'))['text-decoration-line'] = 'underline';
  await new Promise(r => setTimeout(r, 400 || 0));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9954b1e8ff38cc68d3f769a8c488aa1c'))['color'] = '#000000';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9954b1e8ff38cc68d3f769a8c488aa1c'))['text-decoration-line'] = 'none';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/home-previous/components/8c26d238ec58efa916980c5156989ff8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('14160948a388f4c82618c6e80fc67fec');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/home-previous/components/9f18306e287839f6b688b2785af8c8ec/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var decision, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'isContactSelected')) == true) {
    console.log(await asyncListFilter(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8')), async (item) => {
       if ((getObjectProperty(item, 'CurrentlySelectedContact')) == true) {
        delete item['CurrentlySelectedContact'];
        decision = true;
      } else {
        decision = true;
      }


     return ;
    }));
  }
  ___arguments.context.pageData['OpenDrawer'] = false;
  ___arguments.context.pageData['CurrentlySelectedContact'] = false;
  ___arguments.context.pageData['CurrentlySelectedContactObjectID'] = '';
  ___arguments.context.pageData['isContactSelected'] = false;
  ___arguments.context.pageData['EditMode'] = false;
  await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('d5e8e785986ad5d8c618fb16527f9038', undefined);
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bb85878828193def9f8054853f8949b'))['min-height'] = '100%';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/home-previous/components/34b170cf59982968ddc866980023ca7f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var decision, item, stripOutSelectedContacts;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function Set_pageData_Variables() {
  ___arguments.context.pageData['AddScrollDelay'] = true;
  ___arguments.context.pageData['OpenDrawer'] = true;
  ___arguments.context.pageData['CurrentlySelectedContact'] = true;
  ___arguments.context.pageData['isContactSelected'] = true;
  ___arguments.context.getComponentDataStoreByUid('f548849959d80918247fdbdd7f982de8')['CurrentlySelectedContact'] = true;
  ___arguments.context.pageData['CurrentlySelectedContactID'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f548849959d80918247fdbdd7f982de8'), 'id'));
  ___arguments.context.pageData['CurrentlySelectedContactData'] = (JSON.parse((JSON.stringify(___arguments.context.getComponentDataStoreByUid('f548849959d80918247fdbdd7f982de8')))));
}


  if ((getObjectProperty(___arguments.context.pageData, 'isContactSelected')) == true) {
    stripOutSelectedContacts = (await asyncListFilter(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8')), async (item) => {
       if ((getObjectProperty(item, 'CurrentlySelectedContact')) == true) {
        delete item['CurrentlySelectedContact'];
        decision = true;
      } else {
        decision = true;
      }


     return decision;
    }));
  }
  await Set_pageData_Variables();
  console.log('Pushing selected contact to pageData.drawerDataModel');
  console.log(JSON.parse((JSON.stringify(___arguments.context.getComponentDataStoreByUid('f548849959d80918247fdbdd7f982de8')))));
  ___arguments.context.pageData['drawerDataModel'] = (JSON.parse((JSON.stringify(___arguments.context.getComponentDataStoreByUid('f548849959d80918247fdbdd7f982de8')))));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bb85878828193def9f8054853f8949b'))['min-height'] = '125%';
  await (async function() {
  	const elements = document.getElementsByClassName('MainContactsRow');
  	const currentHeight = elements[0].clientHeight; // Get the current height
  	newHeight = currentHeight
  	
  	// newHeight = currentHeight * (1 + percentageIncrease / 100); // Calculate new height
  	if (newHeight < 1150) {
  	  newHeight = 1150;
  	}
  	elements[0].style.minHeight = newHeight + 'px'; // Set the new height
  	// alert('The current height is: '+ currentHeight);

  })();
  (function (component) { component.el.scrollIntoView() })((getObjectProperty(___arguments.context.pageData, (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f548849959d80918247fdbdd7f982de8'), 'id')))));

  },
  /* handler:onClick */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f548849959d80918247fdbdd7f982de8'), 'FirstName')),' ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f548849959d80918247fdbdd7f982de8'), 'LastName'))].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/home-previous/components/d5e8e785986ad5d8c618fb16527f9038/bundle.js', [], () => ({
  /* content */
  /* handler:isOpenLogic */
  ['isOpenLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'OpenDrawer'))

  },
  /* handler:isOpenLogic */
  /* handler:onClose */
  async ['onClose'](___arguments) {
    var result, item, decision;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  ___arguments.context.pageData['OpenDrawer'] = false;
  if ((getObjectProperty(___arguments.context.pageData, 'isContactSelected')) == true) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', (JSON.parse((JSON.stringify((await asyncListFilter(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8')), async (item) => {
       if ((getObjectProperty(item, 'CurrentlySelectedContact')) == true) {
        delete item['CurrentlySelectedContact'];
        decision = true;
      } else {
        decision = true;
      }


     return decision;
    })))))));
  }
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bb85878828193def9f8054853f8949b'))['height'] = 'auto';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bb85878828193def9f8054853f8949b'))['min-height'] = 'auto';
  ___arguments.context.pageData['isContactSelected'] = false;
  ___arguments.context.pageData['EditMode'] = false;
  console.log((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8'));
  result = (await (async function(modifiedData) {
  	var userPreference;
  	
  	if (modifiedData) {
  	
  	  if (confirm("Save your changes? [Enter] to save or [Esc] to cancel") == true) {
  	    userPreference = "Save Requested";
  	  } else {
  	    userPreference = "Save Cancelled!";
  	  }
  	// console.log(userPreference)
  	return userPreference
  	  
  	}

  })((getObjectProperty(___arguments.context.pageData, 'ModifiedData'))));
  if (result == 'Save Requested') {
    console.log('Save Data Requested');
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', (JSON.parse((JSON.stringify((await asyncListFilter(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8')), async (item) => {
       if ((getObjectProperty(item, 'id')) == (getObjectProperty(___arguments.context.pageData, 'CurrentlySelectedContactID'))) {
        item['NeedToSave'] = true;
        return true;
      } else {
        return true;
      }


     return item;
    })))))));
  } else {
    console.log('Save Data Cancelled!');
  }
  ___arguments.context.pageData['ModifiedData'] = false;

  },
  /* handler:onClose */
  /* handler:onOpen */
  ['onOpen'](___arguments) {
      console.log('BAM!!!');

  },
  /* handler:onOpen */
  /* content */
}))

define('./pages/home-previous/components/715ffae88be9507ff0b894488f3f2571/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f548849959d80918247fdbdd7f982de8'), 'CurrentlySelectedContact')) == true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f548849959d80918247fdbdd7f982de8'))['background-color'] = '#990939';
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f548849959d80918247fdbdd7f982de8'))['background-color'] = '#016288';
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/home-previous/components/f548849959d80918247fdbdd7f982de8/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData[(getObjectProperty(___arguments.context.dataModel, 'id'))] = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f548849959d80918247fdbdd7f982de8'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/home-previous/components/c4e88a1ec9685fd8d8c459588a08e548/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f548849959d80918247fdbdd7f982de8'), 'EmailAddress')) != '') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c4e88a1ec9685fd8d8c459588a08e548'))['color'] = '#FFFFFF';
  }

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f548849959d80918247fdbdd7f982de8'), 'EmailAddress')) != '') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c4e88a1ec9685fd8d8c459588a08e548'))['color'] = '#B4B4B4';
  }

  },
  /* handler:onMouseOut */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('3d1800088b7fe3386f380083d4e8b13d')), 'text')) != '') {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/home-previous/components/9a38cdb1fe6889b8853c0d7891b8ca88/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var response, DBSearchTerm, retrievedContacts;

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setTimeouts'); if (timerId && timers[timerId]) {    clearTimeout(timers[timerId]);    delete timers[timerId]; }}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setTimeouts'); const timer = setTimeout(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function Search_Contacts() {
  if ((getObjectProperty(___arguments.context.pageData, 'TOGGLE_IncludeCompany')) == true) {
    retrievedContacts = (getObjectProperty((await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((['https://mgr.pockethost.io/api/collections/ACCOContacts/records?perPage=50&sort=+LastName,FirstName&filter=(','LastName~\'',___arguments.value,'\' || FirstName~\'',___arguments.value,'\' || Company~\'',___arguments.value,'\')'].join('')))).set(({ [`Authorization`]: ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOContactsToken')) })).setEncoding('utf8').send()), 'items'));
    ___arguments.context.pageData['RetrievedContacts'] = retrievedContacts;
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9048e37ecae67908d8bd408823dce8d8'))['background-color'] = '#A00000';
    ___arguments.context.pageData['MAKEITWHITE'] = true;
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ee68b608a0ec67383ffecb48626858c8'))['color'] = '#FFFFFF';
  } else {
    retrievedContacts = (getObjectProperty((await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((['https://mgr.pockethost.io/api/collections/ACCOContacts/records?perPage=50&sort=+LastName,FirstName&filter=(','LastName~\'',___arguments.value,'\' || FirstName~\'',___arguments.value,'\')'].join('')))).set(({ [`Authorization`]: ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOContactsToken')) })).setEncoding('utf8').send()), 'items'));
  }
  return retrievedContacts
}

/**
 * Describe this function...
 */
async function Reset_Search() {
  retrievedContacts = (getObjectProperty((await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((String('https://mgr.pockethost.io/api/collections/ACCOContacts/records?perPage=25&sort=+LastName,FirstName')))).set(({ [`Authorization`]: ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOContactsToken')) })).setEncoding('utf8').send()), 'items'));
  ___arguments.context.pageData['RetrievedContacts'] = retrievedContacts;
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9048e37ecae67908d8bd408823dce8d8'))['background-color'] = '#F5F5F5';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9a38cdb1fe6889b8853c0d7891b8ca88'))['color'] = '#000000';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ee68b608a0ec67383ffecb48626858c8'))['color'] = '#AD0505';
  ___arguments.context.pageData['MAKEITWHITE'] = false;
  ___arguments.context.appData['ForceSearch'] = false;
  return retrievedContacts
}


  stopSetTimeout('lazySearch');

  ;(function() {
    const callback = async () => {
        DBSearchTerm = ___arguments.value;
    ___arguments.context.pageData['DBSearchTerm'] = DBSearchTerm;
    response = await Search_Contacts();
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', ({  }));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', response);
    ___arguments.context.appData['ForceSearch'] = true;

    };

    const timerId = 'lazySearch';
    const timerDelay = 1000;

    runSetTimeout(timerId, callback, timerDelay)
  })()
  if (___arguments.value == '') {
    response = await Search_Contacts();
    response = await Reset_Search();
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', ({  }));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', response);
    ___arguments.context.appData['ForceSearch'] = false;
    ___arguments.context.pageData['DBSearchTerm'] = '';
  } else {
    response = await Search_Contacts();
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', ({  }));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', response);
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9048e37ecae67908d8bd408823dce8d8'))['background-color'] = '#A00000';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9a38cdb1fe6889b8853c0d7891b8ca88'))['color'] = '#FFFFFF';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ee68b608a0ec67383ffecb48626858c8'))['color'] = '#FFFFFF';
    ___arguments.context.pageData['MAKEITWHITE'] = true;
    ___arguments.context.appData['ForceSearch'] = true;
  }
  if (getValueLength(___arguments.value) == 0) {
    ___arguments.context.pageData['DBSearchTerm'] = '';
    stopSetTimeout('lazySearch');
  }

  },
  /* handler:onChange */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    var classList;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'MAKEITWHITE')) == true) {
    classList = ['input-white'];
  } else {
    classList = ['input-black'];
  }
  return classList;

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/home-previous/components/ee68b608a0ec67383ffecb48626858c8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var retrievedContacts;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setTimeouts'); if (timerId && timers[timerId]) {    clearTimeout(timers[timerId]);    delete timers[timerId]; }}

/**
 * Describe this function...
 */
async function Reset_Search() {
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', ({  }));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', (getObjectProperty((await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((String('https://mgr.pockethost.io/api/collections/ACCOContacts/records?perPage=25&sort=+LastName,FirstName')))).set(({ [`Authorization`]: ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOContactsToken')) })).setEncoding('utf8').send()), 'items')));
  ___arguments.context.pageData['RetrievedContacts'] = retrievedContacts;
}


  await Reset_Search();
  ___arguments.context.pageData['DBSearchTerm'] = '';
  ___arguments.context.pageData['value'] = '';
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('9a38cdb1fe6889b8853c0d7891b8ca88'))['value'] = '';
  ___arguments.context.pageData['ForceSearch'] = false;
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9048e37ecae67908d8bd408823dce8d8'))['background-color'] = '#F5F5F5';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ee68b608a0ec67383ffecb48626858c8'))['color'] = '#AD0505';
  ___arguments.context.pageData['MAKEITWHITE'] = false;
  ___arguments.context.pageData['MAKEITBLACK'] = (!(getObjectProperty(___arguments.context.pageData, 'MAKEITWHITE')));
  stopSetTimeout('lazySearch');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/home-previous/components/3a4106331cb86b6899de7db685e6a9f2/bundle.js', [], () => ({
  /* content */
  /* handler:onDelete */
  ['onDelete'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'PageFilter')) == 'Created') {
    ___arguments.context.pageData['PageFilter'] = '';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3a4106331cb86b6899de7db685e6a9f2'))['background-color'] = '#016288';
  }

  },
  /* handler:onDelete */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'PageFilter')) != 'Created') {
    ___arguments.context.pageData['PageFilter'] = 'Created';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3a4106331cb86b6899de7db685e6a9f2'))['background-color'] = '#A00000';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('86684ec8198c47f8c1a80e08638823b6'))['background-color'] = '#016288';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('50d8bec85069e1ce0198f5e8c4670bd8'))['background-color'] = '#016288';
  } else {
    ___arguments.context.pageData['CreatedDirectionDown'] = (!(getObjectProperty(___arguments.context.pageData, 'CreatedDirectionDown')));
    await (async function() {
    	const icon = document.querySelector('.created-chip-class i')

    	if (icon.innerHTML === 'arrow_circle_up') {
    	    icon.innerHTML = 'arrow_circle_down'
    	 } else {
    	    icon.innerHTML = 'arrow_circle_up'
    	 }
    })();
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/home-previous/components/86684ec8198c47f8c1a80e08638823b6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'PageFilter')) != 'Viewed') {
    ___arguments.context.pageData['PageFilter'] = 'Viewed';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3a4106331cb86b6899de7db685e6a9f2'))['background-color'] = '#016288';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('86684ec8198c47f8c1a80e08638823b6'))['background-color'] = '#A00000';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('50d8bec85069e1ce0198f5e8c4670bd8'))['background-color'] = '#016288';
  } else {
    ___arguments.context.pageData['ViewedDirectionDown'] = (!(getObjectProperty(___arguments.context.pageData, 'ViewedDirectionDown')));
    await (async function() {
    	const icon = document.querySelector('.viewed-chip-class i')

    	if (icon.innerHTML === 'arrow_circle_up') {
    	    icon.innerHTML = 'arrow_circle_down'
    	 } else {
    	    icon.innerHTML = 'arrow_circle_up'
    	 }
    })();
  }

  },
  /* handler:onClick */
  /* handler:onDelete */
  ['onDelete'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'PageFilter')) == 'Viewed') {
    ___arguments.context.pageData['PageFilter'] = '';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('86684ec8198c47f8c1a80e08638823b6'))['background-color'] = '#016288';
  }

  },
  /* handler:onDelete */
  /* content */
}))

define('./pages/home-previous/components/50d8bec85069e1ce0198f5e8c4670bd8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'PageFilter')) != 'Modified') {
    ___arguments.context.pageData['PageFilter'] = 'Modified';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3a4106331cb86b6899de7db685e6a9f2'))['background-color'] = '#016288';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('86684ec8198c47f8c1a80e08638823b6'))['background-color'] = '#016288';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('50d8bec85069e1ce0198f5e8c4670bd8'))['background-color'] = '#A00000';
  } else {
    ___arguments.context.pageData['ModifiedDirectionDown'] = (!(getObjectProperty(___arguments.context.pageData, 'ModifiedDirectionDown')));
    await (async function() {
    	const icon = document.querySelector('.modified-chip-class i')

    	if (icon.innerHTML === 'arrow_circle_up') {
    	    icon.innerHTML = 'arrow_circle_down'
    	 } else {
    	    icon.innerHTML = 'arrow_circle_up'
    	 }
    })();
  }

  },
  /* handler:onClick */
  /* handler:onDelete */
  ['onDelete'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'PageFilter')) == 'Modified') {
    ___arguments.context.pageData['PageFilter'] = '';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('50d8bec85069e1ce0198f5e8c4670bd8'))['background-color'] = '#016288';
  }

  },
  /* handler:onDelete */
  /* content */
}))

define('./pages/home-previous/components/c8486c55ffb833b1731c386d281e1628/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var retrievedContacts, results;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function Search_Contacts() {
  if ((getObjectProperty(___arguments.context.pageData, 'TOGGLE_IncludeCompany')) == true) {
    retrievedContacts = (getObjectProperty((await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((['https://mgr.pockethost.io/api/collections/ACCOContacts/records?perPage=50&sort=+LastName,FirstName&filter=(','LastName~\'',(getObjectProperty(___arguments.context.pageData, 'DBSearchTerm')),'\' || FirstName~\'',(getObjectProperty(___arguments.context.pageData, 'DBSearchTerm')),'\' || Company~\'',(getObjectProperty(___arguments.context.pageData, 'DBSearchTerm')),'\')'].join('')))).set(({ [`Authorization`]: ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOContactsToken')) })).setEncoding('utf8').send()), 'items'));
  } else {
    retrievedContacts = (getObjectProperty((await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((['https://mgr.pockethost.io/api/collections/ACCOContacts/records?perPage=50&sort=+LastName,FirstName&filter=(','LastName~\'',(getObjectProperty(___arguments.context.pageData, 'DBSearchTerm')),'\' || FirstName~\'',(getObjectProperty(___arguments.context.pageData, 'DBSearchTerm')),'\')'].join('')))).set(({ [`Authorization`]: ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOContactsToken')) })).setEncoding('utf8').send()), 'items'));
  }
  return retrievedContacts
}


  if (___arguments.value == true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a1a8e4d209da625868a898e85398323e'))['color'] = '#990000';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a1a8e4d209da625868a898e85398323e'))['font-weight'] = 'bold';
    ___arguments.context.pageData['TOGGLE_IncludeCompany'] = true;
    results = await Search_Contacts();
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a1a8e4d209da625868a898e85398323e'))['color'] = '#000000';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a1a8e4d209da625868a898e85398323e'))['font-weight'] = 'normal';
    ___arguments.context.pageData['TOGGLE_IncludeCompany'] = false;
    results = await Search_Contacts();
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', results);

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/home-previous/components/96b815b891276784d638d95fab3833cd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var currentUser, retrievedContactsRawResponse, CurrentPageNumber;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  CurrentPageNumber = 0;
  ___arguments.context.pageData['pageCurser'] = 1;
  if (currentUser != false) {
    retrievedContactsRawResponse = (await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((String('https://mgr.pockethost.io/api/collections/ACCOContacts/records?perPage=25&sort=+LastName,FirstName&page=') + String(JSON.stringify((getObjectProperty(___arguments.context.pageData, 'pageCurser'))))))).set(({ [`Authorization`]: ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOContactsToken')) })).setEncoding('utf8').send());
    ___arguments.context.pageData['page'] = (getObjectProperty(retrievedContactsRawResponse, 'page'));
    ___arguments.context.pageData['perPage'] = (getObjectProperty(retrievedContactsRawResponse, 'perPage'));
    ___arguments.context.pageData['totalItems'] = (getObjectProperty(retrievedContactsRawResponse, 'totalItems'));
    ___arguments.context.pageData['totalPages'] = (getObjectProperty(retrievedContactsRawResponse, 'totalPages'));
    console.log('RetrievedContactsRawResponse:');
    console.log(retrievedContactsRawResponse);
    ___arguments.context.pageData['RetrievedContacts'] = (getObjectProperty(retrievedContactsRawResponse, 'items'));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', ({  }));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', (getObjectProperty(___arguments.context.pageData, 'RetrievedContacts')));
    ___arguments.context.pageData['DisplayingContactsMessage'] = (['Contact: ',(Number((getObjectProperty(___arguments.context.pageData, 'page')))) * (Number((getObjectProperty(___arguments.context.pageData, 'perPage')))),' | Page: ',(getObjectProperty(___arguments.context.pageData, 'page')),' (',(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8'))[0]), 'LastName')),' To ',(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8')).slice(-1)[0]), 'LastName')),') | Total Pages: ',(getObjectProperty(___arguments.context.pageData, 'totalPages')),' | Total Contacts: ',(getObjectProperty(___arguments.context.pageData, 'totalItems'))].join(''));
    console.log(currentUser);
    ___arguments.context.appData['currentUser'] = currentUser;
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('UserLogin', undefined);
  }
  ___arguments.context.pageData['DisplayingContactsMessage'] = (['Contact: ',(Number((getObjectProperty(___arguments.context.pageData, 'page')))) * (Number((getObjectProperty(___arguments.context.pageData, 'perPage')))),' | Page: ',(getObjectProperty(___arguments.context.pageData, 'page')),' (',(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8'))[0]), 'LastName')),' To ',(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8')).slice(-1)[0]), 'LastName')),') | Total Pages: ',(getObjectProperty(___arguments.context.pageData, 'totalPages')),' | Total Contacts: ',(getObjectProperty(___arguments.context.pageData, 'totalItems'))].join(''));

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'page')) == 1) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('96b815b891276784d638d95fab3833cd'))['background-color'] = '#9A91A6';
    return true;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('96b815b891276784d638d95fab3833cd'))['background-color'] = '#0A0A0A';
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/home-previous/components/f1542a58df082559e03864f8db487678/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var currentUser, retrievedContactsRawResponse, ContactsCountReturn, CurrentPageNumber;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['pageCurser'] = ((Number((getObjectProperty(___arguments.context.pageData, 'page')))) - 10);
  if (currentUser != false) {
    retrievedContactsRawResponse = (await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((String('https://mgr.pockethost.io/api/collections/ACCOContacts/records?perPage=25&sort=+LastName,FirstName&page=') + String(JSON.stringify((getObjectProperty(___arguments.context.pageData, 'pageCurser'))))))).set(({ [`Authorization`]: ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOContactsToken')) })).setEncoding('utf8').send());
    ___arguments.context.pageData['page'] = (getObjectProperty(retrievedContactsRawResponse, 'page'));
    ___arguments.context.pageData['perPage'] = (getObjectProperty(retrievedContactsRawResponse, 'perPage'));
    ___arguments.context.pageData['totalItems'] = (getObjectProperty(retrievedContactsRawResponse, 'totalItems'));
    ___arguments.context.pageData['totalPages'] = (getObjectProperty(retrievedContactsRawResponse, 'totalPages'));
    console.log('RetrievedContactsRawResponse:');
    console.log(retrievedContactsRawResponse);
    ___arguments.context.pageData['RetrievedContacts'] = (getObjectProperty(retrievedContactsRawResponse, 'items'));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', ({  }));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', (getObjectProperty(___arguments.context.pageData, 'RetrievedContacts')));
    ___arguments.context.pageData['DisplayingContactsMessage'] = (['Contact: ',(Number((getObjectProperty(___arguments.context.pageData, 'page')))) * (Number((getObjectProperty(___arguments.context.pageData, 'perPage')))),' | Page: ',(getObjectProperty(___arguments.context.pageData, 'page')),' (',(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8'))[0]), 'LastName')),' To ',(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8')).slice(-1)[0]), 'LastName')),') | Total Pages: ',(getObjectProperty(___arguments.context.pageData, 'totalPages')),' | Total Contacts: ',(getObjectProperty(___arguments.context.pageData, 'totalItems'))].join(''));
    console.log(currentUser);
    ___arguments.context.appData['currentUser'] = currentUser;
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('UserLogin', undefined);
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'page')) <= 10) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f1542a58df082559e03864f8db487678'))['background-color'] = '#9A91A6';
    return true;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f1542a58df082559e03864f8db487678'))['background-color'] = '#0A0A0A';
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/home-previous/components/8df8d2e2bef1ae08efcc44611b5882f1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var currentUser, retrievedContactsRawResponse, ContactsCountReturn, CurrentPageNumber;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['pageCurser'] = ((Number((getObjectProperty(___arguments.context.pageData, 'page')))) + 1);
  if (currentUser != false) {
    retrievedContactsRawResponse = (await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((String('https://mgr.pockethost.io/api/collections/ACCOContacts/records?perPage=25&sort=+LastName,FirstName&page=') + String(JSON.stringify((getObjectProperty(___arguments.context.pageData, 'pageCurser'))))))).set(({ [`Authorization`]: ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOContactsToken')) })).setEncoding('utf8').send());
    ___arguments.context.pageData['page'] = (getObjectProperty(retrievedContactsRawResponse, 'page'));
    ___arguments.context.pageData['perPage'] = (getObjectProperty(retrievedContactsRawResponse, 'perPage'));
    ___arguments.context.pageData['totalItems'] = (getObjectProperty(retrievedContactsRawResponse, 'totalItems'));
    ___arguments.context.pageData['totalPages'] = (getObjectProperty(retrievedContactsRawResponse, 'totalPages'));
    console.log('RetrievedContactsRawResponse:');
    console.log(retrievedContactsRawResponse);
    ___arguments.context.pageData['RetrievedContacts'] = (getObjectProperty(retrievedContactsRawResponse, 'items'));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', ({  }));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', (getObjectProperty(___arguments.context.pageData, 'RetrievedContacts')));
    ___arguments.context.pageData['DisplayingContactsMessage'] = (['Contact: ',(Number((getObjectProperty(___arguments.context.pageData, 'page')))) * (Number((getObjectProperty(___arguments.context.pageData, 'perPage')))),' | Page: ',(getObjectProperty(___arguments.context.pageData, 'page')),' (',(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8'))[0]), 'LastName')),' To ',(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8')).slice(-1)[0]), 'LastName')),') | Total Pages: ',(getObjectProperty(___arguments.context.pageData, 'totalPages')),' | Total Contacts: ',(getObjectProperty(___arguments.context.pageData, 'totalItems'))].join(''));
    console.log(currentUser);
    ___arguments.context.appData['currentUser'] = currentUser;
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('UserLogin', undefined);
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'page')) == (Number((getObjectProperty(___arguments.context.pageData, 'totalPages'))))) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('8df8d2e2bef1ae08efcc44611b5882f1'))['background-color'] = '#9A91A6';
    return true;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('8df8d2e2bef1ae08efcc44611b5882f1'))['background-color'] = '#0A0A0A';
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/home-previous/components/eb38a9bcb0711288da0800585d081f5a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var currentUser, retrievedContactsRawResponse, ContactsCountReturn, CurrentPageNumber;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['pageCurser'] = ((Number((getObjectProperty(___arguments.context.pageData, 'page')))) - 1);
  if (currentUser != false) {
    retrievedContactsRawResponse = (await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((String('https://mgr.pockethost.io/api/collections/ACCOContacts/records?perPage=25&sort=+LastName,FirstName&page=') + String(JSON.stringify((getObjectProperty(___arguments.context.pageData, 'pageCurser'))))))).set(({ [`Authorization`]: ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOContactsToken')) })).setEncoding('utf8').send());
    ___arguments.context.pageData['page'] = (getObjectProperty(retrievedContactsRawResponse, 'page'));
    ___arguments.context.pageData['perPage'] = (getObjectProperty(retrievedContactsRawResponse, 'perPage'));
    ___arguments.context.pageData['totalItems'] = (getObjectProperty(retrievedContactsRawResponse, 'totalItems'));
    ___arguments.context.pageData['totalPages'] = (getObjectProperty(retrievedContactsRawResponse, 'totalPages'));
    console.log('RetrievedContactsRawResponse:');
    console.log(retrievedContactsRawResponse);
    ___arguments.context.pageData['RetrievedContacts'] = (getObjectProperty(retrievedContactsRawResponse, 'items'));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', ({  }));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', (getObjectProperty(___arguments.context.pageData, 'RetrievedContacts')));
    ___arguments.context.pageData['DisplayingContactsMessage'] = (['Contact: ',(Number((getObjectProperty(___arguments.context.pageData, 'page')))) * (Number((getObjectProperty(___arguments.context.pageData, 'perPage')))),' | Page: ',(getObjectProperty(___arguments.context.pageData, 'page')),' (',(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8'))[0]), 'LastName')),' To ',(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8')).slice(-1)[0]), 'LastName')),') | Total Pages: ',(getObjectProperty(___arguments.context.pageData, 'totalPages')),' | Total Contacts: ',(getObjectProperty(___arguments.context.pageData, 'totalItems'))].join(''));
    console.log(currentUser);
    ___arguments.context.appData['currentUser'] = currentUser;
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('UserLogin', undefined);
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'page')) == 1) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('eb38a9bcb0711288da0800585d081f5a'))['background-color'] = '#9A91A6';
    return true;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('eb38a9bcb0711288da0800585d081f5a'))['background-color'] = '#0A0A0A';
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/home-previous/components/c38b81a1fde808e224a8dc634857c68a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var currentUser, retrievedContactsRawResponse, ContactsCountReturn, CurrentPageNumber;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['pageCurser'] = ((Number((getObjectProperty(___arguments.context.pageData, 'page')))) + 10);
  if (currentUser != false) {
    retrievedContactsRawResponse = (await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((String('https://mgr.pockethost.io/api/collections/ACCOContacts/records?perPage=25&sort=+LastName,FirstName&page=') + String(JSON.stringify((getObjectProperty(___arguments.context.pageData, 'pageCurser'))))))).set(({ [`Authorization`]: ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOContactsToken')) })).setEncoding('utf8').send());
    ___arguments.context.pageData['page'] = (getObjectProperty(retrievedContactsRawResponse, 'page'));
    ___arguments.context.pageData['perPage'] = (getObjectProperty(retrievedContactsRawResponse, 'perPage'));
    ___arguments.context.pageData['totalItems'] = (getObjectProperty(retrievedContactsRawResponse, 'totalItems'));
    ___arguments.context.pageData['totalPages'] = (getObjectProperty(retrievedContactsRawResponse, 'totalPages'));
    console.log('RetrievedContactsRawResponse:');
    console.log(retrievedContactsRawResponse);
    ___arguments.context.pageData['RetrievedContacts'] = (getObjectProperty(retrievedContactsRawResponse, 'items'));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', ({  }));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', (getObjectProperty(___arguments.context.pageData, 'RetrievedContacts')));
    ___arguments.context.pageData['DisplayingContactsMessage'] = (['Contact: ',(Number((getObjectProperty(___arguments.context.pageData, 'page')))) * (Number((getObjectProperty(___arguments.context.pageData, 'perPage')))),' | Page: ',(getObjectProperty(___arguments.context.pageData, 'page')),' (',(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8'))[0]), 'LastName')),' To ',(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8')).slice(-1)[0]), 'LastName')),') | Total Pages: ',(getObjectProperty(___arguments.context.pageData, 'totalPages')),' | Total Contacts: ',(getObjectProperty(___arguments.context.pageData, 'totalItems'))].join(''));
    console.log(currentUser);
    ___arguments.context.appData['currentUser'] = currentUser;
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('UserLogin', undefined);
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'page')) > (Number((getObjectProperty(___arguments.context.pageData, 'totalPages')))) - 10) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c38b81a1fde808e224a8dc634857c68a'))['background-color'] = '#9A91A6';
    return true;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c38b81a1fde808e224a8dc634857c68a'))['background-color'] = '#0A0A0A';
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/home-previous/components/3f18a098cf5807a87b084d784a98910c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var currentUser, retrievedContactsRawResponse, CurrentPageNumber;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  CurrentPageNumber = 0;
  ___arguments.context.pageData['pageCurser'] = (Number((getObjectProperty(___arguments.context.pageData, 'totalPages'))));
  if (currentUser != false) {
    retrievedContactsRawResponse = (await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((String('https://mgr.pockethost.io/api/collections/ACCOContacts/records?perPage=25&sort=+LastName,FirstName&page=') + String(JSON.stringify((getObjectProperty(___arguments.context.pageData, 'pageCurser'))))))).set(({ [`Authorization`]: ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOContactsToken')) })).setEncoding('utf8').send());
    ___arguments.context.pageData['page'] = (getObjectProperty(retrievedContactsRawResponse, 'page'));
    ___arguments.context.pageData['perPage'] = (getObjectProperty(retrievedContactsRawResponse, 'perPage'));
    ___arguments.context.pageData['totalItems'] = (getObjectProperty(retrievedContactsRawResponse, 'totalItems'));
    ___arguments.context.pageData['totalPages'] = (getObjectProperty(retrievedContactsRawResponse, 'totalPages'));
    console.log('RetrievedContactsRawResponse:');
    console.log(retrievedContactsRawResponse);
    ___arguments.context.pageData['RetrievedContacts'] = (getObjectProperty(retrievedContactsRawResponse, 'items'));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', ({  }));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', (getObjectProperty(___arguments.context.pageData, 'RetrievedContacts')));
    ___arguments.context.pageData['DisplayingContactsMessage'] = (['Contact: ',(Number((getObjectProperty(___arguments.context.pageData, 'page')))) * (Number((getObjectProperty(___arguments.context.pageData, 'perPage')))),' | Page: ',(getObjectProperty(___arguments.context.pageData, 'page')),' (',(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8'))[0]), 'LastName')),' To ',(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8')).slice(-1)[0]), 'LastName')),') | Total Pages: ',(getObjectProperty(___arguments.context.pageData, 'totalPages')),' | Total Contacts: ',(getObjectProperty(___arguments.context.pageData, 'totalItems'))].join(''));
    console.log(currentUser);
    ___arguments.context.appData['currentUser'] = currentUser;
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('UserLogin', undefined);
  }
  ___arguments.context.pageData['DisplayingContactsMessage'] = (['Contact: ',(Number((getObjectProperty(___arguments.context.pageData, 'page')))) * (Number((getObjectProperty(___arguments.context.pageData, 'perPage')))),' | Page: ',(getObjectProperty(___arguments.context.pageData, 'page')),' (',(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8'))[0]), 'LastName')),' To ',(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8')).slice(-1)[0]), 'LastName')),') | Total Pages: ',(getObjectProperty(___arguments.context.pageData, 'totalPages')),' | Total Contacts: ',(getObjectProperty(___arguments.context.pageData, 'totalItems'))].join(''));

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'page')) == (Number((getObjectProperty(___arguments.context.pageData, 'totalPages'))))) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3f18a098cf5807a87b084d784a98910c'))['background-color'] = '#9A91A6';
    return true;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3f18a098cf5807a87b084d784a98910c'))['background-color'] = '#0A0A0A';
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/home-previous/components/8bf48e763098bc9bd82790dc5238e3c8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(JSON.parse((JSON.stringify(___arguments.context.getComponentDataStoreByUid('5e3f583561b818f8a1786ac80fa77ec8')))));
  console.log(JSON.parse((JSON.stringify((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'drawerDataModel')), 'MiddleName'))))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/home-previous/components/b1d3e8684cdf46a8fe882c58ccf881cb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('#Bottom', false, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/home-previous/components/5b9545ea538797582b284eb9c91349e8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('#Top', false, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/home-previous/components/fbefd2bb6fec4718d6382d38ad733348/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/home-previous/components/92b96158c4d823916c18019a5b28fd83/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'CurrentlySelectedContactData')), 'FirstName'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/home-previous/components/31f864bdf9b8c4982b985e46c2a8175a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'CurrentlySelectedContactData')), 'LastName'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/home-previous/components/6672cef89de766787f2889f880d8b618/bundle.js', [], () => ({
  /* content */
  /* handler:onReadOnlyStateAssignment */
  ['onReadOnlyStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.pageData, 'EditMode')))

  },
  /* handler:onReadOnlyStateAssignment */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6672cef89de766787f2889f880d8b618')), 'value')) == '') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('6672cef89de766787f2889f880d8b618'))['border-color'] = '#AE0530';
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('6672cef89de766787f2889f880d8b618'))['border-color'] = '#0520AE';
  }

  },
  /* handler:onBlur */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'drawerDataModel')), 'FirstName'))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/home-previous/components/af7832b8d436d7bdb868946446a9d5fc/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'drawerDataModel')), 'LastName'))

  },
  /* handler:onValueAssignment */
  /* handler:onReadOnlyStateAssignment */
  ['onReadOnlyStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.pageData, 'EditMode')))

  },
  /* handler:onReadOnlyStateAssignment */
  /* content */
}))

define('./pages/home-previous/components/ac22d7a23f48b4a88ef44e890c58d724/bundle.js', [], () => ({
  /* content */
  /* handler:onReadOnlyStateAssignment */
  ['onReadOnlyStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.pageData, 'EditMode')))

  },
  /* handler:onReadOnlyStateAssignment */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'drawerDataModel')), 'MiddleName'))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/home-previous/components/c6d8a878da6ee2a81d1818587298aef2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['EditMode'] = true;
  ___arguments.context.pageData['ModifiedData'] = true;
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c6d8a878da6ee2a81d1818587298aef2'))['background-color'] = '#A00000';

  },
  /* handler:onClick */
  /* handler:onDelete */
  ['onDelete'](___arguments) {
      ___arguments.context.pageData['EditMode'] = false;
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c6d8a878da6ee2a81d1818587298aef2'))['background-color'] = '#016288';

  },
  /* handler:onDelete */
  /* content */
}))

define('./pages/home-previous/components/99a8df394f156cc874813c38d937d968/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('99a8df394f156cc874813c38d937d968'))['color'] = '#03B935';
  console.log('Data to save: ');
  console.log(JSON.stringify((JSON.parse(___arguments.context.getComponentDataStoreByUid('f548849959d80918247fdbdd7f982de8')))));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f548849959d80918247fdbdd7f982de8'), 'NeedToSave')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/home-previous/components/390d1ad861e8a4a817487017ebcec028/bundle.js', [], () => ({
  /* content */
  /* handler:onReadOnlyStateAssignment */
  ['onReadOnlyStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.pageData, 'EditMode')))

  },
  /* handler:onReadOnlyStateAssignment */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'drawerDataModel')), 'Suffix'))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/home-previous/components/60d8097a61c88c0d830a43e79398466a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(JSON.parse((JSON.stringify((getObjectProperty(___arguments.context.pageData, 'drawerDataModel'))))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/home-previous/components/9458d2e81328842c3e982c284f77e859/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('drawerDataModel from within the drawer...');
  console.log(JSON.parse((JSON.stringify((getObjectProperty(___arguments.context.pageData, 'drawerDataModel'))))));
  console.log('drawerDataModel: getting MiddleName');
  console.log(JSON.parse((JSON.stringify((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'drawerDataModel')), 'MiddleName'))))));
  console.log('drawerDataModel: getting LastName (no conversion)');
  console.log(JSON.parse((JSON.stringify((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'drawerDataModel')), 'LastName'))))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/home-previous/components/4e289aefe01b9378bf79b7f89fc4a648/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, targetObject, sourceObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', (await asyncListFilter(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8')), async (item) => {
     if ((getObjectProperty(item, 'id')) == (getObjectProperty(___arguments.context.pageData, 'CurrentlySelectedContactID'))) {
      item['NeedToSave'] = true;
      item['FirstName'] = (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6672cef89de766787f2889f880d8b618')), 'value'));
      item['MiddleName'] = (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ac22d7a23f48b4a88ef44e890c58d724')), 'value'));
      item['MiddleName_Modified'] = (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ac22d7a23f48b4a88ef44e890c58d724')), 'value'));
      item['LastName'] = (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('af7832b8d436d7bdb868946446a9d5fc')), 'value'));
      item['Contact_Name'] = ([(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6672cef89de766787f2889f880d8b618')), 'value')),' ',(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('af7832b8d436d7bdb868946446a9d5fc')), 'value'))].join(''));
      return true;
    } else {
      return true;
    }


   return item;
  })));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/home-previous/components/b8e8c9b587c89757fca8d388c695c5b8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('5e3f583561b818f8a1786ac80fa77ec8')['FirstName'] = 'This is';
  ___arguments.context.getComponentDataStoreByUid('5e3f583561b818f8a1786ac80fa77ec8')['MiddleName'] = 'a freakin\'';
  ___arguments.context.getComponentDataStoreByUid('5e3f583561b818f8a1786ac80fa77ec8')['LastName'] = 'test!';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/home-previous/components/7fb32f6897338c2d3f190f8cb1d62d0c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(JSON.parse((JSON.stringify((getObjectProperty(___arguments.context.pageData, 'CurrentlySelectedContactData'))))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/home-previous/components/a298b228cfffba38b7f81108b5584fa8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log(JSON.parse((JSON.stringify(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('99683348f21a0478cb18ff2b2078896a'))))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/home_5-17b1/components/ab288c9ed0e835b89a08e4b88e03dc16/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOUserToken'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/home_5-17b1/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var currentUser, retrievedContactsRawResponse, storedTokenFromCookie;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function Set_pageData_Variables() {
  ___arguments.context.pageData['drawerDataModel'] = ({  });
  ___arguments.context.pageData['RetrievedContactsRawResponse'] = ({  });
  ___arguments.context.pageData['OpenDrawer'] = false;
  ___arguments.context.pageData['DisplayingContactsPageNumber'] = 0;
}


  await Set_pageData_Variables();
  storedTokenFromCookie = ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOUserToken'));
  currentUser = (await BackendlessUI.Functions.Custom['fn_fb29ed716ee40c6ec05a6af2fb62b61d'](storedTokenFromCookie));
  if (currentUser != false) {
    ___arguments.context.appData['currentUser'] = currentUser;
    retrievedContactsRawResponse = (await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://mgr.pockethost.io/api/collections/ACCOContacts/records?perPage=25&sort=+LastName,FirstName')).set(({ [`Authorization`]: ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOContactsToken')) })).setEncoding('utf8').send());
    ___arguments.context.pageData['pageCursor'] = 0;
    ___arguments.context.pageData['page'] = (getObjectProperty(retrievedContactsRawResponse, 'page'));
    ___arguments.context.pageData['perPage'] = (getObjectProperty(retrievedContactsRawResponse, 'perPage'));
    ___arguments.context.pageData['totalItems'] = (getObjectProperty(retrievedContactsRawResponse, 'totalItems'));
    ___arguments.context.pageData['totalPages'] = (getObjectProperty(retrievedContactsRawResponse, 'totalPages'));
    console.log('RetrievedContactsRawResponse:');
    console.log(retrievedContactsRawResponse);
    ___arguments.context.pageData['RetrievedContacts'] = (getObjectProperty(retrievedContactsRawResponse, 'items'));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', (getObjectProperty(___arguments.context.pageData, 'RetrievedContacts')));
    console.log(currentUser);
    ___arguments.context.pageData['DisplayingContactsMessage'] = (['Contact: ',(Number((getObjectProperty(___arguments.context.pageData, 'page')))) * (Number((getObjectProperty(___arguments.context.pageData, 'perPage')))),' | Page: ',(getObjectProperty(___arguments.context.pageData, 'page')),' (',(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8'))[0]), 'LastName')),' To ',(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8')).slice(-1)[0]), 'LastName')),') | Total Pages: ',(getObjectProperty(___arguments.context.pageData, 'totalPages')),' | Total Contacts: ',(getObjectProperty(___arguments.context.pageData, 'totalItems'))].join(''));
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('UserLogin', undefined);
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/home_5-17b1/components/54081436bb6842a82788d1d8c2a7dbc1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(getObjectProperty(___arguments.context.appData, 'currentUser'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/home_5-17b1/components/e65831ef35789938da8896bca018c4e8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      localStorage.removeItem('ACCOUserToken');
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('UserLogin', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/home_5-17b1/components/cb980528d6cebac8f0984878c8985798/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(getObjectProperty(___arguments.context.pageData, 'RetrievedContacts'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/home_5-17b1/components/26c848494068ad8874b4b73208376878/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await (async function(TextToCopy) {
  	navigator.clipboard.writeText(TextToCopy);
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5e3f583561b818f8a1786ac80fa77ec8'), 'BusinessPhone')));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9954b1e8ff38cc68d3f769a8c488aa1c'))['color'] = '#A00000';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9954b1e8ff38cc68d3f769a8c488aa1c'))['text-decoration-line'] = 'underline';
  await new Promise(r => setTimeout(r, 400 || 0));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9954b1e8ff38cc68d3f769a8c488aa1c'))['color'] = '#000000';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9954b1e8ff38cc68d3f769a8c488aa1c'))['text-decoration-line'] = 'none';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/home_5-17b1/components/8c26d238ec58efa916980c5156989ff8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('14160948a388f4c82618c6e80fc67fec');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/home_5-17b1/components/9f18306e287839f6b688b2785af8c8ec/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var decision, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'isContactSelected')) == true) {
    console.log(await asyncListFilter(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8')), async (item) => {
       if ((getObjectProperty(item, 'CurrentlySelectedContact')) == true) {
        delete item['CurrentlySelectedContact'];
        decision = true;
      } else {
        decision = true;
      }


     return ;
    }));
  }
  ___arguments.context.pageData['OpenDrawer'] = false;
  ___arguments.context.pageData['CurrentlySelectedContact'] = false;
  ___arguments.context.pageData['CurrentlySelectedContactObjectID'] = '';
  ___arguments.context.pageData['isContactSelected'] = false;
  ___arguments.context.pageData['EditMode'] = false;
  await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('d5e8e785986ad5d8c618fb16527f9038', undefined);
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bb85878828193def9f8054853f8949b'))['min-height'] = '100%';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/home_5-17b1/components/34b170cf59982968ddc866980023ca7f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var decision, item, stripOutSelectedContacts;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function Set_pageData_Variables() {
  ___arguments.context.pageData['AddScrollDelay'] = true;
  ___arguments.context.pageData['OpenDrawer'] = true;
  ___arguments.context.pageData['CurrentlySelectedContact'] = true;
  ___arguments.context.pageData['isContactSelected'] = true;
  ___arguments.context.getComponentDataStoreByUid('f548849959d80918247fdbdd7f982de8')['CurrentlySelectedContact'] = true;
  ___arguments.context.pageData['CurrentlySelectedContactID'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f548849959d80918247fdbdd7f982de8'), 'id'));
  ___arguments.context.pageData['CurrentlySelectedContactData'] = (JSON.parse((JSON.stringify(___arguments.context.getComponentDataStoreByUid('f548849959d80918247fdbdd7f982de8')))));
}


  if ((getObjectProperty(___arguments.context.pageData, 'isContactSelected')) == true) {
    stripOutSelectedContacts = (await asyncListFilter(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8')), async (item) => {
       if ((getObjectProperty(item, 'CurrentlySelectedContact')) == true) {
        delete item['CurrentlySelectedContact'];
        decision = true;
      } else {
        decision = true;
      }


     return decision;
    }));
  }
  await Set_pageData_Variables();
  console.log('Pushing selected contact to pageData.drawerDataModel');
  console.log(JSON.parse((JSON.stringify(___arguments.context.getComponentDataStoreByUid('f548849959d80918247fdbdd7f982de8')))));
  ___arguments.context.pageData['drawerDataModel'] = (JSON.parse((JSON.stringify(___arguments.context.getComponentDataStoreByUid('f548849959d80918247fdbdd7f982de8')))));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bb85878828193def9f8054853f8949b'))['min-height'] = '125%';
  await (async function() {
  	const elements = document.getElementsByClassName('MainContactsRow');
  	const currentHeight = elements[0].clientHeight; // Get the current height
  	newHeight = currentHeight
  	
  	// newHeight = currentHeight * (1 + percentageIncrease / 100); // Calculate new height
  	if (newHeight < 1150) {
  	  newHeight = 1150;
  	}
  	elements[0].style.minHeight = newHeight + 'px'; // Set the new height
  	// alert('The current height is: '+ currentHeight);

  })();
  (function (component) { component.el.scrollIntoView() })((getObjectProperty(___arguments.context.pageData, (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f548849959d80918247fdbdd7f982de8'), 'id')))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/home_5-17b1/components/d5e8e785986ad5d8c618fb16527f9038/bundle.js', [], () => ({
  /* content */
  /* handler:isOpenLogic */
  ['isOpenLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'OpenDrawer'))

  },
  /* handler:isOpenLogic */
  /* handler:onClose */
  async ['onClose'](___arguments) {
    var result, item, decision;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  ___arguments.context.pageData['OpenDrawer'] = false;
  if ((getObjectProperty(___arguments.context.pageData, 'isContactSelected')) == true) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', (JSON.parse((JSON.stringify((await asyncListFilter(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8')), async (item) => {
       if ((getObjectProperty(item, 'CurrentlySelectedContact')) == true) {
        delete item['CurrentlySelectedContact'];
        decision = true;
      } else {
        decision = true;
      }


     return decision;
    })))))));
  }
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bb85878828193def9f8054853f8949b'))['height'] = 'auto';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bb85878828193def9f8054853f8949b'))['min-height'] = 'auto';
  ___arguments.context.pageData['isContactSelected'] = false;
  ___arguments.context.pageData['EditMode'] = false;
  console.log((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8'));
  result = (await (async function(modifiedData) {
  	var userPreference;
  	
  	if (modifiedData) {
  	
  	  if (confirm("Save your changes? [Enter] to save or [Esc] to cancel") == true) {
  	    userPreference = "Save Requested";
  	  } else {
  	    userPreference = "Save Cancelled!";
  	  }
  	// console.log(userPreference)
  	return userPreference
  	  
  	}

  })((getObjectProperty(___arguments.context.pageData, 'ModifiedData'))));
  if (result == 'Save Requested') {
    console.log('Save Data Requested');
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', (JSON.parse((JSON.stringify((await asyncListFilter(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8')), async (item) => {
       if ((getObjectProperty(item, 'id')) == (getObjectProperty(___arguments.context.pageData, 'CurrentlySelectedContactID'))) {
        item['NeedToSave'] = true;
        return true;
      } else {
        return true;
      }


     return item;
    })))))));
  } else {
    console.log('Save Data Cancelled!');
  }
  ___arguments.context.pageData['ModifiedData'] = false;

  },
  /* handler:onClose */
  /* handler:onOpen */
  ['onOpen'](___arguments) {
      console.log('BAM!!!');

  },
  /* handler:onOpen */
  /* content */
}))

define('./pages/home_5-17b1/components/715ffae88be9507ff0b894488f3f2571/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f548849959d80918247fdbdd7f982de8'), 'CurrentlySelectedContact')) == true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f548849959d80918247fdbdd7f982de8'))['background-color'] = '#990939';
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f548849959d80918247fdbdd7f982de8'))['background-color'] = '#016288';
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/home_5-17b1/components/f548849959d80918247fdbdd7f982de8/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData[(getObjectProperty(___arguments.context.dataModel, 'id'))] = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f548849959d80918247fdbdd7f982de8'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/home_5-17b1/components/c4e88a1ec9685fd8d8c459588a08e548/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f548849959d80918247fdbdd7f982de8'), 'EmailAddress')) != '') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c4e88a1ec9685fd8d8c459588a08e548'))['color'] = '#FFFFFF';
  }

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f548849959d80918247fdbdd7f982de8'), 'EmailAddress')) != '') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c4e88a1ec9685fd8d8c459588a08e548'))['color'] = '#B4B4B4';
  }

  },
  /* handler:onMouseOut */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('3d1800088b7fe3386f380083d4e8b13d')), 'text')) != '') {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/home_5-17b1/components/9a38cdb1fe6889b8853c0d7891b8ca88/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var response, DBSearchTerm, retrievedContacts;

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setTimeouts'); if (timerId && timers[timerId]) {    clearTimeout(timers[timerId]);    delete timers[timerId]; }}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setTimeouts'); const timer = setTimeout(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function Search_Contacts() {
  if ((getObjectProperty(___arguments.context.pageData, 'TOGGLE_IncludeCompany')) == true) {
    retrievedContacts = (getObjectProperty((await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((['https://mgr.pockethost.io/api/collections/ACCOContacts/records?perPage=50&sort=+LastName,FirstName&filter=(','LastName~\'',___arguments.value,'\' || FirstName~\'',___arguments.value,'\' || Company~\'',___arguments.value,'\')'].join('')))).set(({ [`Authorization`]: ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOContactsToken')) })).setEncoding('utf8').send()), 'items'));
    ___arguments.context.pageData['RetrievedContacts'] = retrievedContacts;
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9048e37ecae67908d8bd408823dce8d8'))['background-color'] = '#A00000';
    ___arguments.context.pageData['MAKEITWHITE'] = true;
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ee68b608a0ec67383ffecb48626858c8'))['color'] = '#FFFFFF';
  } else {
    retrievedContacts = (getObjectProperty((await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((['https://mgr.pockethost.io/api/collections/ACCOContacts/records?perPage=50&sort=+LastName,FirstName&filter=(','LastName~\'',___arguments.value,'\' || FirstName~\'',___arguments.value,'\')'].join('')))).set(({ [`Authorization`]: ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOContactsToken')) })).setEncoding('utf8').send()), 'items'));
  }
  return retrievedContacts
}

/**
 * Describe this function...
 */
async function Reset_Search() {
  retrievedContacts = (getObjectProperty((await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((String('https://mgr.pockethost.io/api/collections/ACCOContacts/records?perPage=25&sort=+LastName,FirstName')))).set(({ [`Authorization`]: ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOContactsToken')) })).setEncoding('utf8').send()), 'items'));
  ___arguments.context.pageData['RetrievedContacts'] = retrievedContacts;
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9048e37ecae67908d8bd408823dce8d8'))['background-color'] = '#F5F5F5';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9a38cdb1fe6889b8853c0d7891b8ca88'))['color'] = '#000000';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ee68b608a0ec67383ffecb48626858c8'))['color'] = '#AD0505';
  ___arguments.context.pageData['MAKEITWHITE'] = false;
  ___arguments.context.appData['ForceSearch'] = false;
  return retrievedContacts
}


  stopSetTimeout('lazySearch');

  ;(function() {
    const callback = async () => {
        DBSearchTerm = ___arguments.value;
    ___arguments.context.pageData['DBSearchTerm'] = DBSearchTerm;
    response = await Search_Contacts();
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', ({  }));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', response);
    ___arguments.context.appData['ForceSearch'] = true;

    };

    const timerId = 'lazySearch';
    const timerDelay = 1000;

    runSetTimeout(timerId, callback, timerDelay)
  })()
  if (___arguments.value == '') {
    response = await Search_Contacts();
    response = await Reset_Search();
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', ({  }));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', response);
    ___arguments.context.appData['ForceSearch'] = false;
    ___arguments.context.pageData['DBSearchTerm'] = '';
  } else {
    response = await Search_Contacts();
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', ({  }));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', response);
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9048e37ecae67908d8bd408823dce8d8'))['background-color'] = '#A00000';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9a38cdb1fe6889b8853c0d7891b8ca88'))['color'] = '#FFFFFF';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ee68b608a0ec67383ffecb48626858c8'))['color'] = '#FFFFFF';
    ___arguments.context.pageData['MAKEITWHITE'] = true;
    ___arguments.context.appData['ForceSearch'] = true;
  }
  if (getValueLength(___arguments.value) == 0) {
    ___arguments.context.pageData['DBSearchTerm'] = '';
    stopSetTimeout('lazySearch');
  }

  },
  /* handler:onChange */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    var classList;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'MAKEITWHITE')) == true) {
    classList = ['input-white'];
  } else {
    classList = ['input-black'];
  }
  return classList;

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/home_5-17b1/components/ee68b608a0ec67383ffecb48626858c8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var retrievedContacts;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setTimeouts'); if (timerId && timers[timerId]) {    clearTimeout(timers[timerId]);    delete timers[timerId]; }}

/**
 * Describe this function...
 */
async function Reset_Search() {
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', ({  }));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', (getObjectProperty((await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((String('https://mgr.pockethost.io/api/collections/ACCOContacts/records?perPage=25&sort=+LastName,FirstName')))).set(({ [`Authorization`]: ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOContactsToken')) })).setEncoding('utf8').send()), 'items')));
  ___arguments.context.pageData['RetrievedContacts'] = retrievedContacts;
}


  await Reset_Search();
  ___arguments.context.pageData['DBSearchTerm'] = '';
  ___arguments.context.pageData['value'] = '';
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('9a38cdb1fe6889b8853c0d7891b8ca88'))['value'] = '';
  ___arguments.context.pageData['ForceSearch'] = false;
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9048e37ecae67908d8bd408823dce8d8'))['background-color'] = '#F5F5F5';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ee68b608a0ec67383ffecb48626858c8'))['color'] = '#AD0505';
  ___arguments.context.pageData['MAKEITWHITE'] = false;
  ___arguments.context.pageData['MAKEITBLACK'] = (!(getObjectProperty(___arguments.context.pageData, 'MAKEITWHITE')));
  stopSetTimeout('lazySearch');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/home_5-17b1/components/3a4106331cb86b6899de7db685e6a9f2/bundle.js', [], () => ({
  /* content */
  /* handler:onDelete */
  ['onDelete'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'PageFilter')) == 'Created') {
    ___arguments.context.pageData['PageFilter'] = '';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3a4106331cb86b6899de7db685e6a9f2'))['background-color'] = '#016288';
  }

  },
  /* handler:onDelete */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'PageFilter')) != 'Created') {
    ___arguments.context.pageData['PageFilter'] = 'Created';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3a4106331cb86b6899de7db685e6a9f2'))['background-color'] = '#A00000';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('86684ec8198c47f8c1a80e08638823b6'))['background-color'] = '#016288';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('50d8bec85069e1ce0198f5e8c4670bd8'))['background-color'] = '#016288';
  } else {
    ___arguments.context.pageData['CreatedDirectionDown'] = (!(getObjectProperty(___arguments.context.pageData, 'CreatedDirectionDown')));
    await (async function() {
    	const icon = document.querySelector('.created-chip-class i')

    	if (icon.innerHTML === 'arrow_circle_up') {
    	    icon.innerHTML = 'arrow_circle_down'
    	 } else {
    	    icon.innerHTML = 'arrow_circle_up'
    	 }
    })();
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/home_5-17b1/components/86684ec8198c47f8c1a80e08638823b6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'PageFilter')) != 'Viewed') {
    ___arguments.context.pageData['PageFilter'] = 'Viewed';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3a4106331cb86b6899de7db685e6a9f2'))['background-color'] = '#016288';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('86684ec8198c47f8c1a80e08638823b6'))['background-color'] = '#A00000';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('50d8bec85069e1ce0198f5e8c4670bd8'))['background-color'] = '#016288';
  } else {
    ___arguments.context.pageData['ViewedDirectionDown'] = (!(getObjectProperty(___arguments.context.pageData, 'ViewedDirectionDown')));
    await (async function() {
    	const icon = document.querySelector('.viewed-chip-class i')

    	if (icon.innerHTML === 'arrow_circle_up') {
    	    icon.innerHTML = 'arrow_circle_down'
    	 } else {
    	    icon.innerHTML = 'arrow_circle_up'
    	 }
    })();
  }

  },
  /* handler:onClick */
  /* handler:onDelete */
  ['onDelete'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'PageFilter')) == 'Viewed') {
    ___arguments.context.pageData['PageFilter'] = '';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('86684ec8198c47f8c1a80e08638823b6'))['background-color'] = '#016288';
  }

  },
  /* handler:onDelete */
  /* content */
}))

define('./pages/home_5-17b1/components/50d8bec85069e1ce0198f5e8c4670bd8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'PageFilter')) != 'Modified') {
    ___arguments.context.pageData['PageFilter'] = 'Modified';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3a4106331cb86b6899de7db685e6a9f2'))['background-color'] = '#016288';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('86684ec8198c47f8c1a80e08638823b6'))['background-color'] = '#016288';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('50d8bec85069e1ce0198f5e8c4670bd8'))['background-color'] = '#A00000';
  } else {
    ___arguments.context.pageData['ModifiedDirectionDown'] = (!(getObjectProperty(___arguments.context.pageData, 'ModifiedDirectionDown')));
    await (async function() {
    	const icon = document.querySelector('.modified-chip-class i')

    	if (icon.innerHTML === 'arrow_circle_up') {
    	    icon.innerHTML = 'arrow_circle_down'
    	 } else {
    	    icon.innerHTML = 'arrow_circle_up'
    	 }
    })();
  }

  },
  /* handler:onClick */
  /* handler:onDelete */
  ['onDelete'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'PageFilter')) == 'Modified') {
    ___arguments.context.pageData['PageFilter'] = '';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('50d8bec85069e1ce0198f5e8c4670bd8'))['background-color'] = '#016288';
  }

  },
  /* handler:onDelete */
  /* content */
}))

define('./pages/home_5-17b1/components/c8486c55ffb833b1731c386d281e1628/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var retrievedContacts, results;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function Search_Contacts() {
  if ((getObjectProperty(___arguments.context.pageData, 'TOGGLE_IncludeCompany')) == true) {
    retrievedContacts = (getObjectProperty((await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((['https://mgr.pockethost.io/api/collections/ACCOContacts/records?perPage=50&sort=+LastName,FirstName&filter=(','LastName~\'',(getObjectProperty(___arguments.context.pageData, 'DBSearchTerm')),'\' || FirstName~\'',(getObjectProperty(___arguments.context.pageData, 'DBSearchTerm')),'\' || Company~\'',(getObjectProperty(___arguments.context.pageData, 'DBSearchTerm')),'\')'].join('')))).set(({ [`Authorization`]: ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOContactsToken')) })).setEncoding('utf8').send()), 'items'));
  } else {
    retrievedContacts = (getObjectProperty((await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((['https://mgr.pockethost.io/api/collections/ACCOContacts/records?perPage=50&sort=+LastName,FirstName&filter=(','LastName~\'',(getObjectProperty(___arguments.context.pageData, 'DBSearchTerm')),'\' || FirstName~\'',(getObjectProperty(___arguments.context.pageData, 'DBSearchTerm')),'\')'].join('')))).set(({ [`Authorization`]: ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOContactsToken')) })).setEncoding('utf8').send()), 'items'));
  }
  return retrievedContacts
}


  if (___arguments.value == true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a1a8e4d209da625868a898e85398323e'))['color'] = '#990000';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a1a8e4d209da625868a898e85398323e'))['font-weight'] = 'bold';
    ___arguments.context.pageData['TOGGLE_IncludeCompany'] = true;
    results = await Search_Contacts();
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a1a8e4d209da625868a898e85398323e'))['color'] = '#000000';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a1a8e4d209da625868a898e85398323e'))['font-weight'] = 'normal';
    ___arguments.context.pageData['TOGGLE_IncludeCompany'] = false;
    results = await Search_Contacts();
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', results);

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/home_5-17b1/components/96b815b891276784d638d95fab3833cd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var currentUser, retrievedContactsRawResponse, CurrentPageNumber;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  CurrentPageNumber = 0;
  ___arguments.context.pageData['pageCurser'] = 1;
  if (currentUser != false) {
    retrievedContactsRawResponse = (await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((String('https://mgr.pockethost.io/api/collections/ACCOContacts/records?perPage=25&sort=+LastName,FirstName&page=') + String(JSON.stringify((getObjectProperty(___arguments.context.pageData, 'pageCurser'))))))).set(({ [`Authorization`]: ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOContactsToken')) })).setEncoding('utf8').send());
    ___arguments.context.pageData['page'] = (getObjectProperty(retrievedContactsRawResponse, 'page'));
    ___arguments.context.pageData['perPage'] = (getObjectProperty(retrievedContactsRawResponse, 'perPage'));
    ___arguments.context.pageData['totalItems'] = (getObjectProperty(retrievedContactsRawResponse, 'totalItems'));
    ___arguments.context.pageData['totalPages'] = (getObjectProperty(retrievedContactsRawResponse, 'totalPages'));
    console.log('RetrievedContactsRawResponse:');
    console.log(retrievedContactsRawResponse);
    ___arguments.context.pageData['RetrievedContacts'] = (getObjectProperty(retrievedContactsRawResponse, 'items'));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', ({  }));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', (getObjectProperty(___arguments.context.pageData, 'RetrievedContacts')));
    ___arguments.context.pageData['DisplayingContactsMessage'] = (['Contact: ',(Number((getObjectProperty(___arguments.context.pageData, 'page')))) * (Number((getObjectProperty(___arguments.context.pageData, 'perPage')))),' | Page: ',(getObjectProperty(___arguments.context.pageData, 'page')),' (',(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8'))[0]), 'LastName')),' To ',(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8')).slice(-1)[0]), 'LastName')),') | Total Pages: ',(getObjectProperty(___arguments.context.pageData, 'totalPages')),' | Total Contacts: ',(getObjectProperty(___arguments.context.pageData, 'totalItems'))].join(''));
    console.log(currentUser);
    ___arguments.context.appData['currentUser'] = currentUser;
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('UserLogin', undefined);
  }
  ___arguments.context.pageData['DisplayingContactsMessage'] = (['Contact: ',(Number((getObjectProperty(___arguments.context.pageData, 'page')))) * (Number((getObjectProperty(___arguments.context.pageData, 'perPage')))),' | Page: ',(getObjectProperty(___arguments.context.pageData, 'page')),' (',(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8'))[0]), 'LastName')),' To ',(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8')).slice(-1)[0]), 'LastName')),') | Total Pages: ',(getObjectProperty(___arguments.context.pageData, 'totalPages')),' | Total Contacts: ',(getObjectProperty(___arguments.context.pageData, 'totalItems'))].join(''));

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'page')) == 1) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('96b815b891276784d638d95fab3833cd'))['background-color'] = '#9A91A6';
    return true;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('96b815b891276784d638d95fab3833cd'))['background-color'] = '#0A0A0A';
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/home_5-17b1/components/f1542a58df082559e03864f8db487678/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var currentUser, retrievedContactsRawResponse, ContactsCountReturn, CurrentPageNumber;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['pageCurser'] = ((Number((getObjectProperty(___arguments.context.pageData, 'page')))) - 10);
  if (currentUser != false) {
    retrievedContactsRawResponse = (await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((String('https://mgr.pockethost.io/api/collections/ACCOContacts/records?perPage=25&sort=+LastName,FirstName&page=') + String(JSON.stringify((getObjectProperty(___arguments.context.pageData, 'pageCurser'))))))).set(({ [`Authorization`]: ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOContactsToken')) })).setEncoding('utf8').send());
    ___arguments.context.pageData['page'] = (getObjectProperty(retrievedContactsRawResponse, 'page'));
    ___arguments.context.pageData['perPage'] = (getObjectProperty(retrievedContactsRawResponse, 'perPage'));
    ___arguments.context.pageData['totalItems'] = (getObjectProperty(retrievedContactsRawResponse, 'totalItems'));
    ___arguments.context.pageData['totalPages'] = (getObjectProperty(retrievedContactsRawResponse, 'totalPages'));
    console.log('RetrievedContactsRawResponse:');
    console.log(retrievedContactsRawResponse);
    ___arguments.context.pageData['RetrievedContacts'] = (getObjectProperty(retrievedContactsRawResponse, 'items'));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', ({  }));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', (getObjectProperty(___arguments.context.pageData, 'RetrievedContacts')));
    ___arguments.context.pageData['DisplayingContactsMessage'] = (['Contact: ',(Number((getObjectProperty(___arguments.context.pageData, 'page')))) * (Number((getObjectProperty(___arguments.context.pageData, 'perPage')))),' | Page: ',(getObjectProperty(___arguments.context.pageData, 'page')),' (',(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8'))[0]), 'LastName')),' To ',(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8')).slice(-1)[0]), 'LastName')),') | Total Pages: ',(getObjectProperty(___arguments.context.pageData, 'totalPages')),' | Total Contacts: ',(getObjectProperty(___arguments.context.pageData, 'totalItems'))].join(''));
    console.log(currentUser);
    ___arguments.context.appData['currentUser'] = currentUser;
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('UserLogin', undefined);
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'page')) <= 10) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f1542a58df082559e03864f8db487678'))['background-color'] = '#9A91A6';
    return true;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f1542a58df082559e03864f8db487678'))['background-color'] = '#0A0A0A';
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/home_5-17b1/components/8df8d2e2bef1ae08efcc44611b5882f1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var currentUser, retrievedContactsRawResponse, ContactsCountReturn, CurrentPageNumber;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['pageCurser'] = ((Number((getObjectProperty(___arguments.context.pageData, 'page')))) + 1);
  if (currentUser != false) {
    retrievedContactsRawResponse = (await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((String('https://mgr.pockethost.io/api/collections/ACCOContacts/records?perPage=25&sort=+LastName,FirstName&page=') + String(JSON.stringify((getObjectProperty(___arguments.context.pageData, 'pageCurser'))))))).set(({ [`Authorization`]: ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOContactsToken')) })).setEncoding('utf8').send());
    ___arguments.context.pageData['page'] = (getObjectProperty(retrievedContactsRawResponse, 'page'));
    ___arguments.context.pageData['perPage'] = (getObjectProperty(retrievedContactsRawResponse, 'perPage'));
    ___arguments.context.pageData['totalItems'] = (getObjectProperty(retrievedContactsRawResponse, 'totalItems'));
    ___arguments.context.pageData['totalPages'] = (getObjectProperty(retrievedContactsRawResponse, 'totalPages'));
    console.log('RetrievedContactsRawResponse:');
    console.log(retrievedContactsRawResponse);
    ___arguments.context.pageData['RetrievedContacts'] = (getObjectProperty(retrievedContactsRawResponse, 'items'));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', ({  }));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', (getObjectProperty(___arguments.context.pageData, 'RetrievedContacts')));
    ___arguments.context.pageData['DisplayingContactsMessage'] = (['Contact: ',(Number((getObjectProperty(___arguments.context.pageData, 'page')))) * (Number((getObjectProperty(___arguments.context.pageData, 'perPage')))),' | Page: ',(getObjectProperty(___arguments.context.pageData, 'page')),' (',(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8'))[0]), 'LastName')),' To ',(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8')).slice(-1)[0]), 'LastName')),') | Total Pages: ',(getObjectProperty(___arguments.context.pageData, 'totalPages')),' | Total Contacts: ',(getObjectProperty(___arguments.context.pageData, 'totalItems'))].join(''));
    console.log(currentUser);
    ___arguments.context.appData['currentUser'] = currentUser;
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('UserLogin', undefined);
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'page')) == (Number((getObjectProperty(___arguments.context.pageData, 'totalPages'))))) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('8df8d2e2bef1ae08efcc44611b5882f1'))['background-color'] = '#9A91A6';
    return true;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('8df8d2e2bef1ae08efcc44611b5882f1'))['background-color'] = '#0A0A0A';
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/home_5-17b1/components/eb38a9bcb0711288da0800585d081f5a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var currentUser, retrievedContactsRawResponse, ContactsCountReturn, CurrentPageNumber;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['pageCurser'] = ((Number((getObjectProperty(___arguments.context.pageData, 'page')))) - 1);
  if (currentUser != false) {
    retrievedContactsRawResponse = (await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((String('https://mgr.pockethost.io/api/collections/ACCOContacts/records?perPage=25&sort=+LastName,FirstName&page=') + String(JSON.stringify((getObjectProperty(___arguments.context.pageData, 'pageCurser'))))))).set(({ [`Authorization`]: ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOContactsToken')) })).setEncoding('utf8').send());
    ___arguments.context.pageData['page'] = (getObjectProperty(retrievedContactsRawResponse, 'page'));
    ___arguments.context.pageData['perPage'] = (getObjectProperty(retrievedContactsRawResponse, 'perPage'));
    ___arguments.context.pageData['totalItems'] = (getObjectProperty(retrievedContactsRawResponse, 'totalItems'));
    ___arguments.context.pageData['totalPages'] = (getObjectProperty(retrievedContactsRawResponse, 'totalPages'));
    console.log('RetrievedContactsRawResponse:');
    console.log(retrievedContactsRawResponse);
    ___arguments.context.pageData['RetrievedContacts'] = (getObjectProperty(retrievedContactsRawResponse, 'items'));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', ({  }));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', (getObjectProperty(___arguments.context.pageData, 'RetrievedContacts')));
    ___arguments.context.pageData['DisplayingContactsMessage'] = (['Contact: ',(Number((getObjectProperty(___arguments.context.pageData, 'page')))) * (Number((getObjectProperty(___arguments.context.pageData, 'perPage')))),' | Page: ',(getObjectProperty(___arguments.context.pageData, 'page')),' (',(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8'))[0]), 'LastName')),' To ',(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8')).slice(-1)[0]), 'LastName')),') | Total Pages: ',(getObjectProperty(___arguments.context.pageData, 'totalPages')),' | Total Contacts: ',(getObjectProperty(___arguments.context.pageData, 'totalItems'))].join(''));
    console.log(currentUser);
    ___arguments.context.appData['currentUser'] = currentUser;
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('UserLogin', undefined);
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'page')) == 1) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('eb38a9bcb0711288da0800585d081f5a'))['background-color'] = '#9A91A6';
    return true;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('eb38a9bcb0711288da0800585d081f5a'))['background-color'] = '#0A0A0A';
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/home_5-17b1/components/c38b81a1fde808e224a8dc634857c68a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var currentUser, retrievedContactsRawResponse, ContactsCountReturn, CurrentPageNumber;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['pageCurser'] = ((Number((getObjectProperty(___arguments.context.pageData, 'page')))) + 10);
  if (currentUser != false) {
    retrievedContactsRawResponse = (await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((String('https://mgr.pockethost.io/api/collections/ACCOContacts/records?perPage=25&sort=+LastName,FirstName&page=') + String(JSON.stringify((getObjectProperty(___arguments.context.pageData, 'pageCurser'))))))).set(({ [`Authorization`]: ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOContactsToken')) })).setEncoding('utf8').send());
    ___arguments.context.pageData['page'] = (getObjectProperty(retrievedContactsRawResponse, 'page'));
    ___arguments.context.pageData['perPage'] = (getObjectProperty(retrievedContactsRawResponse, 'perPage'));
    ___arguments.context.pageData['totalItems'] = (getObjectProperty(retrievedContactsRawResponse, 'totalItems'));
    ___arguments.context.pageData['totalPages'] = (getObjectProperty(retrievedContactsRawResponse, 'totalPages'));
    console.log('RetrievedContactsRawResponse:');
    console.log(retrievedContactsRawResponse);
    ___arguments.context.pageData['RetrievedContacts'] = (getObjectProperty(retrievedContactsRawResponse, 'items'));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', ({  }));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', (getObjectProperty(___arguments.context.pageData, 'RetrievedContacts')));
    ___arguments.context.pageData['DisplayingContactsMessage'] = (['Contact: ',(Number((getObjectProperty(___arguments.context.pageData, 'page')))) * (Number((getObjectProperty(___arguments.context.pageData, 'perPage')))),' | Page: ',(getObjectProperty(___arguments.context.pageData, 'page')),' (',(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8'))[0]), 'LastName')),' To ',(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8')).slice(-1)[0]), 'LastName')),') | Total Pages: ',(getObjectProperty(___arguments.context.pageData, 'totalPages')),' | Total Contacts: ',(getObjectProperty(___arguments.context.pageData, 'totalItems'))].join(''));
    console.log(currentUser);
    ___arguments.context.appData['currentUser'] = currentUser;
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('UserLogin', undefined);
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'page')) > (Number((getObjectProperty(___arguments.context.pageData, 'totalPages')))) - 10) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c38b81a1fde808e224a8dc634857c68a'))['background-color'] = '#9A91A6';
    return true;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c38b81a1fde808e224a8dc634857c68a'))['background-color'] = '#0A0A0A';
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/home_5-17b1/components/3f18a098cf5807a87b084d784a98910c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var currentUser, retrievedContactsRawResponse, CurrentPageNumber;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  CurrentPageNumber = 0;
  ___arguments.context.pageData['pageCurser'] = (Number((getObjectProperty(___arguments.context.pageData, 'totalPages'))));
  if (currentUser != false) {
    retrievedContactsRawResponse = (await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((String('https://mgr.pockethost.io/api/collections/ACCOContacts/records?perPage=25&sort=+LastName,FirstName&page=') + String(JSON.stringify((getObjectProperty(___arguments.context.pageData, 'pageCurser'))))))).set(({ [`Authorization`]: ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOContactsToken')) })).setEncoding('utf8').send());
    ___arguments.context.pageData['page'] = (getObjectProperty(retrievedContactsRawResponse, 'page'));
    ___arguments.context.pageData['perPage'] = (getObjectProperty(retrievedContactsRawResponse, 'perPage'));
    ___arguments.context.pageData['totalItems'] = (getObjectProperty(retrievedContactsRawResponse, 'totalItems'));
    ___arguments.context.pageData['totalPages'] = (getObjectProperty(retrievedContactsRawResponse, 'totalPages'));
    console.log('RetrievedContactsRawResponse:');
    console.log(retrievedContactsRawResponse);
    ___arguments.context.pageData['RetrievedContacts'] = (getObjectProperty(retrievedContactsRawResponse, 'items'));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', ({  }));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', (getObjectProperty(___arguments.context.pageData, 'RetrievedContacts')));
    ___arguments.context.pageData['DisplayingContactsMessage'] = (['Contact: ',(Number((getObjectProperty(___arguments.context.pageData, 'page')))) * (Number((getObjectProperty(___arguments.context.pageData, 'perPage')))),' | Page: ',(getObjectProperty(___arguments.context.pageData, 'page')),' (',(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8'))[0]), 'LastName')),' To ',(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8')).slice(-1)[0]), 'LastName')),') | Total Pages: ',(getObjectProperty(___arguments.context.pageData, 'totalPages')),' | Total Contacts: ',(getObjectProperty(___arguments.context.pageData, 'totalItems'))].join(''));
    console.log(currentUser);
    ___arguments.context.appData['currentUser'] = currentUser;
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('UserLogin', undefined);
  }
  ___arguments.context.pageData['DisplayingContactsMessage'] = (['Contact: ',(Number((getObjectProperty(___arguments.context.pageData, 'page')))) * (Number((getObjectProperty(___arguments.context.pageData, 'perPage')))),' | Page: ',(getObjectProperty(___arguments.context.pageData, 'page')),' (',(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8'))[0]), 'LastName')),' To ',(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8')).slice(-1)[0]), 'LastName')),') | Total Pages: ',(getObjectProperty(___arguments.context.pageData, 'totalPages')),' | Total Contacts: ',(getObjectProperty(___arguments.context.pageData, 'totalItems'))].join(''));

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'page')) == (Number((getObjectProperty(___arguments.context.pageData, 'totalPages'))))) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3f18a098cf5807a87b084d784a98910c'))['background-color'] = '#9A91A6';
    return true;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3f18a098cf5807a87b084d784a98910c'))['background-color'] = '#0A0A0A';
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/home_5-17b1/components/8bf48e763098bc9bd82790dc5238e3c8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(JSON.parse((JSON.stringify(___arguments.context.getComponentDataStoreByUid('5e3f583561b818f8a1786ac80fa77ec8')))));
  console.log(JSON.parse((JSON.stringify((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'drawerDataModel')), 'MiddleName'))))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/home_5-17b1/components/b1d3e8684cdf46a8fe882c58ccf881cb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('#Bottom', false, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/home_5-17b1/components/5b9545ea538797582b284eb9c91349e8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('#Top', false, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/home_5-17b1/components/fbefd2bb6fec4718d6382d38ad733348/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/home_5-17b1/components/92b96158c4d823916c18019a5b28fd83/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'CurrentlySelectedContactData')), 'FirstName'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/home_5-17b1/components/31f864bdf9b8c4982b985e46c2a8175a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'CurrentlySelectedContactData')), 'LastName'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/home_5-17b1/components/6672cef89de766787f2889f880d8b618/bundle.js', [], () => ({
  /* content */
  /* handler:onReadOnlyStateAssignment */
  ['onReadOnlyStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.pageData, 'EditMode')))

  },
  /* handler:onReadOnlyStateAssignment */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6672cef89de766787f2889f880d8b618')), 'value')) == '') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('6672cef89de766787f2889f880d8b618'))['border-color'] = '#AE0530';
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('6672cef89de766787f2889f880d8b618'))['border-color'] = '#0520AE';
  }

  },
  /* handler:onBlur */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'drawerDataModel')), 'FirstName'))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/home_5-17b1/components/af7832b8d436d7bdb868946446a9d5fc/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'drawerDataModel')), 'LastName'))

  },
  /* handler:onValueAssignment */
  /* handler:onReadOnlyStateAssignment */
  ['onReadOnlyStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.pageData, 'EditMode')))

  },
  /* handler:onReadOnlyStateAssignment */
  /* content */
}))

define('./pages/home_5-17b1/components/ac22d7a23f48b4a88ef44e890c58d724/bundle.js', [], () => ({
  /* content */
  /* handler:onReadOnlyStateAssignment */
  ['onReadOnlyStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.pageData, 'EditMode')))

  },
  /* handler:onReadOnlyStateAssignment */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'drawerDataModel')), 'MiddleName'))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/home_5-17b1/components/c6d8a878da6ee2a81d1818587298aef2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['EditMode'] = true;
  ___arguments.context.pageData['ModifiedData'] = true;
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c6d8a878da6ee2a81d1818587298aef2'))['background-color'] = '#A00000';

  },
  /* handler:onClick */
  /* handler:onDelete */
  ['onDelete'](___arguments) {
      ___arguments.context.pageData['EditMode'] = false;
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c6d8a878da6ee2a81d1818587298aef2'))['background-color'] = '#016288';

  },
  /* handler:onDelete */
  /* content */
}))

define('./pages/home_5-17b1/components/99a8df394f156cc874813c38d937d968/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('99a8df394f156cc874813c38d937d968'))['color'] = '#03B935';

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f548849959d80918247fdbdd7f982de8'), 'NeedToSave')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/home_5-17b1/components/390d1ad861e8a4a817487017ebcec028/bundle.js', [], () => ({
  /* content */
  /* handler:onReadOnlyStateAssignment */
  ['onReadOnlyStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.pageData, 'EditMode')))

  },
  /* handler:onReadOnlyStateAssignment */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'drawerDataModel')), 'Suffix'))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/home_5-17b1/components/60d8097a61c88c0d830a43e79398466a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(JSON.parse((JSON.stringify((getObjectProperty(___arguments.context.pageData, 'drawerDataModel'))))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/home_5-17b1/components/9458d2e81328842c3e982c284f77e859/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('drawerDataModel from within the drawer...');
  console.log(JSON.parse((JSON.stringify((getObjectProperty(___arguments.context.pageData, 'drawerDataModel'))))));
  console.log('drawerDataModel: getting MiddleName');
  console.log(JSON.parse((JSON.stringify((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'drawerDataModel')), 'MiddleName'))))));
  console.log('drawerDataModel: getting LastName (no conversion)');
  console.log(JSON.parse((JSON.stringify((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'drawerDataModel')), 'LastName'))))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/home_5-17b1/components/4e289aefe01b9378bf79b7f89fc4a648/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, targetObject, sourceObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('99683348f21a0478cb18ff2b2078896a', (await asyncListFilter(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8')), async (item) => {
     if ((getObjectProperty(item, 'id')) == (getObjectProperty(___arguments.context.pageData, 'CurrentlySelectedContactID'))) {
      item['NeedToSave'] = true;
      item['FirstName'] = (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6672cef89de766787f2889f880d8b618')), 'value'));
      item['MiddleName'] = (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ac22d7a23f48b4a88ef44e890c58d724')), 'value'));
      item['LastName'] = (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('af7832b8d436d7bdb868946446a9d5fc')), 'value'));
      return true;
    } else {
      return false;
    }


   return item;
  })));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/home_5-17b1/components/b8e8c9b587c89757fca8d388c695c5b8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('5e3f583561b818f8a1786ac80fa77ec8')['FirstName'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'drawerDataModel')), 'FirstName'));
  ___arguments.context.getComponentDataStoreByUid('5e3f583561b818f8a1786ac80fa77ec8')['MiddleName'] = 'This is a freakin\' test!';
  ___arguments.context.getComponentDataStoreByUid('5e3f583561b818f8a1786ac80fa77ec8')['LastName'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'drawerDataModel')), 'LastName'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/home_5-17b1/components/7fb32f6897338c2d3f190f8cb1d62d0c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(JSON.parse((JSON.stringify((getObjectProperty(___arguments.context.pageData, 'CurrentlySelectedContactData'))))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/home_5-17b1/components/a298b228cfffba38b7f81108b5584fa8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('99683348f21a0478cb18ff2b2078896a'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/home_backup6-4/components/ab288c9ed0e835b89a08e4b88e03dc16/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOUserToken'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/home_backup6-4/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var currentUser, retrievedContactsRawResponse, storedTokenFromCookie;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function Set_pageData_Variables() {
  ___arguments.context.pageData['drawerDataModel'] = ({  });
  ___arguments.context.pageData['RetrievedContactsRawResponse'] = ({  });
  ___arguments.context.pageData['OpenDrawer'] = false;
  ___arguments.context.pageData['DisplayingContactsPageNumber'] = 0;
  ___arguments.context.pageData['ContactsModifiedOnPage'] = 0;
  ___arguments.context.pageData['BlockerDivVisible'] = false;
}


  await Set_pageData_Variables();
  storedTokenFromCookie = ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOUserToken'));
  currentUser = (await BackendlessUI.Functions.Custom['fn_fb29ed716ee40c6ec05a6af2fb62b61d'](storedTokenFromCookie));
  if (currentUser != false) {
    ___arguments.context.appData['currentUser'] = currentUser;
    retrievedContactsRawResponse = (await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://mgr.pockethost.io/api/collections/ACCOContacts/records?perPage=25&sort=+LastName,FirstName')).set(({ [`Authorization`]: ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOUserToken')) })).setEncoding('utf8').send());
    ___arguments.context.pageData['pageCursor'] = 0;
    ___arguments.context.pageData['page'] = (getObjectProperty(retrievedContactsRawResponse, 'page'));
    ___arguments.context.pageData['perPage'] = (getObjectProperty(retrievedContactsRawResponse, 'perPage'));
    ___arguments.context.pageData['totalItems'] = (getObjectProperty(retrievedContactsRawResponse, 'totalItems'));
    ___arguments.context.pageData['totalPages'] = (getObjectProperty(retrievedContactsRawResponse, 'totalPages'));
    console.log('RetrievedContactsRawResponse:');
    console.log(retrievedContactsRawResponse);
    ___arguments.context.pageData['RetrievedContacts'] = (getObjectProperty(retrievedContactsRawResponse, 'items'));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', (getObjectProperty(___arguments.context.pageData, 'RetrievedContacts')));
    console.log(currentUser);
    ___arguments.context.pageData['DisplayingContactsMessage'] = (['Contact: ',(Number((getObjectProperty(___arguments.context.pageData, 'page')))) * (Number((getObjectProperty(___arguments.context.pageData, 'perPage')))),' | Page: ',(getObjectProperty(___arguments.context.pageData, 'page')),' (',(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8'))[0]), 'LastName')),' To ',(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8')).slice(-1)[0]), 'LastName')),') | Total Pages: ',(getObjectProperty(___arguments.context.pageData, 'totalPages')),' | Total Contacts: ',(getObjectProperty(___arguments.context.pageData, 'totalItems'))].join(''));
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('UserLogin', undefined);
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/home_backup6-4/components/54081436bb6842a82788d1d8c2a7dbc1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(JSON.parse((JSON.stringify((getObjectProperty(___arguments.context.appData, 'currentUser'))))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/home_backup6-4/components/e65831ef35789938da8896bca018c4e8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      localStorage.removeItem('ACCOUserToken');
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('UserLogin', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/home_backup6-4/components/cb980528d6cebac8f0984878c8985798/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(getObjectProperty(___arguments.context.pageData, 'RetrievedContacts'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/home_backup6-4/components/26c848494068ad8874b4b73208376878/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await (async function(TextToCopy) {
  	navigator.clipboard.writeText(TextToCopy);
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5e3f583561b818f8a1786ac80fa77ec8'), 'BusinessPhone')));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9954b1e8ff38cc68d3f769a8c488aa1c'))['color'] = '#A00000';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9954b1e8ff38cc68d3f769a8c488aa1c'))['text-decoration-line'] = 'underline';
  await new Promise(r => setTimeout(r, 400 || 0));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9954b1e8ff38cc68d3f769a8c488aa1c'))['color'] = '#000000';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9954b1e8ff38cc68d3f769a8c488aa1c'))['text-decoration-line'] = 'none';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/home_backup6-4/components/8c26d238ec58efa916980c5156989ff8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('14160948a388f4c82618c6e80fc67fec');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/home_backup6-4/components/9f18306e287839f6b688b2785af8c8ec/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var decision, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'isContactSelected')) == true) {
    console.log(await asyncListFilter(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8')), async (item) => {
       if ((getObjectProperty(item, 'CurrentlySelectedContact')) == true) {
        delete item['CurrentlySelectedContact'];
        decision = true;
      } else {
        decision = true;
      }


     return ;
    }));
  }
  ___arguments.context.pageData['OpenDrawer'] = false;
  ___arguments.context.pageData['CurrentlySelectedContact'] = false;
  ___arguments.context.pageData['CurrentlySelectedContactObjectID'] = '';
  ___arguments.context.pageData['isContactSelected'] = false;
  ___arguments.context.pageData['EditMode'] = false;
  await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('d5e8e785986ad5d8c618fb16527f9038', undefined);
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bb85878828193def9f8054853f8949b'))['min-height'] = '100%';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/home_backup6-4/components/34b170cf59982968ddc866980023ca7f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var decision, item, stripOutSelectedContacts;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function Set_pageData_Variables() {
  ___arguments.context.pageData['AddScrollDelay'] = true;
  ___arguments.context.pageData['OpenDrawer'] = true;
  ___arguments.context.pageData['CurrentlySelectedContact'] = true;
  ___arguments.context.pageData['isContactSelected'] = true;
  ___arguments.context.getComponentDataStoreByUid('f548849959d80918247fdbdd7f982de8')['CurrentlySelectedContact'] = true;
  ___arguments.context.pageData['CurrentlySelectedContactID'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f548849959d80918247fdbdd7f982de8'), 'id'));
  ___arguments.context.pageData['CurrentlySelectedContactData'] = (JSON.parse((JSON.stringify(___arguments.context.getComponentDataStoreByUid('f548849959d80918247fdbdd7f982de8')))));
}


  if ((getObjectProperty(___arguments.context.pageData, 'isContactSelected')) == true) {
    stripOutSelectedContacts = (await asyncListFilter(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8')), async (item) => {
       if ((getObjectProperty(item, 'CurrentlySelectedContact')) == true) {
        delete item['CurrentlySelectedContact'];
        decision = true;
      } else {
        decision = true;
      }


     return decision;
    }));
  }
  await Set_pageData_Variables();
  console.log('Pushing selected contact to pageData.drawerDataModel');
  console.log(JSON.parse((JSON.stringify(___arguments.context.getComponentDataStoreByUid('f548849959d80918247fdbdd7f982de8')))));
  ___arguments.context.pageData['drawerDataModel'] = (JSON.parse((JSON.stringify(___arguments.context.getComponentDataStoreByUid('f548849959d80918247fdbdd7f982de8')))));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bb85878828193def9f8054853f8949b'))['min-height'] = '125%';
  await (async function() {
  	const elements = document.getElementsByClassName('MainContactsRow');
  	const currentHeight = elements[0].clientHeight; // Get the current height
  	newHeight = currentHeight
  	
  	// newHeight = currentHeight * (1 + percentageIncrease / 100); // Calculate new height
  	if (newHeight < 1150) {
  	  newHeight = 1150;
  	}
  	elements[0].style.minHeight = newHeight + 'px'; // Set the new height
  	// alert('The current height is: '+ currentHeight);

  })();
  (function (component) { component.el.scrollIntoView() })((getObjectProperty(___arguments.context.pageData, (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f548849959d80918247fdbdd7f982de8'), 'id')))));

  },
  /* handler:onClick */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f548849959d80918247fdbdd7f982de8'), 'FirstName')),' ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f548849959d80918247fdbdd7f982de8'), 'LastName'))].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/home_backup6-4/components/d5e8e785986ad5d8c618fb16527f9038/bundle.js', [], () => ({
  /* content */
  /* handler:isOpenLogic */
  ['isOpenLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'OpenDrawer'))

  },
  /* handler:isOpenLogic */
  /* handler:onClose */
  async ['onClose'](___arguments) {
    var currentCount, item, listCount, result, decision;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  ___arguments.context.pageData['OpenDrawer'] = false;
  if ((getObjectProperty(___arguments.context.pageData, 'isContactSelected')) == true) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', (JSON.parse((JSON.stringify((await asyncListFilter(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8')), async (item) => {
       if ((getObjectProperty(item, 'CurrentlySelectedContact')) == true) {
        delete item['CurrentlySelectedContact'];
        decision = true;
      } else {
        decision = true;
      }


     return decision;
    })))))));
  }
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bb85878828193def9f8054853f8949b'))['height'] = 'auto';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bb85878828193def9f8054853f8949b'))['min-height'] = 'auto';
  ___arguments.context.pageData['isContactSelected'] = false;
  if (((getObjectProperty(___arguments.context.pageData, 'EditMode')) || (getObjectProperty(___arguments.context.pageData, 'AdminEditMode'))) == true) {
    result = (await (async function(modifiedData) {
    	var userPreference;
    	
    	if (modifiedData) {
    	
    	  if (confirm("Save your changes? [Enter] to save or [Esc] to cancel") == true) {
    	    userPreference = "Save Requested";
    	  } else {
    	    userPreference = "Save Cancelled!";
    	  }
    	// console.log(userPreference)
    	return userPreference
    	  
    	}

    })((getObjectProperty(___arguments.context.pageData, 'ModifiedData'))));
    if (result == 'Save Requested') {
      console.log('Save Data Requested');
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', (JSON.parse((JSON.stringify((await asyncListFilter(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8')), async (item) => {
         if ((getObjectProperty(item, 'id')) == (getObjectProperty(___arguments.context.pageData, 'CurrentlySelectedContactID'))) {
          item['NeedToSave'] = true;
          item['FirstName'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'drawerDataModel')), 'FirstName'));
          item['MiddleName'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'drawerDataModel')), 'MiddleName'));
          item['LastName'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'drawerDataModel')), 'LastName'));
          item['Suffix'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'drawerDataModel')), 'Suffix'));
          item['Company'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'drawerDataModel')), 'Company'));
          item['BusinessStreet'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'drawerDataModel')), 'BusinessStreet'));
          item['BusinessCity'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'drawerDataModel')), 'BusinessCity'));
          item['BusinessState'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'drawerDataModel')), 'BusinessState'));
          item['BusinessPostalCode'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'drawerDataModel')), 'BusinessPostalCode'));
          item['EmailAddress'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'drawerDataModel')), 'EmailAddress'));
          item['EmailAddress2'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'drawerDataModel')), 'EmailAddress2'));
          item['BusinessPhone'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'drawerDataModel')), 'BusinessPhone'));
          item['BusinessPhone2'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'drawerDataModel')), 'BusinessPhone2'));
          item['MobilePhone'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'drawerDataModel')), 'MobilePhone'));
          return true;
        } else {
          return true;
        }


       return item;
      })))))));
      ___arguments.context.pageData['BlockerDivVisible'] = true;
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ac384c2fae874c589bd87f588a6bdbc8'))['min-height'] = 157;
    } else {
      console.log('Save Data Cancelled!');
    }
    currentCount = 0;
    listCount = (await asyncListFilter(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8')), async (item) => {
       if ((getObjectProperty(item, 'NeedToSave')) == true) {
        currentCount = currentCount + 1;
      }


     return currentCount;
    }));
    ___arguments.context.pageData['ContactsModifiedOnPage'] = currentCount;
    ___arguments.context.pageData['ModifiedData'] = false;
  }
  if ((getObjectProperty(___arguments.context.pageData, 'AdminEditMode')) != true) {
    if ((getObjectProperty(___arguments.context.pageData, 'EditMode')) == true) {
      ___arguments.context.pageData['EditMode'] = false;
    }
  }

  },
  /* handler:onClose */
  /* handler:onOpen */
  ['onOpen'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'AdminEditMode')) == true) {
    ___arguments.context.pageData['EditMode'] = true;
  }

  },
  /* handler:onOpen */
  /* content */
}))

define('./pages/home_backup6-4/components/715ffae88be9507ff0b894488f3f2571/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f548849959d80918247fdbdd7f982de8'), 'CurrentlySelectedContact')) == true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f548849959d80918247fdbdd7f982de8'))['background-color'] = '#990939';
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f548849959d80918247fdbdd7f982de8'))['background-color'] = '#016288';
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/home_backup6-4/components/f548849959d80918247fdbdd7f982de8/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData[(getObjectProperty(___arguments.context.dataModel, 'id'))] = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f548849959d80918247fdbdd7f982de8'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/home_backup6-4/components/c4e88a1ec9685fd8d8c459588a08e548/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f548849959d80918247fdbdd7f982de8'), 'EmailAddress')) != '') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c4e88a1ec9685fd8d8c459588a08e548'))['color'] = '#FFFFFF';
  }

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f548849959d80918247fdbdd7f982de8'), 'EmailAddress')) != '') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c4e88a1ec9685fd8d8c459588a08e548'))['color'] = '#B4B4B4';
  }

  },
  /* handler:onMouseOut */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('3d1800088b7fe3386f380083d4e8b13d')), 'text')) != '') {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/home_backup6-4/components/9a38cdb1fe6889b8853c0d7891b8ca88/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var response, DBSearchTerm, retrievedContacts;

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setTimeouts'); if (timerId && timers[timerId]) {    clearTimeout(timers[timerId]);    delete timers[timerId]; }}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setTimeouts'); const timer = setTimeout(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function Search_Contacts() {
  if ((getObjectProperty(___arguments.context.pageData, 'TOGGLE_IncludeCompany')) == true) {
    retrievedContacts = (getObjectProperty((await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((['https://mgr.pockethost.io/api/collections/ACCOContacts/records?perPage=50&sort=+LastName,FirstName&filter=(','LastName~\'',___arguments.value,'\' || FirstName~\'',___arguments.value,'\' || Company~\'',___arguments.value,'\')'].join('')))).set(({ [`Authorization`]: ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOUserToken')) })).setEncoding('utf8').send()), 'items'));
    ___arguments.context.pageData['RetrievedContacts'] = retrievedContacts;
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9048e37ecae67908d8bd408823dce8d8'))['background-color'] = '#A00000';
    ___arguments.context.pageData['MAKEITWHITE'] = true;
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ee68b608a0ec67383ffecb48626858c8'))['color'] = '#FFFFFF';
  } else {
    retrievedContacts = (getObjectProperty((await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((['https://mgr.pockethost.io/api/collections/ACCOContacts/records?perPage=50&sort=+LastName,FirstName&filter=(','LastName~\'',___arguments.value,'\' || FirstName~\'',___arguments.value,'\')'].join('')))).set(({ [`Authorization`]: ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOUserToken')) })).setEncoding('utf8').send()), 'items'));
  }
  return retrievedContacts
}

/**
 * Describe this function...
 */
async function Reset_Search() {
  retrievedContacts = (getObjectProperty((await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((String('https://mgr.pockethost.io/api/collections/ACCOContacts/records?perPage=25&sort=+LastName,FirstName')))).set(({ [`Authorization`]: ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOUserToken')) })).setEncoding('utf8').send()), 'items'));
  ___arguments.context.pageData['RetrievedContacts'] = retrievedContacts;
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9048e37ecae67908d8bd408823dce8d8'))['background-color'] = '#F5F5F5';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9a38cdb1fe6889b8853c0d7891b8ca88'))['color'] = '#000000';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ee68b608a0ec67383ffecb48626858c8'))['color'] = '#AD0505';
  ___arguments.context.pageData['MAKEITWHITE'] = false;
  ___arguments.context.appData['ForceSearch'] = false;
  return retrievedContacts
}


  stopSetTimeout('lazySearch');

  ;(function() {
    const callback = async () => {
        DBSearchTerm = ___arguments.value;
    ___arguments.context.pageData['DBSearchTerm'] = DBSearchTerm;
    response = await Search_Contacts();
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', ({  }));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', response);
    ___arguments.context.appData['ForceSearch'] = true;

    };

    const timerId = 'lazySearch';
    const timerDelay = 1000;

    runSetTimeout(timerId, callback, timerDelay)
  })()
  if (___arguments.value == '') {
    response = await Search_Contacts();
    response = await Reset_Search();
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', ({  }));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', response);
    ___arguments.context.appData['ForceSearch'] = false;
    ___arguments.context.pageData['DBSearchTerm'] = '';
  } else {
    response = await Search_Contacts();
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', ({  }));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', response);
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9048e37ecae67908d8bd408823dce8d8'))['background-color'] = '#A00000';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9a38cdb1fe6889b8853c0d7891b8ca88'))['color'] = '#FFFFFF';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ee68b608a0ec67383ffecb48626858c8'))['color'] = '#FFFFFF';
    ___arguments.context.pageData['MAKEITWHITE'] = true;
    ___arguments.context.appData['ForceSearch'] = true;
  }
  if (getValueLength(___arguments.value) == 0) {
    ___arguments.context.pageData['DBSearchTerm'] = '';
    stopSetTimeout('lazySearch');
  }

  },
  /* handler:onChange */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    var classList;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'MAKEITWHITE')) == true) {
    classList = ['input-white'];
  } else {
    classList = ['input-black'];
  }
  return classList;

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/home_backup6-4/components/ee68b608a0ec67383ffecb48626858c8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var retrievedContacts;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setTimeouts'); if (timerId && timers[timerId]) {    clearTimeout(timers[timerId]);    delete timers[timerId]; }}

/**
 * Describe this function...
 */
async function Reset_Search() {
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', ({  }));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', (getObjectProperty((await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((String('https://mgr.pockethost.io/api/collections/ACCOContacts/records?perPage=25&sort=+LastName,FirstName')))).set(({ [`Authorization`]: ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOUserToken')) })).setEncoding('utf8').send()), 'items')));
  ___arguments.context.pageData['RetrievedContacts'] = retrievedContacts;
}


  await Reset_Search();
  ___arguments.context.pageData['DBSearchTerm'] = '';
  ___arguments.context.pageData['value'] = '';
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('9a38cdb1fe6889b8853c0d7891b8ca88'))['value'] = '';
  ___arguments.context.pageData['ForceSearch'] = false;
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9048e37ecae67908d8bd408823dce8d8'))['background-color'] = '#F5F5F5';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ee68b608a0ec67383ffecb48626858c8'))['color'] = '#AD0505';
  ___arguments.context.pageData['MAKEITWHITE'] = false;
  ___arguments.context.pageData['MAKEITBLACK'] = (!(getObjectProperty(___arguments.context.pageData, 'MAKEITWHITE')));
  stopSetTimeout('lazySearch');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/home_backup6-4/components/3a4106331cb86b6899de7db685e6a9f2/bundle.js', [], () => ({
  /* content */
  /* handler:onDelete */
  ['onDelete'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'PageFilter')) == 'Created') {
    ___arguments.context.pageData['PageFilter'] = '';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3a4106331cb86b6899de7db685e6a9f2'))['background-color'] = '#016288';
  }

  },
  /* handler:onDelete */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'PageFilter')) != 'Created') {
    ___arguments.context.pageData['PageFilter'] = 'Created';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3a4106331cb86b6899de7db685e6a9f2'))['background-color'] = '#A00000';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('86684ec8198c47f8c1a80e08638823b6'))['background-color'] = '#016288';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('50d8bec85069e1ce0198f5e8c4670bd8'))['background-color'] = '#016288';
  } else {
    ___arguments.context.pageData['CreatedDirectionDown'] = (!(getObjectProperty(___arguments.context.pageData, 'CreatedDirectionDown')));
    await (async function() {
    	const icon = document.querySelector('.created-chip-class i')

    	if (icon.innerHTML === 'arrow_circle_up') {
    	    icon.innerHTML = 'arrow_circle_down'
    	 } else {
    	    icon.innerHTML = 'arrow_circle_up'
    	 }
    })();
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/home_backup6-4/components/86684ec8198c47f8c1a80e08638823b6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'PageFilter')) != 'Viewed') {
    ___arguments.context.pageData['PageFilter'] = 'Viewed';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3a4106331cb86b6899de7db685e6a9f2'))['background-color'] = '#016288';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('86684ec8198c47f8c1a80e08638823b6'))['background-color'] = '#A00000';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('50d8bec85069e1ce0198f5e8c4670bd8'))['background-color'] = '#016288';
  } else {
    ___arguments.context.pageData['ViewedDirectionDown'] = (!(getObjectProperty(___arguments.context.pageData, 'ViewedDirectionDown')));
    await (async function() {
    	const icon = document.querySelector('.viewed-chip-class i')

    	if (icon.innerHTML === 'arrow_circle_up') {
    	    icon.innerHTML = 'arrow_circle_down'
    	 } else {
    	    icon.innerHTML = 'arrow_circle_up'
    	 }
    })();
  }

  },
  /* handler:onClick */
  /* handler:onDelete */
  ['onDelete'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'PageFilter')) == 'Viewed') {
    ___arguments.context.pageData['PageFilter'] = '';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('86684ec8198c47f8c1a80e08638823b6'))['background-color'] = '#016288';
  }

  },
  /* handler:onDelete */
  /* content */
}))

define('./pages/home_backup6-4/components/50d8bec85069e1ce0198f5e8c4670bd8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'PageFilter')) != 'Modified') {
    ___arguments.context.pageData['PageFilter'] = 'Modified';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3a4106331cb86b6899de7db685e6a9f2'))['background-color'] = '#016288';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('86684ec8198c47f8c1a80e08638823b6'))['background-color'] = '#016288';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('50d8bec85069e1ce0198f5e8c4670bd8'))['background-color'] = '#A00000';
  } else {
    ___arguments.context.pageData['ModifiedDirectionDown'] = (!(getObjectProperty(___arguments.context.pageData, 'ModifiedDirectionDown')));
    await (async function() {
    	const icon = document.querySelector('.modified-chip-class i')

    	if (icon.innerHTML === 'arrow_circle_up') {
    	    icon.innerHTML = 'arrow_circle_down'
    	 } else {
    	    icon.innerHTML = 'arrow_circle_up'
    	 }
    })();
  }

  },
  /* handler:onClick */
  /* handler:onDelete */
  ['onDelete'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'PageFilter')) == 'Modified') {
    ___arguments.context.pageData['PageFilter'] = '';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('50d8bec85069e1ce0198f5e8c4670bd8'))['background-color'] = '#016288';
  }

  },
  /* handler:onDelete */
  /* content */
}))

define('./pages/home_backup6-4/components/c8486c55ffb833b1731c386d281e1628/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var retrievedContacts, results;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function Search_Contacts() {
  if ((getObjectProperty(___arguments.context.pageData, 'TOGGLE_IncludeCompany')) == true) {
    retrievedContacts = (getObjectProperty((await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((['https://mgr.pockethost.io/api/collections/ACCOContacts/records?perPage=50&sort=+LastName,FirstName&filter=(','LastName~\'',(getObjectProperty(___arguments.context.pageData, 'DBSearchTerm')),'\' || FirstName~\'',(getObjectProperty(___arguments.context.pageData, 'DBSearchTerm')),'\' || Company~\'',(getObjectProperty(___arguments.context.pageData, 'DBSearchTerm')),'\')'].join('')))).set(({ [`Authorization`]: ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOUserToken')) })).setEncoding('utf8').send()), 'items'));
  } else {
    retrievedContacts = (getObjectProperty((await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((['https://mgr.pockethost.io/api/collections/ACCOContacts/records?perPage=50&sort=+LastName,FirstName&filter=(','LastName~\'',(getObjectProperty(___arguments.context.pageData, 'DBSearchTerm')),'\' || FirstName~\'',(getObjectProperty(___arguments.context.pageData, 'DBSearchTerm')),'\')'].join('')))).set(({ [`Authorization`]: ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOUserToken')) })).setEncoding('utf8').send()), 'items'));
  }
  return retrievedContacts
}


  if (___arguments.value == true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a1a8e4d209da625868a898e85398323e'))['color'] = '#990000';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a1a8e4d209da625868a898e85398323e'))['font-weight'] = 'bold';
    ___arguments.context.pageData['TOGGLE_IncludeCompany'] = true;
    results = await Search_Contacts();
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a1a8e4d209da625868a898e85398323e'))['color'] = '#000000';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a1a8e4d209da625868a898e85398323e'))['font-weight'] = 'normal';
    ___arguments.context.pageData['TOGGLE_IncludeCompany'] = false;
    results = await Search_Contacts();
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', results);

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/home_backup6-4/components/96b815b891276784d638d95fab3833cd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var currentUser, retrievedContactsRawResponse, CurrentPageNumber;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  CurrentPageNumber = 0;
  ___arguments.context.pageData['pageCursor'] = 1;
  if (currentUser != false) {
    retrievedContactsRawResponse = (await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((String('https://mgr.pockethost.io/api/collections/ACCOContacts/records?perPage=25&sort=+LastName,FirstName&page=') + String(JSON.stringify((getObjectProperty(___arguments.context.pageData, 'pageCursor'))))))).set(({ [`Authorization`]: ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOUserToken')) })).setEncoding('utf8').send());
    ___arguments.context.pageData['page'] = (getObjectProperty(retrievedContactsRawResponse, 'page'));
    ___arguments.context.pageData['perPage'] = (getObjectProperty(retrievedContactsRawResponse, 'perPage'));
    ___arguments.context.pageData['totalItems'] = (getObjectProperty(retrievedContactsRawResponse, 'totalItems'));
    ___arguments.context.pageData['totalPages'] = (getObjectProperty(retrievedContactsRawResponse, 'totalPages'));
    console.log('RetrievedContactsRawResponse:');
    console.log(retrievedContactsRawResponse);
    ___arguments.context.pageData['RetrievedContacts'] = (getObjectProperty(retrievedContactsRawResponse, 'items'));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', ({  }));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', (getObjectProperty(___arguments.context.pageData, 'RetrievedContacts')));
    ___arguments.context.pageData['DisplayingContactsMessage'] = (['Contact: ',(Number((getObjectProperty(___arguments.context.pageData, 'page')))) * (Number((getObjectProperty(___arguments.context.pageData, 'perPage')))),' | Page: ',(getObjectProperty(___arguments.context.pageData, 'page')),' (',(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8'))[0]), 'LastName')),' To ',(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8')).slice(-1)[0]), 'LastName')),') | Total Pages: ',(getObjectProperty(___arguments.context.pageData, 'totalPages')),' | Total Contacts: ',(getObjectProperty(___arguments.context.pageData, 'totalItems'))].join(''));
    console.log(currentUser);
    ___arguments.context.appData['currentUser'] = currentUser;
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('UserLogin', undefined);
  }
  ___arguments.context.pageData['DisplayingContactsMessage'] = (['Contact: ',(Number((getObjectProperty(___arguments.context.pageData, 'page')))) * (Number((getObjectProperty(___arguments.context.pageData, 'perPage')))),' | Page: ',(getObjectProperty(___arguments.context.pageData, 'page')),' (',(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8'))[0]), 'LastName')),' To ',(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8')).slice(-1)[0]), 'LastName')),') | Total Pages: ',(getObjectProperty(___arguments.context.pageData, 'totalPages')),' | Total Contacts: ',(getObjectProperty(___arguments.context.pageData, 'totalItems'))].join(''));

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'page')) == 1) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('96b815b891276784d638d95fab3833cd'))['background-color'] = '#9A91A6';
    return true;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('96b815b891276784d638d95fab3833cd'))['background-color'] = '#0A0A0A';
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/home_backup6-4/components/f1542a58df082559e03864f8db487678/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var currentUser, retrievedContactsRawResponse, ContactsCountReturn, CurrentPageNumber;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['pageCursor'] = ((Number((getObjectProperty(___arguments.context.pageData, 'page')))) - 10);
  if (currentUser != false) {
    retrievedContactsRawResponse = (await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((String('https://mgr.pockethost.io/api/collections/ACCOContacts/records?perPage=25&sort=+LastName,FirstName&page=') + String(JSON.stringify((getObjectProperty(___arguments.context.pageData, 'pageCursor'))))))).set(({ [`Authorization`]: ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOUserToken')) })).setEncoding('utf8').send());
    ___arguments.context.pageData['page'] = (getObjectProperty(retrievedContactsRawResponse, 'page'));
    ___arguments.context.pageData['perPage'] = (getObjectProperty(retrievedContactsRawResponse, 'perPage'));
    ___arguments.context.pageData['totalItems'] = (getObjectProperty(retrievedContactsRawResponse, 'totalItems'));
    ___arguments.context.pageData['totalPages'] = (getObjectProperty(retrievedContactsRawResponse, 'totalPages'));
    console.log('RetrievedContactsRawResponse:');
    console.log(retrievedContactsRawResponse);
    ___arguments.context.pageData['RetrievedContacts'] = (getObjectProperty(retrievedContactsRawResponse, 'items'));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', ({  }));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', (getObjectProperty(___arguments.context.pageData, 'RetrievedContacts')));
    ___arguments.context.pageData['DisplayingContactsMessage'] = (['Contact: ',(Number((getObjectProperty(___arguments.context.pageData, 'page')))) * (Number((getObjectProperty(___arguments.context.pageData, 'perPage')))),' | Page: ',(getObjectProperty(___arguments.context.pageData, 'page')),' (',(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8'))[0]), 'LastName')),' To ',(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8')).slice(-1)[0]), 'LastName')),') | Total Pages: ',(getObjectProperty(___arguments.context.pageData, 'totalPages')),' | Total Contacts: ',(getObjectProperty(___arguments.context.pageData, 'totalItems'))].join(''));
    console.log(currentUser);
    ___arguments.context.appData['currentUser'] = currentUser;
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('UserLogin', undefined);
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'page')) <= 10) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f1542a58df082559e03864f8db487678'))['background-color'] = '#9A91A6';
    return true;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f1542a58df082559e03864f8db487678'))['background-color'] = '#0A0A0A';
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/home_backup6-4/components/8df8d2e2bef1ae08efcc44611b5882f1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var currentUser, retrievedContactsRawResponse, ContactsCountReturn, CurrentPageNumber;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['pageCursor'] = ((Number((getObjectProperty(___arguments.context.pageData, 'page')))) + 1);
  if (currentUser != false) {
    retrievedContactsRawResponse = (await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((String('https://mgr.pockethost.io/api/collections/ACCOContacts/records?perPage=25&sort=+LastName,FirstName&page=') + String(JSON.stringify((getObjectProperty(___arguments.context.pageData, 'pageCursor'))))))).set(({ [`Authorization`]: ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOUserToken')) })).setEncoding('utf8').send());
    ___arguments.context.pageData['page'] = (getObjectProperty(retrievedContactsRawResponse, 'page'));
    ___arguments.context.pageData['perPage'] = (getObjectProperty(retrievedContactsRawResponse, 'perPage'));
    ___arguments.context.pageData['totalItems'] = (getObjectProperty(retrievedContactsRawResponse, 'totalItems'));
    ___arguments.context.pageData['totalPages'] = (getObjectProperty(retrievedContactsRawResponse, 'totalPages'));
    console.log('RetrievedContactsRawResponse:');
    console.log(retrievedContactsRawResponse);
    ___arguments.context.pageData['RetrievedContacts'] = (getObjectProperty(retrievedContactsRawResponse, 'items'));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', ({  }));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', (getObjectProperty(___arguments.context.pageData, 'RetrievedContacts')));
    ___arguments.context.pageData['DisplayingContactsMessage'] = (['Contact: ',(Number((getObjectProperty(___arguments.context.pageData, 'page')))) * (Number((getObjectProperty(___arguments.context.pageData, 'perPage')))),' | Page: ',(getObjectProperty(___arguments.context.pageData, 'page')),' (',(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8'))[0]), 'LastName')),' To ',(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8')).slice(-1)[0]), 'LastName')),') | Total Pages: ',(getObjectProperty(___arguments.context.pageData, 'totalPages')),' | Total Contacts: ',(getObjectProperty(___arguments.context.pageData, 'totalItems'))].join(''));
    console.log(currentUser);
    ___arguments.context.appData['currentUser'] = currentUser;
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('UserLogin', undefined);
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'page')) == (Number((getObjectProperty(___arguments.context.pageData, 'totalPages'))))) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('8df8d2e2bef1ae08efcc44611b5882f1'))['background-color'] = '#9A91A6';
    return true;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('8df8d2e2bef1ae08efcc44611b5882f1'))['background-color'] = '#0A0A0A';
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/home_backup6-4/components/eb38a9bcb0711288da0800585d081f5a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var currentUser, retrievedContactsRawResponse, ContactsCountReturn, CurrentPageNumber;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['pageCursor'] = ((Number((getObjectProperty(___arguments.context.pageData, 'page')))) - 1);
  if (currentUser != false) {
    retrievedContactsRawResponse = (await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((String('https://mgr.pockethost.io/api/collections/ACCOContacts/records?perPage=25&sort=+LastName,FirstName&page=') + String(JSON.stringify((getObjectProperty(___arguments.context.pageData, 'pageCursor'))))))).set(({ [`Authorization`]: ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOUserToken')) })).setEncoding('utf8').send());
    ___arguments.context.pageData['page'] = (getObjectProperty(retrievedContactsRawResponse, 'page'));
    ___arguments.context.pageData['perPage'] = (getObjectProperty(retrievedContactsRawResponse, 'perPage'));
    ___arguments.context.pageData['totalItems'] = (getObjectProperty(retrievedContactsRawResponse, 'totalItems'));
    ___arguments.context.pageData['totalPages'] = (getObjectProperty(retrievedContactsRawResponse, 'totalPages'));
    console.log('RetrievedContactsRawResponse:');
    console.log(retrievedContactsRawResponse);
    ___arguments.context.pageData['RetrievedContacts'] = (getObjectProperty(retrievedContactsRawResponse, 'items'));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', ({  }));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', (getObjectProperty(___arguments.context.pageData, 'RetrievedContacts')));
    ___arguments.context.pageData['DisplayingContactsMessage'] = (['Contact: ',(Number((getObjectProperty(___arguments.context.pageData, 'page')))) * (Number((getObjectProperty(___arguments.context.pageData, 'perPage')))),' | Page: ',(getObjectProperty(___arguments.context.pageData, 'page')),' (',(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8'))[0]), 'LastName')),' To ',(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8')).slice(-1)[0]), 'LastName')),') | Total Pages: ',(getObjectProperty(___arguments.context.pageData, 'totalPages')),' | Total Contacts: ',(getObjectProperty(___arguments.context.pageData, 'totalItems'))].join(''));
    console.log(currentUser);
    ___arguments.context.appData['currentUser'] = currentUser;
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('UserLogin', undefined);
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'page')) == 1) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('eb38a9bcb0711288da0800585d081f5a'))['background-color'] = '#9A91A6';
    return true;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('eb38a9bcb0711288da0800585d081f5a'))['background-color'] = '#0A0A0A';
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/home_backup6-4/components/c38b81a1fde808e224a8dc634857c68a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var currentUser, retrievedContactsRawResponse, ContactsCountReturn, CurrentPageNumber;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['pageCursor'] = ((Number((getObjectProperty(___arguments.context.pageData, 'page')))) + 10);
  if (currentUser != false) {
    retrievedContactsRawResponse = (await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((String('https://mgr.pockethost.io/api/collections/ACCOContacts/records?perPage=25&sort=+LastName,FirstName&page=') + String(JSON.stringify((getObjectProperty(___arguments.context.pageData, 'pageCursor'))))))).set(({ [`Authorization`]: ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOUserToken')) })).setEncoding('utf8').send());
    ___arguments.context.pageData['page'] = (getObjectProperty(retrievedContactsRawResponse, 'page'));
    ___arguments.context.pageData['perPage'] = (getObjectProperty(retrievedContactsRawResponse, 'perPage'));
    ___arguments.context.pageData['totalItems'] = (getObjectProperty(retrievedContactsRawResponse, 'totalItems'));
    ___arguments.context.pageData['totalPages'] = (getObjectProperty(retrievedContactsRawResponse, 'totalPages'));
    console.log('RetrievedContactsRawResponse:');
    console.log(retrievedContactsRawResponse);
    ___arguments.context.pageData['RetrievedContacts'] = (getObjectProperty(retrievedContactsRawResponse, 'items'));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', ({  }));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', (getObjectProperty(___arguments.context.pageData, 'RetrievedContacts')));
    ___arguments.context.pageData['DisplayingContactsMessage'] = (['Contact: ',(Number((getObjectProperty(___arguments.context.pageData, 'page')))) * (Number((getObjectProperty(___arguments.context.pageData, 'perPage')))),' | Page: ',(getObjectProperty(___arguments.context.pageData, 'page')),' (',(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8'))[0]), 'LastName')),' To ',(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8')).slice(-1)[0]), 'LastName')),') | Total Pages: ',(getObjectProperty(___arguments.context.pageData, 'totalPages')),' | Total Contacts: ',(getObjectProperty(___arguments.context.pageData, 'totalItems'))].join(''));
    console.log(currentUser);
    ___arguments.context.appData['currentUser'] = currentUser;
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('UserLogin', undefined);
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'page')) > (Number((getObjectProperty(___arguments.context.pageData, 'totalPages')))) - 10) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c38b81a1fde808e224a8dc634857c68a'))['background-color'] = '#9A91A6';
    return true;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c38b81a1fde808e224a8dc634857c68a'))['background-color'] = '#0A0A0A';
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/home_backup6-4/components/3f18a098cf5807a87b084d784a98910c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var currentUser, retrievedContactsRawResponse, CurrentPageNumber;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  CurrentPageNumber = 0;
  ___arguments.context.pageData['pageCursor'] = (Number((getObjectProperty(___arguments.context.pageData, 'totalPages'))));
  if (currentUser != false) {
    retrievedContactsRawResponse = (await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((String('https://mgr.pockethost.io/api/collections/ACCOContacts/records?perPage=25&sort=+LastName,FirstName&page=') + String(JSON.stringify((getObjectProperty(___arguments.context.pageData, 'pageCursor'))))))).set(({ [`Authorization`]: ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOUserToken')) })).setEncoding('utf8').send());
    ___arguments.context.pageData['page'] = (getObjectProperty(retrievedContactsRawResponse, 'page'));
    ___arguments.context.pageData['perPage'] = (getObjectProperty(retrievedContactsRawResponse, 'perPage'));
    ___arguments.context.pageData['totalItems'] = (getObjectProperty(retrievedContactsRawResponse, 'totalItems'));
    ___arguments.context.pageData['totalPages'] = (getObjectProperty(retrievedContactsRawResponse, 'totalPages'));
    console.log('RetrievedContactsRawResponse:');
    console.log(retrievedContactsRawResponse);
    ___arguments.context.pageData['RetrievedContacts'] = (getObjectProperty(retrievedContactsRawResponse, 'items'));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', ({  }));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', (getObjectProperty(___arguments.context.pageData, 'RetrievedContacts')));
    ___arguments.context.pageData['DisplayingContactsMessage'] = (['Contact: ',(Number((getObjectProperty(___arguments.context.pageData, 'page')))) * (Number((getObjectProperty(___arguments.context.pageData, 'perPage')))),' | Page: ',(getObjectProperty(___arguments.context.pageData, 'page')),' (',(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8'))[0]), 'LastName')),' To ',(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8')).slice(-1)[0]), 'LastName')),') | Total Pages: ',(getObjectProperty(___arguments.context.pageData, 'totalPages')),' | Total Contacts: ',(getObjectProperty(___arguments.context.pageData, 'totalItems'))].join(''));
    console.log(currentUser);
    ___arguments.context.appData['currentUser'] = currentUser;
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('UserLogin', undefined);
  }
  ___arguments.context.pageData['DisplayingContactsMessage'] = (['Contact: ',(Number((getObjectProperty(___arguments.context.pageData, 'page')))) * (Number((getObjectProperty(___arguments.context.pageData, 'perPage')))),' | Page: ',(getObjectProperty(___arguments.context.pageData, 'page')),' (',(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8'))[0]), 'LastName')),' To ',(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8')).slice(-1)[0]), 'LastName')),') | Total Pages: ',(getObjectProperty(___arguments.context.pageData, 'totalPages')),' | Total Contacts: ',(getObjectProperty(___arguments.context.pageData, 'totalItems'))].join(''));

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'page')) == (Number((getObjectProperty(___arguments.context.pageData, 'totalPages'))))) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3f18a098cf5807a87b084d784a98910c'))['background-color'] = '#9A91A6';
    return true;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3f18a098cf5807a87b084d784a98910c'))['background-color'] = '#0A0A0A';
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/home_backup6-4/components/8bf48e763098bc9bd82790dc5238e3c8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(JSON.parse((JSON.stringify(___arguments.context.getComponentDataStoreByUid('5e3f583561b818f8a1786ac80fa77ec8')))));
  console.log(JSON.parse((JSON.stringify((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'drawerDataModel')), 'MiddleName'))))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/home_backup6-4/components/b1d3e8684cdf46a8fe882c58ccf881cb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('#Bottom', false, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/home_backup6-4/components/5b9545ea538797582b284eb9c91349e8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('#Top', false, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/home_backup6-4/components/fbefd2bb6fec4718d6382d38ad733348/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/home_backup6-4/components/92b96158c4d823916c18019a5b28fd83/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'CurrentlySelectedContactData')), 'FirstName'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/home_backup6-4/components/31f864bdf9b8c4982b985e46c2a8175a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'CurrentlySelectedContactData')), 'LastName'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/home_backup6-4/components/6672cef89de766787f2889f880d8b618/bundle.js', [], () => ({
  /* content */
  /* handler:onReadOnlyStateAssignment */
  ['onReadOnlyStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.pageData, 'EditMode')))

  },
  /* handler:onReadOnlyStateAssignment */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6672cef89de766787f2889f880d8b618')), 'value')) == '') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('6672cef89de766787f2889f880d8b618'))['border-color'] = '#AE0530';
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('6672cef89de766787f2889f880d8b618'))['border-color'] = '#0520AE';
  }

  },
  /* handler:onBlur */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'drawerDataModel')), 'FirstName'))

  },
  /* handler:onValueAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Object.assign((getObjectProperty(___arguments.context.pageData, 'drawerDataModel')), ({ [`FirstName`]: ___arguments.value }));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/home_backup6-4/components/af7832b8d436d7bdb868946446a9d5fc/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'drawerDataModel')), 'LastName'))

  },
  /* handler:onValueAssignment */
  /* handler:onReadOnlyStateAssignment */
  ['onReadOnlyStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.pageData, 'EditMode')))

  },
  /* handler:onReadOnlyStateAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Object.assign((getObjectProperty(___arguments.context.pageData, 'drawerDataModel')), ({ [`LastName`]: ___arguments.value }));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/home_backup6-4/components/ac22d7a23f48b4a88ef44e890c58d724/bundle.js', [], () => ({
  /* content */
  /* handler:onReadOnlyStateAssignment */
  ['onReadOnlyStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.pageData, 'EditMode')))

  },
  /* handler:onReadOnlyStateAssignment */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'drawerDataModel')), 'MiddleName'))

  },
  /* handler:onValueAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Object.assign((getObjectProperty(___arguments.context.pageData, 'drawerDataModel')), ({ [`MiddleName`]: ___arguments.value }));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/home_backup6-4/components/c6d8a878da6ee2a81d1818587298aef2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['EditMode'] = true;
  ___arguments.context.pageData['ModifiedData'] = true;
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c6d8a878da6ee2a81d1818587298aef2'))['background-color'] = '#A00000';

  },
  /* handler:onClick */
  /* handler:onDelete */
  ['onDelete'](___arguments) {
      ___arguments.context.pageData['EditMode'] = false;
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c6d8a878da6ee2a81d1818587298aef2'))['background-color'] = '#016288';

  },
  /* handler:onDelete */
  /* content */
}))

define('./pages/home_backup6-4/components/99a8df394f156cc874813c38d937d968/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('99a8df394f156cc874813c38d937d968')), 'color')) != '#03B935') {
    console.log('We need to save this contacts\' details...');
    ___arguments.context.pageData['ContactsModifiedOnPage'] = ((getObjectProperty(___arguments.context.pageData, 'ContactsModifiedOnPage')) - 1);
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('99a8df394f156cc874813c38d937d968'))['color'] = '#03B935';
    await new Promise(r => setTimeout(r, 3000 || 0));
    ___arguments.context.getComponentDataStoreByUid('f548849959d80918247fdbdd7f982de8')['NeedToSave'] = false;
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('99a8df394f156cc874813c38d937d968'))['color'] = '#FF0004';
    console.log('Data to save: ');
    console.log(___arguments.context.getComponentDataStoreByUid('f548849959d80918247fdbdd7f982de8'));
    if ((getObjectProperty(___arguments.context.pageData, 'ContactsModifiedOnPage')) == 0) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ac384c2fae874c589bd87f588a6bdbc8'))['min-height'] = 10;
    }
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var item, listCount;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f548849959d80918247fdbdd7f982de8'), 'NeedToSave')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/home_backup6-4/components/390d1ad861e8a4a817487017ebcec028/bundle.js', [], () => ({
  /* content */
  /* handler:onReadOnlyStateAssignment */
  ['onReadOnlyStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.pageData, 'EditMode')))

  },
  /* handler:onReadOnlyStateAssignment */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'drawerDataModel')), 'Suffix'))

  },
  /* handler:onValueAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Object.assign((getObjectProperty(___arguments.context.pageData, 'drawerDataModel')), ({ [`Suffix`]: ___arguments.value }));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/home_backup6-4/components/60d8097a61c88c0d830a43e79398466a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(JSON.parse((JSON.stringify((getObjectProperty(___arguments.context.pageData, 'drawerDataModel'))))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/home_backup6-4/components/4e289aefe01b9378bf79b7f89fc4a648/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, targetObject, sourceObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6b7b52d718ffad8dfe80198041f4de8', (await asyncListFilter(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b6b7b52d718ffad8dfe80198041f4de8')), async (item) => {
     if ((getObjectProperty(item, 'id')) == (getObjectProperty(___arguments.context.pageData, 'CurrentlySelectedContactID'))) {
      item['NeedToSave'] = true;
      item['FirstName'] = (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6672cef89de766787f2889f880d8b618')), 'value'));
      item['MiddleName'] = (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ac22d7a23f48b4a88ef44e890c58d724')), 'value'));
      item['MiddleName_Modified'] = (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ac22d7a23f48b4a88ef44e890c58d724')), 'value'));
      item['LastName'] = (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('af7832b8d436d7bdb868946446a9d5fc')), 'value'));
      item['Contact_Name'] = ([(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6672cef89de766787f2889f880d8b618')), 'value')),' ',(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('af7832b8d436d7bdb868946446a9d5fc')), 'value'))].join(''));
      return true;
    } else {
      return true;
    }


   return item;
  })));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/home_backup6-4/components/4858b01879e8f3e64732c02ec845eda9/bundle.js', [], () => ({
  /* content */
  /* handler:onReadOnlyStateAssignment */
  ['onReadOnlyStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.pageData, 'EditMode')))

  },
  /* handler:onReadOnlyStateAssignment */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'drawerDataModel')), 'Company'))

  },
  /* handler:onValueAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Object.assign((getObjectProperty(___arguments.context.pageData, 'drawerDataModel')), ({ [`Company`]: ___arguments.value }));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/home_backup6-4/components/4221dcc8d2d947a85538184f6448fe98/bundle.js', [], () => ({
  /* content */
  /* handler:onReadOnlyStateAssignment */
  ['onReadOnlyStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.pageData, 'EditMode')))

  },
  /* handler:onReadOnlyStateAssignment */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'drawerDataModel')), 'JobTitle'))

  },
  /* handler:onValueAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Object.assign((getObjectProperty(___arguments.context.pageData, 'drawerDataModel')), ({ [`JobTitle`]: ___arguments.value }));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/home_backup6-4/components/550713e5e12288185c18386c85a1f806/bundle.js', [], () => ({
  /* content */
  /* handler:onReadOnlyStateAssignment */
  ['onReadOnlyStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.pageData, 'EditMode')))

  },
  /* handler:onReadOnlyStateAssignment */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'drawerDataModel')), 'BusinessStreet'))

  },
  /* handler:onValueAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Object.assign((getObjectProperty(___arguments.context.pageData, 'drawerDataModel')), ({ [`BusinessStreet`]: ___arguments.value }));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/home_backup6-4/components/0f74f9883e8523488538b3f88cfba288/bundle.js', [], () => ({
  /* content */
  /* handler:onReadOnlyStateAssignment */
  ['onReadOnlyStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.pageData, 'EditMode')))

  },
  /* handler:onReadOnlyStateAssignment */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'drawerDataModel')), 'BusinessCity'))

  },
  /* handler:onValueAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Object.assign((getObjectProperty(___arguments.context.pageData, 'drawerDataModel')), ({ [`BusinessCity`]: ___arguments.value }));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/home_backup6-4/components/88c14e78df588d38de180a48b8c1a5a8/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'drawerDataModel')), 'BusinessState'))

  },
  /* handler:onValueAssignment */
  /* handler:onReadOnlyStateAssignment */
  ['onReadOnlyStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.pageData, 'EditMode')))

  },
  /* handler:onReadOnlyStateAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Object.assign((getObjectProperty(___arguments.context.pageData, 'drawerDataModel')), ({ [`BusinessState`]: ___arguments.value }));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/home_backup6-4/components/f9881ba8c9566a99d80d0c464588eb28/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'drawerDataModel')), 'BusinessPostalCode'))

  },
  /* handler:onValueAssignment */
  /* handler:onReadOnlyStateAssignment */
  ['onReadOnlyStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.pageData, 'EditMode')))

  },
  /* handler:onReadOnlyStateAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Object.assign((getObjectProperty(___arguments.context.pageData, 'drawerDataModel')), ({ [`BusinessPostalCode`]: ___arguments.value }));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/home_backup6-4/components/703ecff8b328a55880c89cd846884c37/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'drawerDataModel')), 'EmailAddress'))

  },
  /* handler:onValueAssignment */
  /* handler:onReadOnlyStateAssignment */
  ['onReadOnlyStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.pageData, 'EditMode')))

  },
  /* handler:onReadOnlyStateAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Object.assign((getObjectProperty(___arguments.context.pageData, 'drawerDataModel')), ({ [`EmailAddress`]: ___arguments.value }));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/home_backup6-4/components/818af1d835280ed8b6f531582568ef08/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'drawerDataModel')), 'EmailAddress2'))

  },
  /* handler:onValueAssignment */
  /* handler:onReadOnlyStateAssignment */
  ['onReadOnlyStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.pageData, 'EditMode')))

  },
  /* handler:onReadOnlyStateAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Object.assign((getObjectProperty(___arguments.context.pageData, 'drawerDataModel')), ({ [`EmailAddress2`]: ___arguments.value }));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/home_backup6-4/components/f968043a1ef6440ab3a9e3f84de3ca98/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'drawerDataModel')), 'BusinessPhone'))

  },
  /* handler:onValueAssignment */
  /* handler:onReadOnlyStateAssignment */
  ['onReadOnlyStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.pageData, 'EditMode')))

  },
  /* handler:onReadOnlyStateAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Object.assign((getObjectProperty(___arguments.context.pageData, 'drawerDataModel')), ({ [`BusinessPhone`]: ___arguments.value }));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/home_backup6-4/components/f918db08fea5aaf8f7689b09d9281d0c/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'drawerDataModel')), 'BusinessPhone2'))

  },
  /* handler:onValueAssignment */
  /* handler:onReadOnlyStateAssignment */
  ['onReadOnlyStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.pageData, 'EditMode')))

  },
  /* handler:onReadOnlyStateAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Object.assign((getObjectProperty(___arguments.context.pageData, 'drawerDataModel')), ({ [`BusinessPhone2`]: ___arguments.value }));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/home_backup6-4/components/8798c77db678d7f82cb8e16eeeb8d8d8/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'drawerDataModel')), 'MobilePhone'))

  },
  /* handler:onValueAssignment */
  /* handler:onReadOnlyStateAssignment */
  ['onReadOnlyStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.pageData, 'EditMode')))

  },
  /* handler:onReadOnlyStateAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Object.assign((getObjectProperty(___arguments.context.pageData, 'drawerDataModel')), ({ [`MobilePhone`]: ___arguments.value }));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/home_backup6-4/components/da08f538e9f87698723c23311ed8027a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('Contacts Modified on Page: ') + String(getObjectProperty(___arguments.context.pageData, 'ContactsModifiedOnPage')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/home_backup6-4/components/45e853dd24b7d0d8a374d9359ea9db18/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'AdminEditMode')) != true) {
    ___arguments.context.pageData['AdminEditMode'] = true;
    ___arguments.context.pageData['EditMode'] = true;
    ___arguments.context.pageData['ModifiedData'] = true;
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('45e853dd24b7d0d8a374d9359ea9db18'))['background-color'] = '#A00000';
  } else {
    ___arguments.context.pageData['AdminEditMode'] = false;
    ___arguments.context.pageData['EditMode'] = false;
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('45e853dd24b7d0d8a374d9359ea9db18'))['background-color'] = '#016288';
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/home_backup6-4/components/34e859c84eb8a5d367772312422c5668/bundle.js', [], () => ({
  /* content */
  /* handler:onCheckedStateAssignment */
  ['onCheckedStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'AdminEditMode')) == true) {
    return true;
  }
  if ((getObjectProperty(___arguments.context.pageData, 'EditMode')) == true) {
    return true;
  }

  },
  /* handler:onCheckedStateAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
      if (___arguments.value == false) {
    ___arguments.context.pageData['EditMode'] = false;
  } else {
    ___arguments.context.pageData['EditMode'] = true;
    ___arguments.context.pageData['ModifiedData'] = true;
  }

  },
  /* handler:onChange */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'AdminEditMode')) == true) {
    return true;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/home_backup6-4/components/be99ba0526853a96ade9ec3aa8aa9513/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['ModifiedData'] = true;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/home_backup6-4/components/ac384c2fae874c589bd87f588a6bdbc8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'ContactsModifiedOnPage')) > 0)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/home_backup6-4/components/b148d888c90afcf8617158a32b3cbdc8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'ContactsModifiedOnPage')) > 0) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/home_backup6-4/components/7bbfad1806fdddd83fc49ca857181fbc/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['ContactsModifiedOnPage'] = 0;

  },
  /* handler:onClick */
  /* content */
}))

